function _superPropSet(t, e, o, r, p, f) { return _set(_getPrototypeOf(f ? t.prototype : t), e, o, r, p); }
function set(e, r, t, o) { return set = "undefined" != typeof Reflect && Reflect.set ? Reflect.set : function (e, r, t, o) { var f, i = _superPropBase(e, r); if (i) { if ((f = Object.getOwnPropertyDescriptor(i, r)).set) return f.set.call(o, t), !0; if (!f.writable) return !1; } if (f = Object.getOwnPropertyDescriptor(o, r)) { if (!f.writable) return !1; f.value = t, Object.defineProperty(o, r, f); } else _defineProperty(o, r, t); return !0; }, set(e, r, t, o); }
function _set(e, r, t, o, f) { if (!set(e, r, t, o || e) && f) throw new TypeError("failed to set property"); return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*! DSFR v1.14.1 | SPDX-License-Identifier: MIT | License-Filename: LICENSE.md | restricted use (see terms and conditions) */
var State = /*#__PURE__*/function () {
  function State() {
    _classCallCheck(this, State);
    this.modules = {};
  }
  return _createClass(State, [{
    key: "create",
    value: function create(ModuleClass) {
      var module = new ModuleClass();
      this.modules[module.type] = module;
    }
  }, {
    key: "getModule",
    value: function getModule(type) {
      return this.modules[type];
    }
  }, {
    key: "add",
    value: function add(type, item) {
      this.modules[type].add(item);
    }
  }, {
    key: "remove",
    value: function remove(type, item) {
      this.modules[type].remove(item);
    }
  }, {
    key: "isActive",
    get: function get() {
      return this._isActive;
    },
    set: function set(value) {
      var _this = this;
      if (value === this._isActive) return;
      this._isActive = value;
      var values = Object.keys(this.modules).map(function (e) {
        return _this.modules[e];
      });
      if (value) {
        var _iterator = _createForOfIteratorHelper(values),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var module = _step.value;
            module.activate();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        var _iterator2 = _createForOfIteratorHelper(values),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _module = _step2.value;
            _module.deactivate();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "isLegacy",
    get: function get() {
      return this._isLegacy;
    },
    set: function set(value) {
      if (value === this._isLegacy) return;
      this._isLegacy = value;
    }
  }]);
}();
var _state = new State();
var config = {
  prefix: 'fr',
  namespace: 'dsfr',
  organisation: '@gouvfr',
  version: '1.14.1'
};
var LogLevel = /*#__PURE__*/function () {
  function LogLevel(level, light, dark, logger) {
    _classCallCheck(this, LogLevel);
    this.level = level;
    this.light = light;
    this.dark = dark;
    switch (logger) {
      case 'warn':
        this.logger = console.warn;
        break;
      case 'error':
        this.logger = console.error;
        break;
      default:
        this.logger = console.log;
    }
  }
  return _createClass(LogLevel, [{
    key: "log",
    value: function log() {
      var message = new Message(config.namespace);
      for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
        values[_key] = arguments[_key];
      }
      for (var _i = 0, _values = values; _i < _values.length; _i++) {
        var value = _values[_i];
        message.add(value);
      }
      this.print(message);
    }
  }, {
    key: "print",
    value: function print(message) {
      message.setColor(this.color);
      this.logger.apply(console, message.getMessage());
    }
  }, {
    key: "color",
    get: function get() {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? this.dark : this.light;
    }
  }]);
}();
var Message = /*#__PURE__*/function () {
  function Message(domain) {
    _classCallCheck(this, Message);
    this.inputs = ['%c'];
    this.styles = ['font-family:Marianne', 'line-height: 1.5'];
    this.objects = [];
    if (domain) this.add("".concat(domain, " :"));
  }
  return _createClass(Message, [{
    key: "add",
    value: function add(value) {
      switch (_typeof(value)) {
        case 'object':
        case 'function':
          this.inputs.push('%o ');
          this.objects.push(value);
          break;
        default:
          this.inputs.push("".concat(value, " "));
      }
    }
  }, {
    key: "setColor",
    value: function setColor(color) {
      this.styles.push("color:".concat(color));
    }
  }, {
    key: "getMessage",
    value: function getMessage() {
      return [this.inputs.join(''), this.styles.join(';')].concat(_toConsumableArray(this.objects));
    }
  }]);
}();
var LEVELS = {
  log: new LogLevel(0, '#616161', '#989898'),
  debug: new LogLevel(1, '#000091', '#8B8BFF'),
  info: new LogLevel(2, '#007c3b', '#00ed70'),
  warn: new LogLevel(3, '#ba4500', '#fa5c00', 'warn'),
  error: new LogLevel(4, '#D80600', '#FF4641', 'error')
};
var Inspector = /*#__PURE__*/function () {
  function Inspector() {
    var _this2 = this;
    _classCallCheck(this, Inspector);
    this.level = 2;
    var _loop = function _loop() {
      var level = LEVELS[id];
      _this2[id] = function () {
        for (var _len2 = arguments.length, msgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          msgs[_key2] = arguments[_key2];
        }
        if (_this2.level <= level.level) level.log.apply(level, msgs);
      };
      _this2[id].print = level.print.bind(level);
    };
    for (var id in LEVELS) {
      _loop();
    }
  }
  return _createClass(Inspector, [{
    key: "state",
    value: function state() {
      var message = new Message();
      message.add(_state);
      this.log.print(message);
    }
  }, {
    key: "tree",
    value: function tree() {
      var stage = _state.getModule('stage');
      if (!stage) return;
      var message = new Message();
      this._branch(stage.root, 0, message);
      this.log.print(message);
    }
  }, {
    key: "_branch",
    value: function _branch(element, space, message) {
      var branch = '';
      if (space > 0) {
        var indent = '';
        for (var i = 0; i < space; i++) indent += '    ';
        // branch += indent + '|\n';
        branch += indent + '└─ ';
      }
      branch += "[".concat(element.id, "] ").concat(element.html);
      message.add(branch);
      message.add({
        '@': element
      });
      message.add('\n');
      var _iterator3 = _createForOfIteratorHelper(element.children),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var child = _step3.value;
          branch += this._branch(child, space + 1, message);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }]);
}();
var inspector = new Inspector();
var startAtDomContentLoaded = function startAtDomContentLoaded(callback) {
  if (document.readyState !== 'loading') window.requestAnimationFrame(callback);else document.addEventListener('DOMContentLoaded', callback);
};
var startAuto = function startAuto(callback) {
  // detect
  startAtDomContentLoaded(callback);
};
var Modes = {
  AUTO: 'auto',
  MANUAL: 'manual',
  RUNTIME: 'runtime',
  LOADED: 'loaded',
  VUE: 'vue',
  ANGULAR: 'angular',
  REACT: 'react'
};
var _dispatch = function dispatch(node, type) {
  var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var bubbles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var cancelable = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var options = {
    bubbles: bubbles === true,
    cancelable: cancelable === true
  };
  if (detail) options.detail = detail;
  var event = new CustomEvent(type, options);
  node.dispatchEvent(event);
};
var rootDispatch = function rootDispatch(type) {
  var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var bubbles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var cancelable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return _dispatch(document.documentElement, type, detail, bubbles, cancelable);
};
var ns = function ns(name) {
  return "".concat(config.prefix, "-").concat(name);
};
ns.selector = function (name, notation) {
  if (notation === undefined) notation = '.';
  return "".concat(notation).concat(ns(name));
};
ns.attr = function (name) {
  return "data-".concat(ns(name));
};
ns.attr.selector = function (name, value) {
  var result = ns.attr(name);
  if (value !== undefined) result += "=\"".concat(value, "\"");
  return "[".concat(result, "]");
};
ns.event = function (type) {
  return "".concat(config.namespace, ".").concat(type);
};
ns.emission = function (domain, type) {
  return "emission:".concat(domain, ".").concat(type);
};
var RootEvent = {
  READY: ns.event('ready'),
  START: ns.event('start'),
  STOP: ns.event('stop'),
  RENDER: ns.event('render'),
  RESIZE: ns.event('resize'),
  BREAKPOINT: ns.event('breakpoint'),
  SCROLL_LOCK: ns.event('scroll-lock'),
  SCROLL_UNLOCK: ns.event('scroll-unlock')
};
var Options = /*#__PURE__*/function () {
  function Options() {
    _classCallCheck(this, Options);
    this._mode = Modes.AUTO;
    this.isStarted = false;
    this.starting = this.start.bind(this);
    this.preventManipulation = false;
  }
  return _createClass(Options, [{
    key: "configure",
    value: function configure() {
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var start = arguments.length > 1 ? arguments[1] : undefined;
      var query = arguments.length > 2 ? arguments[2] : undefined;
      this.startCallback = start;
      var isProduction = settings.production && (!query || query.production !== 'false');
      switch (true) {
        case query && !isNaN(query.level):
          inspector.level = Number(query.level);
          break;
        case query && query.verbose && (query.verbose === 'true' || query.verbose === 1):
          inspector.level = 0;
          break;
        case isProduction:
          inspector.level = 999;
          break;
        case settings.verbose:
          inspector.level = 0;
          break;
      }
      inspector.info("version ".concat(config.version));
      rootDispatch(RootEvent.READY);
      this.mode = settings.mode || Modes.AUTO;
    }
  }, {
    key: "mode",
    get: function get() {
      return this._mode;
    },
    set: function set(value) {
      switch (value) {
        case Modes.AUTO:
          this.preventManipulation = false;
          startAuto(this.starting);
          break;
        case Modes.LOADED:
          this.preventManipulation = false;
          startAtDomContentLoaded(this.starting);
          break;
        case Modes.RUNTIME:
          this.preventManipulation = false;
          this.start();
          break;
        case Modes.MANUAL:
          this.preventManipulation = false;
          break;
        case Modes.VUE:
          this.preventManipulation = true;
          break;
        case Modes.ANGULAR:
          this.preventManipulation = true;
          break;
        case Modes.REACT:
          this.preventManipulation = true;
          break;
        default:
          inspector.error('Illegal mode');
          return;
      }
      this._mode = value;
      inspector.info("mode set to ".concat(value));
    }
  }, {
    key: "start",
    value: function start() {
      inspector.info('start');
      this.startCallback();
    }
  }]);
}();
var options = new Options();
var Collection = /*#__PURE__*/function () {
  function Collection() {
    _classCallCheck(this, Collection);
    this._collection = [];
  }
  return _createClass(Collection, [{
    key: "forEach",
    value: function forEach(callback) {
      this._collection.forEach(callback);
    }
  }, {
    key: "map",
    value: function map(callback) {
      return this._collection.map(callback);
    }
  }, {
    key: "length",
    get: function get() {
      return this._collection.length;
    }
  }, {
    key: "add",
    value: function add(collectable) {
      if (this._collection.indexOf(collectable) > -1) return false;
      this._collection.push(collectable);
      if (this.onAdd) this.onAdd();
      if (this.onPopulate && this._collection.length === 1) this.onPopulate();
      return true;
    }
  }, {
    key: "remove",
    value: function remove(collectable) {
      var index = this._collection.indexOf(collectable);
      if (index === -1) return false;
      this._collection.splice(index, 1);
      if (this.onRemove) this.onRemove();
      if (this.onEmpty && this._collection.length === 0) this.onEmpty();
    }
  }, {
    key: "execute",
    value: function execute() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      var _iterator4 = _createForOfIteratorHelper(this._collection),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var collectable = _step4.value;
          if (collectable) collectable.apply(null, args);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this._collection.length = 0;
    }
  }, {
    key: "clone",
    value: function clone() {
      var clone = new Collection();
      clone._collection = this._collection.slice();
      return clone;
    }
  }, {
    key: "collection",
    get: function get() {
      return this._collection;
    }
  }]);
}();
var Module = /*#__PURE__*/function (_Collection) {
  function Module(type) {
    var _this3;
    _classCallCheck(this, Module);
    _this3 = _callSuper(this, Module);
    _this3.type = type;
    _this3.isActive = false;
    return _this3;
  }
  _inherits(Module, _Collection);
  return _createClass(Module, [{
    key: "activate",
    value: function activate() {}
  }, {
    key: "deactivate",
    value: function deactivate() {}
  }]);
}(Collection);
var querySelectorAllArray = function querySelectorAllArray(element, selectors) {
  return Array.prototype.slice.call(element.querySelectorAll(selectors));
};
var _queryParentSelector = function queryParentSelector(element, selectors) {
  var parent = element.parentElement;
  if (parent.matches(selectors)) return parent;
  if (parent === document.documentElement) return null;
  return _queryParentSelector(parent, selectors);
};
var Registration = /*#__PURE__*/function () {
  function Registration(selector, InstanceClass, creator) {
    _classCallCheck(this, Registration);
    this.selector = selector;
    this.InstanceClass = InstanceClass;
    this.creator = creator;
    this.instances = new Collection();
    this.isIntroduced = false;
    this._instanceClassName = this.InstanceClass.instanceClassName;
    this._instanceClassNames = this.getInstanceClassNames(this.InstanceClass);
    this._property = this._instanceClassName.substring(0, 1).toLowerCase() + this._instanceClassName.substring(1);
    var dashed = this._instanceClassName.replace(/[^a-zA-Z0-9]+/g, '-').replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2').replace(/([a-z])([A-Z])/g, '$1-$2').replace(/([0-9])([^0-9])/g, '$1-$2').replace(/([^0-9])([0-9])/g, '$1-$2').toLowerCase();
    this._attribute = ns.attr("js-".concat(dashed));
  }
  return _createClass(Registration, [{
    key: "getInstanceClassNames",
    value: function getInstanceClassNames(InstanceClass) {
      var prototype = Object.getPrototypeOf(InstanceClass);
      if (!prototype || prototype.instanceClassName === 'Instance') return [InstanceClass.instanceClassName];
      return [].concat(_toConsumableArray(this.getInstanceClassNames(prototype)), [InstanceClass.instanceClassName]);
    }
  }, {
    key: "hasInstanceClassName",
    value: function hasInstanceClassName(instanceClassName) {
      return this._instanceClassNames.indexOf(instanceClassName) > -1;
    }
  }, {
    key: "introduce",
    value: function introduce() {
      if (this.isIntroduced) return;
      this.isIntroduced = true;
      _state.getModule('stage').parse(document.documentElement, this);
    }
  }, {
    key: "parse",
    value: function parse(node, nonRecursive) {
      var nodes = [];
      if (node.matches && node.matches(this.selector)) nodes.push(node);
      // eslint-disable-next-line no-useless-call
      if (!nonRecursive && node.querySelectorAll && node.querySelector(this.selector)) nodes.push.apply(nodes, querySelectorAllArray(node, this.selector));
      return nodes;
    }
  }, {
    key: "create",
    value: function create(element) {
      if (!element.node.matches(this.selector)) return;
      var instance = new this.InstanceClass();
      this.instances.add(instance);
      return instance;
    }
  }, {
    key: "remove",
    value: function remove(instance) {
      this.instances.remove(instance);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var instances = this.instances.collection;
      for (var i = instances.length - 1; i > -1; i--) instances[i]._dispose();
      this.creator = null;
    }
  }, {
    key: "instanceClassName",
    get: function get() {
      return this._instanceClassName;
    }
  }, {
    key: "instanceClassNames",
    get: function get() {
      return this._instanceClassNames;
    }
  }, {
    key: "property",
    get: function get() {
      return this._property;
    }
  }, {
    key: "attribute",
    get: function get() {
      return this._attribute;
    }
  }]);
}();
var Register = /*#__PURE__*/function (_Module) {
  function Register() {
    _classCallCheck(this, Register);
    return _callSuper(this, Register, ['register']);
  }
  _inherits(Register, _Module);
  return _createClass(Register, [{
    key: "register",
    value: function register(selector, InstanceClass, creator) {
      var registration = new Registration(selector, InstanceClass, creator);
      this.add(registration);
      if (_state.isActive) registration.introduce();
      return registration;
    }
  }, {
    key: "activate",
    value: function activate() {
      var _iterator5 = _createForOfIteratorHelper(this.collection),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var registration = _step5.value;
          registration.introduce();
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "remove",
    value: function remove(registration) {
      registration.dispose();
      _superPropGet(Register, "remove", this, 3)([registration]);
    }
  }]);
}(Module);
var count = 0;
var Element$1 = /*#__PURE__*/function () {
  function Element$1(node, id) {
    _classCallCheck(this, Element$1);
    if (!id) {
      count++;
      this.id = count;
    } else this.id = id;
    this.node = node;
    this.attributeNames = [];
    this.instances = [];
    this._children = [];
    this._parent = null;
    this._projects = [];
  }
  return _createClass(Element$1, [{
    key: "proxy",
    get: function get() {
      var scope = this;
      if (!this._proxy) {
        this._proxy = {
          id: this.id,
          get parent() {
            return scope.parent ? scope.parent.proxy : null;
          },
          get children() {
            return scope.children.map(function (child) {
              return child.proxy;
            });
          }
        };
        var _iterator6 = _createForOfIteratorHelper(this.instances),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var instance = _step6.value;
            this._proxy[instance.registration.property] = instance.proxy;
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
      return this._proxy;
    }
  }, {
    key: "html",
    get: function get() {
      if (!this.node || !this.node.outerHTML) return '';
      var end = this.node.outerHTML.indexOf('>');
      return this.node.outerHTML.substring(0, end + 1);
    }
  }, {
    key: "project",
    value: function project(registration) {
      if (this._projects.indexOf(registration) === -1) this._projects.push(registration);
    }
  }, {
    key: "populate",
    value: function populate() {
      var projects = this._projects.slice();
      this._projects.length = 0;
      var _iterator7 = _createForOfIteratorHelper(projects),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var registration = _step7.value;
          this.create(registration);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "create",
    value: function create(registration) {
      if (this.hasInstance(registration.instanceClassName)) {
        // inspector.debug(`failed creation, instance of ${registration.instanceClassName} already exists on element [${this.id}]`);
        return;
      }
      inspector.debug("create instance of ".concat(registration.instanceClassName, " on element [").concat(this.id, "]"));
      var instance = registration.create(this);
      this.instances.push(instance);
      instance._config(this, registration);
      if (this._proxy) this._proxy[registration.property] = instance.proxy;
    }
  }, {
    key: "remove",
    value: function remove(instance) {
      var index = this.instances.indexOf(instance);
      if (index > -1) this.instances.splice(index, 1);
      if (this._proxy) delete this._proxy[instance.registration.property];
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent;
    }
  }, {
    key: "ascendants",
    get: function get() {
      return [this.parent].concat(_toConsumableArray(this.parent.ascendants));
    }
  }, {
    key: "children",
    get: function get() {
      return this._children;
    }
  }, {
    key: "descendants",
    get: function get() {
      var descendants = _toConsumableArray(this._children);
      this._children.forEach(function (child) {
        return descendants.push.apply(descendants, _toConsumableArray(child.descendants));
      });
      return descendants;
    }

    // TODO : emit ascendant et descendant de changement ?
  }, {
    key: "addChild",
    value: function addChild(child, index) {
      if (this._children.indexOf(child) > -1) return null;
      child._parent = this;
      if (!isNaN(index) && index > -1 && index < this._children.length) this._children.splice(index, 0, child);else this._children.push(child);
      return child;
    }
  }, {
    key: "removeChild",
    value: function removeChild(child) {
      var index = this._children.indexOf(child);
      if (index === -1) return null;
      child._parent = null;
      this._children.splice(index, 1);
    }
  }, {
    key: "emit",
    value: function emit(type, data) {
      var elements = _state.getModule('stage').collection;
      var response = [];
      var _iterator8 = _createForOfIteratorHelper(elements),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var element = _step8.value;
          response.push.apply(response, _toConsumableArray(element._emit(type, data)));
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      return response;
    }
  }, {
    key: "_emit",
    value: function _emit(type, data) {
      var response = [];
      var _iterator9 = _createForOfIteratorHelper(this.instances),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var instance = _step9.value;
          response.push.apply(response, _toConsumableArray(instance._emitter.emit(type, data)));
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      return response;
    }
  }, {
    key: "ascend",
    value: function ascend(type, data) {
      if (this._parent) return this._parent._ascend(type, data);
      return [];
    }
  }, {
    key: "_ascend",
    value: function _ascend(type, data) {
      var response = [];
      var _iterator0 = _createForOfIteratorHelper(this.instances),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var instance = _step0.value;
          response.push.apply(response, _toConsumableArray(instance._ascent.emit(type, data)));
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
      if (this._parent) response.push.apply(response, _toConsumableArray(this._parent._ascend(type, data)));
      return response;
    }
  }, {
    key: "descend",
    value: function descend(type, data) {
      var response = [];
      var _iterator1 = _createForOfIteratorHelper(this._children),
        _step1;
      try {
        for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
          var child = _step1.value;
          response.push.apply(response, _toConsumableArray(child._descend(type, data)));
        }
      } catch (err) {
        _iterator1.e(err);
      } finally {
        _iterator1.f();
      }
      return response;
    }
  }, {
    key: "_descend",
    value: function _descend(type, data) {
      var response = [];
      var _iterator10 = _createForOfIteratorHelper(this.instances),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var instance = _step10.value;
          response.push.apply(response, _toConsumableArray(instance._descent.emit(type, data)));
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      var _iterator11 = _createForOfIteratorHelper(this._children),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var child = _step11.value;
          response.push.apply(response, _toConsumableArray(child._descend(type, data)));
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      return response;
    }
  }, {
    key: "getInstance",
    value: function getInstance(instanceClassName) {
      var _iterator12 = _createForOfIteratorHelper(this.instances),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var instance = _step12.value;
          if (instance.registration.hasInstanceClassName(instanceClassName)) return instance;
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      return null;
    }
  }, {
    key: "hasInstance",
    value: function hasInstance(instanceClassName) {
      return this.getInstance(instanceClassName) !== null;
    }
  }, {
    key: "getDescendantInstances",
    value: function getDescendantInstances(instanceClassName, stopAtInstanceClassName, stopAtFirstInstance) {
      if (!instanceClassName) return [];
      var instances = [];
      var _iterator13 = _createForOfIteratorHelper(this._children),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var child = _step13.value;
          var instance = child.getInstance(instanceClassName);
          if (instance) {
            instances.push(instance);
            if (stopAtFirstInstance) continue;
          }
          if ((!stopAtInstanceClassName || !child.hasInstance(stopAtInstanceClassName)) && child.children.length) instances.push.apply(instances, child.getDescendantInstances(instanceClassName, stopAtInstanceClassName, stopAtFirstInstance));
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      return instances;
    }
  }, {
    key: "getAscendantInstance",
    value: function getAscendantInstance(instanceClassName, stopAtInstanceClassName) {
      if (!instanceClassName || !this._parent) return null;
      var instance = this._parent.getInstance(instanceClassName);
      if (instance) return instance;
      if (stopAtInstanceClassName && this._parent.hasInstance(stopAtInstanceClassName)) return null;
      return this._parent.getAscendantInstance(instanceClassName, stopAtInstanceClassName);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      for (var i = this.instances.length - 1; i >= 0; i--) {
        var instance = this.instances[i];
        if (instance) instance._dispose();
      }
      this.instances.length = 0;
      _state.remove('stage', this);
      this.parent.removeChild(this);
      this._children.length = 0;
      inspector.debug("remove element [".concat(this.id, "] ").concat(this.html));
    }
  }, {
    key: "prepare",
    value: function prepare(attributeName) {
      if (this.attributeNames.indexOf(attributeName) === -1) this.attributeNames.push(attributeName);
    }
  }, {
    key: "examine",
    value: function examine() {
      var attributeNames = this.attributeNames.slice();
      this.attributeNames.length = 0;
      for (var i = this.instances.length - 1; i > -1; i--) this.instances[i].examine(attributeNames);
    }
  }]);
}();
var RootEmission = {
  CLICK: ns.emission('root', 'click'),
  KEYDOWN: ns.emission('root', 'keydown'),
  KEYUP: ns.emission('root', 'keyup')
};
var KeyCodes = {
  TAB: {
    id: 'tab',
    value: 9
  },
  ESCAPE: {
    id: 'escape',
    value: 27
  },
  END: {
    id: 'end',
    value: 35
  },
  HOME: {
    id: 'home',
    value: 36
  },
  LEFT: {
    id: 'left',
    value: 37
  },
  UP: {
    id: 'up',
    value: 38
  },
  RIGHT: {
    id: 'right',
    value: 39
  },
  DOWN: {
    id: 'down',
    value: 40
  }
};
var getKeyCode = function getKeyCode(keyCode) {
  return Object.values(KeyCodes).filter(function (entry) {
    return entry.value === keyCode;
  })[0];
};
var Root = /*#__PURE__*/function (_Element$) {
  function Root() {
    var _this4;
    _classCallCheck(this, Root);
    _this4 = _callSuper(this, Root, [document.documentElement, 'root']);
    _this4.node.setAttribute(ns.attr('js'), true);
    _this4.listen();
    return _this4;
  }
  _inherits(Root, _Element$);
  return _createClass(Root, [{
    key: "listen",
    value: function listen() {
      // TODO v2 => listener au niveau des éléments qui redistribuent aux instances.
      document.documentElement.addEventListener('click', this.click.bind(this), {
        capture: true
      });
      document.documentElement.addEventListener('keydown', this.keydown.bind(this), {
        capture: true
      });
      document.documentElement.addEventListener('keyup', this.keyup.bind(this), {
        capture: true
      });
    }
  }, {
    key: "click",
    value: function click(e) {
      this.emit(RootEmission.CLICK, e.target);
    }
  }, {
    key: "keydown",
    value: function keydown(e) {
      this.emit(RootEmission.KEYDOWN, getKeyCode(e.keyCode));
    }
  }, {
    key: "keyup",
    value: function keyup(e) {
      this.emit(RootEmission.KEYUP, getKeyCode(e.keyCode));
    }
  }]);
}(Element$1);
var Stage = /*#__PURE__*/function (_Module2) {
  function Stage() {
    var _this5;
    _classCallCheck(this, Stage);
    _this5 = _callSuper(this, Stage, ['stage']);
    _this5.root = new Root();
    _superPropGet((_this5, Stage), "add", _this5, 3)([_this5.root]);
    _this5.observer = new MutationObserver(_this5.mutate.bind(_this5));
    _this5.modifications = [];
    _this5.willModify = false;
    _this5.modifying = _this5.modify.bind(_this5);
    return _this5;
  }
  _inherits(Stage, _Module2);
  return _createClass(Stage, [{
    key: "hasElement",
    value: function hasElement(node) {
      var _iterator14 = _createForOfIteratorHelper(this.collection),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var element = _step14.value;
          if (element.node === node) return true;
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
      return false;
    }
  }, {
    key: "getElement",
    value: function getElement(node) {
      var _iterator15 = _createForOfIteratorHelper(this.collection),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var _element = _step15.value;
          if (_element.node === node) return _element;
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
      var element = new Element$1(node);
      this.add(element);
      inspector.debug("add element [".concat(element.id, "] ").concat(element.html));
      return element;
    }
  }, {
    key: "getProxy",
    value: function getProxy(node) {
      if (!this.hasElement(node)) return null;
      var element = this.getElement(node);
      return element.proxy;
    }
  }, {
    key: "add",
    value: function add(element) {
      _superPropGet(Stage, "add", this, 3)([element]);
      this.put(element, this.root);
    }
  }, {
    key: "put",
    value: function put(element, branch) {
      var index = 0;
      for (var i = branch.children.length - 1; i > -1; i--) {
        var child = branch.children[i];
        var position = element.node.compareDocumentPosition(child.node);
        if (position & Node.DOCUMENT_POSITION_CONTAINS) {
          this.put(element, child);
          return;
        } else if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
          branch.removeChild(child);
          element.addChild(child, 0);
        } else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
          index = i + 1;
          break;
        }
      }
      branch.addChild(element, index);
    }
  }, {
    key: "activate",
    value: function activate() {
      this.observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true
      });
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      this.observer.disconnect();
    }
  }, {
    key: "mutate",
    value: function mutate(mutations) {
      var _this6 = this;
      var examinations = [];
      mutations.forEach(function (mutation) {
        switch (mutation.type) {
          case 'childList':
            mutation.removedNodes.forEach(function (node) {
              return _this6.dispose(node);
            });
            mutation.addedNodes.forEach(function (node) {
              return _this6.parse(node);
            });
            break;
          case 'attributes':
            if (_this6.hasElement(mutation.target)) {
              var element = _this6.getElement(mutation.target);
              element.prepare(mutation.attributeName);
              if (examinations.indexOf(element) === -1) examinations.push(element);
              var _iterator16 = _createForOfIteratorHelper(element.descendants),
                _step16;
              try {
                for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                  var descendant = _step16.value;
                  if (examinations.indexOf(descendant) === -1) examinations.push(descendant);
                }
              } catch (err) {
                _iterator16.e(err);
              } finally {
                _iterator16.f();
              }
            }
            if (_this6.modifications.indexOf(mutation.target) === -1) _this6.modifications.push(mutation.target);
            break;
        }
      });
      examinations.forEach(function (element) {
        return element.examine();
      });
      if (this.modifications.length && !this.willModify) {
        this.willModify = true;
        window.requestAnimationFrame(this.modifying);
      }
    }
  }, {
    key: "modify",
    value: function modify() {
      this.willModify = false;
      var targets = this.modifications.slice();
      this.modifications.length = 0;
      var _iterator17 = _createForOfIteratorHelper(targets),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var target = _step17.value;
          if (document.documentElement.contains(target)) this.parse(target);
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
    }
  }, {
    key: "dispose",
    value: function dispose(node) {
      var disposables = [];
      this.forEach(function (element) {
        if (node.contains(element.node)) disposables.push(element);
      });
      for (var _i2 = 0, _disposables = disposables; _i2 < _disposables.length; _i2++) {
        var disposable = _disposables[_i2];
        disposable.dispose();
        this.remove(disposable);
      }
    }
  }, {
    key: "parse",
    value: function parse(node, registration, nonRecursive) {
      var registrations = registration ? [registration] : _state.getModule('register').collection;
      var creations = [];
      var _iterator18 = _createForOfIteratorHelper(registrations),
        _step18;
      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var _registration = _step18.value;
          var nodes = _registration.parse(node, nonRecursive);
          var _iterator19 = _createForOfIteratorHelper(nodes),
            _step19;
          try {
            for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
              var n = _step19.value;
              var _element2 = this.getElement(n);
              _element2.project(_registration);
              if (creations.indexOf(_element2) === -1) creations.push(_element2);
            }
          } catch (err) {
            _iterator19.e(err);
          } finally {
            _iterator19.f();
          }
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
      for (var _i3 = 0, _creations = creations; _i3 < _creations.length; _i3++) {
        var element = _creations[_i3];
        element.populate();
      }
    }
  }]);
}(Module);
var Renderer = /*#__PURE__*/function (_Module3) {
  function Renderer() {
    var _this7;
    _classCallCheck(this, Renderer);
    _this7 = _callSuper(this, Renderer, ['render']);
    _this7.rendering = _this7.render.bind(_this7);
    _this7.nexts = new Collection();
    return _this7;
  }
  _inherits(Renderer, _Module3);
  return _createClass(Renderer, [{
    key: "activate",
    value: function activate() {
      window.requestAnimationFrame(this.rendering);
    }
  }, {
    key: "request",
    value: function request(instance) {
      this.nexts.add(instance);
    }
  }, {
    key: "render",
    value: function render() {
      if (!_state.isActive) return;
      window.requestAnimationFrame(this.rendering);
      this.forEach(function (instance) {
        return instance.render();
      });
      if (!this.nexts.length) return;
      var nexts = this.nexts.clone();
      this.nexts.clear();
      nexts.forEach(function (instance) {
        return instance.next();
      });
      rootDispatch(RootEvent.RENDER);
    }
  }]);
}(Module);
var Resizer = /*#__PURE__*/function (_Module4) {
  function Resizer() {
    var _this8;
    _classCallCheck(this, Resizer);
    _this8 = _callSuper(this, Resizer, ['resize']);
    _this8.requireResize = false;
    _this8.resizing = _this8.resize.bind(_this8);
    var requesting = _this8.request.bind(_this8);
    if (document.fonts) {
      document.fonts.ready.then(requesting);
    }
    window.addEventListener('resize', requesting);
    window.addEventListener('orientationchange', requesting);
    return _this8;
  }
  _inherits(Resizer, _Module4);
  return _createClass(Resizer, [{
    key: "activate",
    value: function activate() {
      this.request();
    }
  }, {
    key: "request",
    value: function request() {
      if (this.requireResize) return;
      this.requireResize = true;
      window.requestAnimationFrame(this.resizing);
    }
  }, {
    key: "resize",
    value: function resize() {
      if (!this.requireResize) return;
      this.forEach(function (instance) {
        return instance.resize();
      });
      this.requireResize = false;
      rootDispatch(RootEvent.RESIZE);
    }
  }]);
}(Module);
var ScrollLocker = /*#__PURE__*/function (_Module5) {
  function ScrollLocker() {
    var _this9;
    _classCallCheck(this, ScrollLocker);
    _this9 = _callSuper(this, ScrollLocker, ['lock']);
    _this9._isLocked = false;
    _this9._scrollY = 0;
    _this9.onPopulate = _this9.lock.bind(_this9);
    _this9.onEmpty = _this9.unlock.bind(_this9);
    return _this9;
  }
  _inherits(ScrollLocker, _Module5);
  return _createClass(ScrollLocker, [{
    key: "isLocked",
    get: function get() {
      return this._isLocked;
    }
  }, {
    key: "lock",
    value: function lock() {
      if (!this._isLocked) {
        this._isLocked = true;
        this._scrollY = window.scrollY;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.setAttribute(ns.attr('scrolling'), 'false');
        document.body.style.top = "".concat(-this._scrollY, "px");
        this.behavior = getComputedStyle(document.documentElement).getPropertyValue('scroll-behavior');
        if (this.behavior === 'smooth') document.documentElement.style.scrollBehavior = 'auto';
        if (scrollBarGap > 0) {
          document.documentElement.style.setProperty('--scrollbar-width', "".concat(scrollBarGap, "px"));
        }
        rootDispatch(RootEvent.SCROLL_LOCK);
      }
    }
  }, {
    key: "unlock",
    value: function unlock() {
      if (this._isLocked) {
        this._isLocked = false;
        document.documentElement.removeAttribute(ns.attr('scrolling'));
        document.body.style.top = '';
        window.scrollTo(0, this._scrollY);
        if (this.behavior === 'smooth') document.documentElement.style.removeProperty('scroll-behavior');
        document.documentElement.style.removeProperty('--scrollbar-width');
        rootDispatch(RootEvent.SCROLL_UNLOCK);
      }
    }
  }, {
    key: "move",
    value: function move(value) {
      if (this._isLocked) {
        this._scrollY += value;
        document.body.style.top = "".concat(-this._scrollY, "px");
      } else {
        window.scrollTo(0, window.scrollY + value);
      }
    }
  }]);
}(Module);
var Load = /*#__PURE__*/function (_Module6) {
  function Load() {
    var _this0;
    _classCallCheck(this, Load);
    _this0 = _callSuper(this, Load, ['load']);
    _this0.loading = _this0.load.bind(_this0);
    return _this0;
  }
  _inherits(Load, _Module6);
  return _createClass(Load, [{
    key: "activate",
    value: function activate() {
      window.addEventListener('load', this.loading);
    }
  }, {
    key: "load",
    value: function load() {
      this.forEach(function (instance) {
        return instance.load();
      });
    }
  }]);
}(Module);
var FONT_FAMILIES = ['Marianne', 'Spectral'];
var FontSwap = /*#__PURE__*/function (_Module7) {
  function FontSwap() {
    var _this1;
    _classCallCheck(this, FontSwap);
    _this1 = _callSuper(this, FontSwap, ['font-swap']);
    _this1.swapping = _this1.swap.bind(_this1);
    return _this1;
  }
  _inherits(FontSwap, _Module7);
  return _createClass(FontSwap, [{
    key: "activate",
    value: function activate() {
      if (document.fonts) {
        document.fonts.addEventListener('loadingdone', this.swapping);
      }
    }
  }, {
    key: "swap",
    value: function swap() {
      var families = FONT_FAMILIES.filter(function (family) {
        return document.fonts.check("16px ".concat(family));
      });
      this.forEach(function (instance) {
        return instance.swapFont(families);
      });
    }
  }]);
}(Module);
var MouseMove = /*#__PURE__*/function (_Module8) {
  function MouseMove() {
    var _this10;
    _classCallCheck(this, MouseMove);
    _this10 = _callSuper(this, MouseMove, ['mouse-move']);
    _this10.requireMove = false;
    _this10._isMoving = false;
    _this10.moving = _this10.move.bind(_this10);
    _this10.requesting = _this10.request.bind(_this10);
    _this10.onPopulate = _this10.listen.bind(_this10);
    _this10.onEmpty = _this10.unlisten.bind(_this10);
    return _this10;
  }
  _inherits(MouseMove, _Module8);
  return _createClass(MouseMove, [{
    key: "listen",
    value: function listen() {
      if (this._isMoving) return;
      this._isMoving = true;
      this.requireMove = false;
      document.documentElement.addEventListener('mousemove', this.requesting);
    }
  }, {
    key: "unlisten",
    value: function unlisten() {
      if (!this._isMoving) return;
      this._isMoving = false;
      this.requireMove = false;
      document.documentElement.removeEventListener('mousemove', this.requesting);
    }
  }, {
    key: "request",
    value: function request(e) {
      if (!this._isMoving) return;
      this.point = {
        x: e.clientX,
        y: e.clientY
      };
      if (this.requireMove) return;
      this.requireMove = true;
      window.requestAnimationFrame(this.moving);
    }
  }, {
    key: "move",
    value: function move() {
      var _this11 = this;
      if (!this.requireMove) return;
      this.forEach(function (instance) {
        return instance.mouseMove(_this11.point);
      });
      this.requireMove = false;
    }
  }]);
}(Module);
var Hash = /*#__PURE__*/function (_Module9) {
  function Hash() {
    var _this12;
    _classCallCheck(this, Hash);
    _this12 = _callSuper(this, Hash, ['hash']);
    _this12.handling = _this12.handle.bind(_this12);
    _this12.getLocationHash();
    return _this12;
  }
  _inherits(Hash, _Module9);
  return _createClass(Hash, [{
    key: "activate",
    value: function activate() {
      window.addEventListener('hashchange', this.handling);
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      window.removeEventListener('hashchange', this.handling);
    }
  }, {
    key: "_sanitize",
    value: function _sanitize(hash) {
      if (hash.charAt(0) === '#') return hash.substring(1);
      return hash;
    }
  }, {
    key: "hash",
    get: function get() {
      return this._hash;
    },
    set: function set(value) {
      var hash = this._sanitize(value);
      if (this._hash !== hash) window.location.hash = hash;
    }
  }, {
    key: "getLocationHash",
    value: function getLocationHash() {
      var hash = window.location.hash;
      this._hash = this._sanitize(hash);
    }
  }, {
    key: "handle",
    value: function handle(e) {
      var _this13 = this;
      this.getLocationHash();
      this.forEach(function (instance) {
        return instance.handleHash(_this13._hash, e);
      });
    }
  }]);
}(Module);
var Engine = /*#__PURE__*/function () {
  function Engine() {
    _classCallCheck(this, Engine);
    _state.create(Register);
    _state.create(Stage);
    _state.create(Renderer);
    _state.create(Resizer);
    _state.create(ScrollLocker);
    _state.create(Load);
    _state.create(FontSwap);
    _state.create(MouseMove);
    _state.create(Hash);
    var registerModule = _state.getModule('register');
    this.register = registerModule.register.bind(registerModule);
  }
  return _createClass(Engine, [{
    key: "isActive",
    get: function get() {
      return _state.isActive;
    }
  }, {
    key: "start",
    value: function start() {
      inspector.debug('START');
      _state.isActive = true;
      rootDispatch(RootEvent.START);
    }
  }, {
    key: "stop",
    value: function stop() {
      inspector.debug('STOP');
      _state.isActive = false;
      rootDispatch(RootEvent.STOP);
    }
  }]);
}();
var engine = new Engine();
var Colors = /*#__PURE__*/function () {
  function Colors() {
    _classCallCheck(this, Colors);
  }
  return _createClass(Colors, [{
    key: "getColor",
    value: function getColor(context, use, tint) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var option = getOption(options);
      var decision = "--".concat(context, "-").concat(use, "-").concat(tint).concat(option);
      return getComputedStyle(document.documentElement).getPropertyValue(decision).trim() || null;
    }
  }]);
}();
var getOption = function getOption(options) {
  switch (true) {
    case options.hover:
      return '-hover';
    case options.active:
      return '-active';
    default:
      return '';
  }
};
var colors = new Colors();
var sanitize = function sanitize(className) {
  return className.charAt(0) === '.' ? className.substr(1) : className;
};
var getClassNames = function getClassNames(element) {
  switch (true) {
    case !element.className:
      return [];
    case typeof element.className === 'string':
      return element.className.split(' ');
    case typeof element.className.baseVal === 'string':
      return element.className.baseVal.split(' ');
  }
  return [];
};
var modifyClass = function modifyClass(element, className, remove) {
  className = sanitize(className);
  var classNames = getClassNames(element);
  var index = classNames.indexOf(className);
  if (remove === true) {
    if (index > -1) classNames.splice(index, 1);
  } else if (index === -1) classNames.push(className);
  element.className = classNames.join(' ');
};
var _addClass = function addClass(element, className) {
  return modifyClass(element, className);
};
var _removeClass = function removeClass(element, className) {
  return modifyClass(element, className, true);
};
var _hasClass = function hasClass(element, className) {
  return getClassNames(element).indexOf(sanitize(className)) > -1;
};
var ACTIONS = ['[tabindex]:not([tabindex="-1"])', 'a[href]', 'button:not([disabled])', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details', 'iframe'];
var ACTIONS_SELECTOR = ACTIONS.join();
var queryActions = function queryActions(element) {
  return element.querySelectorAll(ACTIONS_SELECTOR);
};
var counter = 0;
var uniqueId = function uniqueId(id) {
  if (!document.getElementById(id)) return id;
  var element = true;
  var base = id;
  while (element) {
    counter++;
    id = "".concat(base, "-").concat(counter);
    element = document.getElementById(id);
  }
  return id;
};
var dom = {
  addClass: _addClass,
  hasClass: _hasClass,
  removeClass: _removeClass,
  queryParentSelector: _queryParentSelector,
  querySelectorAllArray: querySelectorAllArray,
  queryActions: queryActions,
  uniqueId: uniqueId,
  dispatch: _dispatch
};
var DataURISVG = /*#__PURE__*/function () {
  function DataURISVG() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    _classCallCheck(this, DataURISVG);
    this._width = width;
    this._height = height;
    this._content = '';
  }
  return _createClass(DataURISVG, [{
    key: "width",
    get: function get() {
      return this._width;
    },
    set: function set(value) {
      this._width = value;
    }
  }, {
    key: "height",
    get: function get() {
      return this._height;
    },
    set: function set(value) {
      this._height = value;
    }
  }, {
    key: "content",
    get: function get() {
      return this._content;
    },
    set: function set(value) {
      this._content = value;
    }
  }, {
    key: "getDataURI",
    value: function getDataURI() {
      var isLegacy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var svg = "<svg xmlns='http://www.w3.org/2000/svg' viewbox='0 0 ".concat(this._width, " ").concat(this._height, "' width='").concat(this._width, "px' height='").concat(this._height, "px'>").concat(this._content, "</svg>");
      svg = svg.replace(/#/gi, '%23');
      if (isLegacy) {
        svg = svg.replace(/</gi, '%3C');
        svg = svg.replace(/>/gi, '%3E');
        svg = svg.replace(/"/gi, '\'');
        svg = svg.replace(/{/gi, '%7B');
        svg = svg.replace(/}/gi, '%7D');
      }
      return "data:image/svg+xml;charset=utf8,".concat(svg);
    }
  }]);
}();
var image = {
  DataURISVG: DataURISVG
};
var supportLocalStorage = function supportLocalStorage() {
  try {
    return 'localStorage' in window && window.localStorage !== null;
  } catch (e) {
    return false;
  }
};
var supportAspectRatio = function supportAspectRatio() {
  if (!window.CSS) return false;
  return CSS.supports('aspect-ratio: 16 / 9');
};
var support = {
  supportLocalStorage: supportLocalStorage,
  supportAspectRatio: supportAspectRatio
};
var TransitionSelector = {
  NONE: ns.selector('transition-none')
};
var selector = {
  TransitionSelector: TransitionSelector
};

/**
 * Copy properties from multiple sources including accessors.
 * source : https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#copier_des_accesseurs
 *
 * @param {object} [target] - Target object to copy into
 * @param {...objects} [sources] - Multiple objects
 * @return {object} A new object
 *
 * @example
 *
 *     const obj1 = {
 *        key: 'value'
 *     };
 *     const obj2 = {
 *        get function01 () {
 *          return a-value;
 *        }
 *        set function01 () {
 *          return a-value;
 *        }
 *     };
 *     completeAssign(obj1, obj2)
 */
var completeAssign = function completeAssign(target) {
  for (var _len4 = arguments.length, sources = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    sources[_key4 - 1] = arguments[_key4];
  }
  sources.forEach(function (source) {
    var descriptors = Object.keys(source).reduce(function (descriptors, key) {
      descriptors[key] = Object.getOwnPropertyDescriptor(source, key);
      return descriptors;
    }, {});
    Object.getOwnPropertySymbols(source).forEach(function (sym) {
      var descriptor = Object.getOwnPropertyDescriptor(source, sym);
      if (descriptor.enumerable) {
        descriptors[sym] = descriptor;
      }
    });
    Object.defineProperties(target, descriptors);
  });
  return target;
};
var property = {
  completeAssign: completeAssign
};

/**
 * Return an object of query params or null
 *
 * @method
 * @name searchParams
 * @param {string} url - an url
 * @returns {Object} object of query params or null
 */

var searchParams = function searchParams(url) {
  if (url && url.search) {
    var params = new URLSearchParams(window.location.search);
    var entries = params.entries();
    return Object.fromEntries(entries);
  }
  return null;
};
var internals = {};
var legacy = {};
Object.defineProperty(legacy, 'isLegacy', {
  get: function get() {
    return _state.isLegacy;
  }
});
legacy.setLegacy = function () {
  _state.isLegacy = true;
};
internals.legacy = legacy;
internals.dom = dom;
internals.image = image;
internals.support = support;
internals.motion = selector;
internals.property = property;
internals.ns = ns;
internals.register = engine.register;
internals.state = _state;
internals.query = searchParams(window.location);
Object.defineProperty(internals, 'preventManipulation', {
  get: function get() {
    return options.preventManipulation;
  }
});
Object.defineProperty(internals, 'stage', {
  get: function get() {
    return _state.getModule('stage');
  }
});
var api$1 = function api$1(node) {
  var stage = _state.getModule('stage');
  return stage.getProxy(node);
};
api$1.version = config.version;
api$1.prefix = config.prefix;
api$1.organisation = config.organisation;
api$1.Modes = Modes;
Object.defineProperty(api$1, 'mode', {
  set: function set(value) {
    options.mode = value;
  },
  get: function get() {
    return options.mode;
  }
});
api$1.internals = internals;
api$1.version = config.version;
api$1.start = engine.start;
api$1.stop = engine.stop;
api$1.inspector = inspector;
api$1.colors = colors;
var configuration = window[config.namespace];
api$1.internals.configuration = configuration;
options.configure(configuration, api$1.start, api$1.internals.query);
window[config.namespace] = api$1;
var Emitter = /*#__PURE__*/function () {
  function Emitter() {
    _classCallCheck(this, Emitter);
    this.emissions = {};
  }
  return _createClass(Emitter, [{
    key: "add",
    value: function add(type, closure) {
      if (typeof closure !== 'function') throw new Error('closure must be a function');
      if (!this.emissions[type]) this.emissions[type] = [];
      this.emissions[type].push(closure);
    }
  }, {
    key: "remove",
    value: function remove(type, closure) {
      if (!this.emissions[type]) return;
      if (!closure) delete this.emissions[type];else {
        var index = this.emissions[type].indexOf(closure);
        if (index > -1) this.emissions[type].splice(index);
      }
    }
  }, {
    key: "emit",
    value: function emit(type, data) {
      if (!this.emissions[type]) return [];
      var response = [];
      var _iterator20 = _createForOfIteratorHelper(this.emissions[type]),
        _step20;
      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var closure = _step20.value;
          if (closure) response.push(closure(data));
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }
      return response;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.emissions = null;
    }
  }]);
}();
var FocusManager = /*#__PURE__*/function () {
  function FocusManager() {
    _classCallCheck(this, FocusManager);
    this._activeElements = [];
    window.document.addEventListener('focusin', this._onFocusIn.bind(this));
  }
  return _createClass(FocusManager, [{
    key: "_onFocusIn",
    value: function _onFocusIn(e) {
      this._activeElements.push(e.target);
    }
  }, {
    key: "index",
    get: function get() {
      return this._activeElements.length - 1;
    }
  }, {
    key: "focus",
    value: function focus(index) {
      var element = this._activeElements[index];
      switch (true) {
        case index < 0:
        case this._activeElements.length === 0:
          this.focusOnLogo();
          return;
        case !element:
        case !document.documentElement.contains(element):
        case !this._isDisplayed(element):
          this.focus(index - 1);
          return;
      }
      element.focus();
    }
  }, {
    key: "focusOnLogo",
    value: function focusOnLogo() {
      var logo = document.querySelector(api$1.header.HeaderSelector.BRAND_LINK);
      if (logo) logo.focus();
    }
  }, {
    key: "_isDisplayed",
    value: function _isDisplayed(element) {
      while (element && element !== document.documentElement) {
        if (element === document.body) return true;
        var style = window.getComputedStyle(element);
        if (style.display === 'none' || style.visibility === 'hidden') return false;
        element = element.parentElement;
      }
      return true;
    }
  }]);
}();
var focusManager = new FocusManager();
var Breakpoint = /*#__PURE__*/function () {
  function Breakpoint(id, minWidth) {
    _classCallCheck(this, Breakpoint);
    this.id = id;
    this.minWidth = minWidth;
  }
  return _createClass(Breakpoint, [{
    key: "test",
    value: function test() {
      return window.matchMedia("(min-width: ".concat(this.minWidth, "em)")).matches;
    }
  }]);
}();
var Breakpoints = {
  XS: new Breakpoint('xs', 0),
  SM: new Breakpoint('sm', 36),
  MD: new Breakpoint('md', 48),
  LG: new Breakpoint('lg', 62),
  XL: new Breakpoint('xl', 78)
};
var InstanceEvent = {
  CLICK: ns.event('click')
};
var Instance = /*#__PURE__*/function () {
  function Instance() {
    var jsAttribute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    _classCallCheck(this, Instance);
    this.jsAttribute = jsAttribute;
    this._isRendering = false;
    this._isResizing = false;
    this._isScrollLocked = false;
    this._isLoading = false;
    this._isSwappingFont = false;
    this._isEnabled = true;
    this._isDisposed = false;
    this._listeners = {};
    this._handlingClick = this._handleClick.bind(this);
    this._hashes = [];
    this._hash = '';
    this._keyListenerTypes = [];
    this._keys = [];
    this.handlingKey = this.handleKey.bind(this);
    this._emitter = new Emitter();
    this._ascent = new Emitter();
    this._descent = new Emitter();
    this._registrations = [];
    this._nexts = [];
  }
  return _createClass(Instance, [{
    key: "_config",
    value: function _config(element, registration) {
      this.element = element;
      this.registration = registration;
      this.node = element.node;
      this.id = element.node.id;
      if (this.jsAttribute) this.setAttribute(registration.attribute, true);
      this.init();
    }
  }, {
    key: "init",
    value: function init() {}
  }, {
    key: "proxy",
    get: function get() {
      var scope = this;
      var proxy = {
        render: function render() {
          return scope.render();
        },
        resize: function resize() {
          return scope.resize();
        }
      };
      var proxyAccessors = {
        get node() {
          return scope.node;
        },
        get isEnabled() {
          return scope.isEnabled;
        },
        set isEnabled(value) {
          scope.isEnabled = value;
        }
      };
      return completeAssign(proxy, proxyAccessors);
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len5 = arguments.length, values = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        values[_key5] = arguments[_key5];
      }
      values.unshift("".concat(this.registration.instanceClassName, " #").concat(this.id, " - "));
      inspector.log.apply(inspector, values);
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len6 = arguments.length, values = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        values[_key6] = arguments[_key6];
      }
      values.unshift("".concat(this.registration.instanceClassName, " #").concat(this.id, " - "));
      inspector.debug.apply(inspector, values);
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len7 = arguments.length, values = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        values[_key7] = arguments[_key7];
      }
      values.unshift("".concat(this.registration.instanceClassName, " #").concat(this.id, " - "));
      inspector.info.apply(inspector, values);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len8 = arguments.length, values = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        values[_key8] = arguments[_key8];
      }
      values.unshift("".concat(this.registration.instanceClassName, " #").concat(this.id, " - "));
      inspector.warn.apply(inspector, values);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len9 = arguments.length, values = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        values[_key9] = arguments[_key9];
      }
      values.unshift("".concat(this.registration.instanceClassName, " #").concat(this.id, " - "));
      inspector.error.apply(inspector, values);
    }
  }, {
    key: "register",
    value: function register(selector, InstanceClass) {
      var registration = _state.getModule('register').register(selector, InstanceClass, this);
      this._registrations.push(registration);
    }
  }, {
    key: "getRegisteredInstances",
    value: function getRegisteredInstances(instanceClassName) {
      var _iterator21 = _createForOfIteratorHelper(this._registrations),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var registration = _step21.value;
          if (registration.hasInstanceClassName(instanceClassName)) return registration.instances.collection;
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
      return [];
    }
  }, {
    key: "dispatch",
    value: function dispatch(type) {
      var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var bubbles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var cancelable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      _dispatch(this.node, type, detail, bubbles, cancelable);
    }

    // TODO v2 => listener au niveau des éléments qui redistribuent aux instances.
  }, {
    key: "listen",
    value: function listen(type, closure, options) {
      if (!this._listeners[type]) this._listeners[type] = [];
      var listeners = this._listeners[type];
      // if (listeners.some(listener => listener.closure === closure)) return;
      var listener = new Listener(this.node, type, closure, options);
      listeners.push(listener);
      listener.listen();
    }
  }, {
    key: "unlisten",
    value: function unlisten(type, closure, options) {
      var _this14 = this;
      if (!type) {
        for (var _type in this._listeners) this.unlisten(_type);
        return;
      }
      var listeners = this._listeners[type];
      if (!listeners) return;
      if (!closure) {
        listeners.forEach(function (listener) {
          return _this14.unlisten(type, listener.closure);
        });
        return;
      }
      var removal = listeners.filter(function (listener) {
        return listener.closure === closure && listener.matchOptions(options);
      });
      removal.forEach(function (listener) {
        return listener.unlisten();
      });
      this._listeners[type] = listeners.filter(function (listener) {
        return removal.indexOf(listener) === -1;
      });
    }
  }, {
    key: "listenClick",
    value: function listenClick(options) {
      this.listen('click', this._handlingClick, options);
    }
  }, {
    key: "unlistenClick",
    value: function unlistenClick(options) {
      this.unlisten('click', this._handlingClick, options);
    }
  }, {
    key: "_handleClick",
    value: function _handleClick(e) {
      this.handleClick(e);
      this.dispatch(InstanceEvent.CLICK, this);
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {}
  }, {
    key: "hash",
    get: function get() {
      return _state.getModule('hash').hash;
    },
    set: function set(value) {
      _state.getModule('hash').hash = value;
    }
  }, {
    key: "listenHash",
    value: function listenHash(hash, add) {
      if (!this._hashes) return;
      if (this._hashes.length === 0) _state.add('hash', this);
      var action = new HashAction(hash, add);
      this._hashes = this._hashes.filter(function (action) {
        return action.hash !== hash;
      });
      this._hashes.push(action);
    }
  }, {
    key: "unlistenHash",
    value: function unlistenHash(hash) {
      if (!this._hashes) return;
      this._hashes = this._hashes.filter(function (action) {
        return action.hash !== hash;
      });
      if (this._hashes.length === 0) _state.remove('hash', this);
    }
  }, {
    key: "handleHash",
    value: function handleHash(hash, e) {
      if (!this._hashes) return;
      var _iterator22 = _createForOfIteratorHelper(this._hashes),
        _step22;
      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var action = _step22.value;
          action.handle(hash, e);
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
    }
  }, {
    key: "listenKey",
    value: function listenKey(keyCode, closure) {
      var preventDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var stopPropagation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var type = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'down';
      if (this._keyListenerTypes.indexOf(type) === -1) {
        this.listen("key".concat(type), this.handlingKey);
        this._keyListenerTypes.push(type);
      }
      this._keys.push(new KeyAction(type, keyCode, closure, preventDefault, stopPropagation));
    }
  }, {
    key: "unlistenKey",
    value: function unlistenKey(code, closure) {
      var _this15 = this;
      this._keys = this._keys.filter(function (key) {
        return key.code !== code || key.closure !== closure;
      });
      this._keyListenerTypes.forEach(function (type) {
        if (!_this15._keys.some(function (key) {
          return key.type === type;
        })) _this15.unlisten("key".concat(type), _this15.handlingKey);
      });
    }
  }, {
    key: "handleKey",
    value: function handleKey(e) {
      var _iterator23 = _createForOfIteratorHelper(this._keys),
        _step23;
      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var key = _step23.value;
          key.handle(e);
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
    }
  }, {
    key: "isEnabled",
    get: function get() {
      return this._isEnabled;
    },
    set: function set(value) {
      this._isEnabled = value;
    }
  }, {
    key: "isRendering",
    get: function get() {
      return this._isRendering;
    },
    set: function set(value) {
      if (this._isRendering === value) return;
      if (value) _state.add('render', this);else _state.remove('render', this);
      this._isRendering = value;
    }
  }, {
    key: "render",
    value: function render() {}
  }, {
    key: "request",
    value: function request(closure) {
      this._nexts.push(closure);
      _state.getModule('render').request(this);
    }
  }, {
    key: "next",
    value: function next() {
      var nexts = this._nexts.slice();
      this._nexts.length = 0;
      var _iterator24 = _createForOfIteratorHelper(nexts),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var closure = _step24.value;
          if (closure) closure();
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
    }
  }, {
    key: "isResizing",
    get: function get() {
      return this._isResizing;
    },
    set: function set(value) {
      if (this._isResizing === value) return;
      if (value) {
        _state.add('resize', this);
        this.resize();
      } else _state.remove('resize', this);
      this._isResizing = value;
    }
  }, {
    key: "resize",
    value: function resize() {}
  }, {
    key: "isBreakpoint",
    value: function isBreakpoint(breakpoint) {
      switch (true) {
        case typeof breakpoint === 'string':
          return Breakpoints[breakpoint.toUpperCase()].test();
        default:
          return breakpoint.test();
      }
    }
  }, {
    key: "isScrollLocked",
    get: function get() {
      return this._isScrollLocked;
    },
    set: function set(value) {
      if (this._isScrollLocked === value) return;
      if (value) _state.add('lock', this);else _state.remove('lock', this);
      this._isScrollLocked = value;
    }
  }, {
    key: "isLoading",
    get: function get() {
      return this._isLoading;
    },
    set: function set(value) {
      if (this._isLoading === value) return;
      if (value) _state.add('load', this);else _state.remove('load', this);
      this._isLoading = value;
    }
  }, {
    key: "load",
    value: function load() {}
  }, {
    key: "isSwappingFont",
    get: function get() {
      return this._isSwappingFont;
    },
    set: function set(value) {
      if (this._isSwappingFont === value) return;
      if (value) _state.add('font-swap', this);else _state.remove('font-swap', this);
      this._isSwappingFont = value;
    }
  }, {
    key: "swapFont",
    value: function swapFont() {}
  }, {
    key: "isMouseMoving",
    get: function get() {
      return this._isMouseMoving;
    },
    set: function set(value) {
      if (this._isMouseMoving === value) return;
      if (value) {
        _state.add('mouse-move', this);
      } else {
        _state.remove('mouse-move', this);
      }
      this._isMouseMoving = value;
    }
  }, {
    key: "mouseMove",
    value: function mouseMove(point) {}
  }, {
    key: "examine",
    value: function examine(attributeNames) {
      if (!this.node.matches(this.registration.selector)) {
        this._dispose();
        return;
      }
      this.mutate(attributeNames);
    }
  }, {
    key: "mutate",
    value: function mutate(attributeNames) {}
  }, {
    key: "retrieveNodeId",
    value: function retrieveNodeId(node, append) {
      if (node.id) return node.id;
      var id = uniqueId("".concat(this.id, "-").concat(append));
      this.warn("add id '".concat(id, "' to ").concat(append));
      node.setAttribute('id', id);
      return id;
    }
  }, {
    key: "isDisposed",
    get: function get() {
      return this._isDisposed;
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      this.debug("dispose instance of ".concat(this.registration.instanceClassName, " on element [").concat(this.element.id, "]"));
      this.removeAttribute(this.registration.attribute);
      this.unlisten();
      _state.remove('hash', this);
      this._hashes = null;
      this._keys = null;
      this.isRendering = false;
      this.isResizing = false;
      this._nexts = null;
      _state.getModule('render').nexts.remove(this);
      this.isScrollLocked = false;
      this.isLoading = false;
      this.isSwappingFont = false;
      this.isMouseMoving = false;
      this._emitter.dispose();
      this._emitter = null;
      this._ascent.dispose();
      this._ascent = null;
      this._descent.dispose();
      this._descent = null;
      this.element.remove(this);
      var _iterator25 = _createForOfIteratorHelper(this._registrations),
        _step25;
      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var registration = _step25.value;
          _state.remove('register', registration);
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
      this._registrations = null;
      this.registration.remove(this);
      this._isDisposed = true;
      this.dispose();
    }
  }, {
    key: "dispose",
    value: function dispose() {}
  }, {
    key: "emit",
    value: function emit(type, data) {
      return this.element.emit(type, data);
    }
  }, {
    key: "addEmission",
    value: function addEmission(type, closure) {
      this._emitter.add(type, closure);
    }
  }, {
    key: "removeEmission",
    value: function removeEmission(type, closure) {
      this._emitter.remove(type, closure);
    }
  }, {
    key: "ascend",
    value: function ascend(type, data) {
      return this.element.ascend(type, data);
    }
  }, {
    key: "addAscent",
    value: function addAscent(type, closure) {
      this._ascent.add(type, closure);
    }
  }, {
    key: "removeAscent",
    value: function removeAscent(type, closure) {
      this._ascent.remove(type, closure);
    }
  }, {
    key: "descend",
    value: function descend(type, data) {
      return this.element.descend(type, data);
    }
  }, {
    key: "addDescent",
    value: function addDescent(type, closure) {
      this._descent.add(type, closure);
    }
  }, {
    key: "removeDescent",
    value: function removeDescent(type, closure) {
      this._descent.remove(type, closure);
    }
  }, {
    key: "style",
    get: function get() {
      return this.node.style;
    }
  }, {
    key: "addClass",
    value: function addClass(className) {
      _addClass(this.node, className);
    }
  }, {
    key: "removeClass",
    value: function removeClass(className) {
      _removeClass(this.node, className);
    }
  }, {
    key: "hasClass",
    value: function hasClass(className) {
      return _hasClass(this.node, className);
    }
  }, {
    key: "classNames",
    get: function get() {
      return getClassNames(this.node);
    }
  }, {
    key: "remove",
    value: function remove() {
      this.node.parentNode.removeChild(this.node);
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(attributeName, value) {
      this.node.setAttribute(attributeName, value);
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(attributeName) {
      return this.node.getAttribute(attributeName);
    }
  }, {
    key: "hasAttribute",
    value: function hasAttribute(attributeName) {
      return this.node.hasAttribute(attributeName);
    }
  }, {
    key: "removeAttribute",
    value: function removeAttribute(attributeName) {
      this.node.removeAttribute(attributeName);
    }
  }, {
    key: "setProperty",
    value: function setProperty(propertyName, value) {
      this.node.style.setProperty(propertyName, value);
    }
  }, {
    key: "removeProperty",
    value: function removeProperty(propertyName) {
      this.node.style.removeProperty(propertyName);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.node.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.node.blur();
    }
  }, {
    key: "retainFocus",
    value: function retainFocus() {
      this._focusIndex = focusManager.index;
    }
  }, {
    key: "focusBack",
    value: function focusBack() {
      focusManager.focus(this._focusIndex);
    }
  }, {
    key: "focusClosest",
    value: function focusClosest() {
      var closest = this._focusClosest(this.node.parentNode);
      if (closest) closest.focus();
    }
  }, {
    key: "_focusClosest",
    value: function _focusClosest(parent) {
      if (!parent) return null;
      var actions = _toConsumableArray(queryActions(parent));
      if (actions.length <= 1) {
        return this._focusClosest(parent.parentNode);
      } else {
        var index = actions.indexOf(this.node);
        return actions[index + (index < actions.length - 1 ? 1 : -1)];
      }
    }
  }, {
    key: "hasFocus",
    get: function get() {
      return this.node === document.activeElement;
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView() {
      var rect = this.getRect();
      var scroll = _state.getModule('lock');
      if (rect.top < 0) {
        scroll.move(rect.top - 50);
      }
      if (rect.bottom > window.innerHeight) {
        scroll.move(rect.bottom - window.innerHeight + 50);
      }
    }
  }, {
    key: "matches",
    value: function matches(selectors) {
      return this.node.matches(selectors);
    }
  }, {
    key: "querySelector",
    value: function querySelector(selectors) {
      return this.node.querySelector(selectors);
    }
  }, {
    key: "querySelectorAll",
    value: function querySelectorAll(selectors) {
      return querySelectorAllArray(this.node, selectors);
    }
  }, {
    key: "queryParentSelector",
    value: function queryParentSelector(selectors) {
      return _queryParentSelector(this.node, selectors);
    }
  }, {
    key: "getRect",
    value: function getRect() {
      var rect = this.node.getBoundingClientRect();
      rect.center = rect.left + rect.width * 0.5;
      rect.middle = rect.top + rect.height * 0.5;
      return rect;
    }
  }, {
    key: "isLegacy",
    get: function get() {
      return _state.isLegacy;
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Instance';
    }
  }]);
}();
var KeyAction = /*#__PURE__*/function () {
  function KeyAction(type, keyCode, closure, preventDefault, stopPropagation) {
    _classCallCheck(this, KeyAction);
    this.type = type;
    this.eventType = "key".concat(type);
    this.keyCode = keyCode;
    this.closure = closure;
    this.preventDefault = preventDefault === true;
    this.stopPropagation = stopPropagation === true;
  }
  return _createClass(KeyAction, [{
    key: "handle",
    value: function handle(e) {
      if (e.type !== this.eventType) return;
      if (e.keyCode === this.keyCode.value) {
        this.closure(e);
        if (this.preventDefault) {
          e.preventDefault();
        }
        if (this.stopPropagation) {
          e.stopPropagation();
        }
      }
    }
  }]);
}();
var Listener = /*#__PURE__*/function () {
  function Listener(node, type, closure, options) {
    _classCallCheck(this, Listener);
    this._node = node;
    this._type = type;
    this._closure = closure;
    this._options = options;
  }
  return _createClass(Listener, [{
    key: "closure",
    get: function get() {
      return this._closure;
    }
  }, {
    key: "listen",
    value: function listen() {
      this._node.addEventListener(this._type, this._closure, this._options);
    }
  }, {
    key: "matchOptions",
    value: function matchOptions() {
      var _this16 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      switch (true) {
        case options === null:
        case typeof this._options === 'boolean' && typeof options === 'boolean' && this._options === options:
          return true;
        case Object.keys(this._options).length !== Object.keys(options).length:
          return false;
        case Object.keys(options).every(function (key) {
          return _this16._options[key] === options[key];
        }):
          return true;
      }
      return false;
    }
  }, {
    key: "unlisten",
    value: function unlisten() {
      this._node.removeEventListener(this._type, this._closure, this._options);
    }
  }]);
}();
var HashAction = /*#__PURE__*/function () {
  function HashAction(hash, add) {
    _classCallCheck(this, HashAction);
    this.hash = hash;
    this.add = add;
  }
  return _createClass(HashAction, [{
    key: "handle",
    value: function handle(hash, e) {
      if (this.hash === hash) this.add(e);
    }
  }]);
}();
var DisclosureEvent = {
  DISCLOSE: ns.event('disclose'),
  CONCEAL: ns.event('conceal'),
  CURRENT: ns.event('current')
};
var DisclosureEmission = {
  RESET: ns.emission('disclosure', 'reset'),
  ADDED: ns.emission('disclosure', 'added'),
  RETRIEVE: ns.emission('disclosure', 'retrieve'),
  REMOVED: ns.emission('disclosure', 'removed'),
  GROUP: ns.emission('disclosure', 'group'),
  UNGROUP: ns.emission('disclosure', 'ungroup'),
  SPOTLIGHT: ns.emission('disclosure', 'spotlight')
};
var Disclosure = /*#__PURE__*/function (_Instance) {
  function Disclosure(type, selector, DisclosureButtonInstanceClass, disclosuresGroupInstanceClassName) {
    var _this17;
    _classCallCheck(this, Disclosure);
    _this17 = _callSuper(this, Disclosure);
    _this17.type = type;
    _this17._selector = selector;
    _this17.DisclosureButtonInstanceClass = DisclosureButtonInstanceClass;
    _this17.disclosuresGroupInstanceClassName = disclosuresGroupInstanceClassName;
    _this17.modifier = _this17._selector + '--' + _this17.type.id;
    _this17._isPristine = true;
    _this17._isActive = true;
    _this17._isRetrievingPrimaries = false;
    _this17._hasRetrieved = false;
    _this17._primaryButtons = [];
    return _this17;
  }
  _inherits(Disclosure, _Instance);
  return _createClass(Disclosure, [{
    key: "init",
    value: function init() {
      this.addDescent(DisclosureEmission.RESET, this.reset.bind(this));
      this.addDescent(DisclosureEmission.GROUP, this.update.bind(this));
      this.addDescent(DisclosureEmission.UNGROUP, this.update.bind(this));
      this.addAscent(DisclosureEmission.SPOTLIGHT, this.disclose.bind(this));
      this.register("[aria-controls=\"".concat(this.id, "\"]"), this.DisclosureButtonInstanceClass);
      this.ascend(DisclosureEmission.ADDED);
      this.listenHash(this.id, this._spotlight.bind(this));
      this.update();
    }
  }, {
    key: "isEnabled",
    get: function get() {
      return _superPropGet(Disclosure, "isEnabled", this, 1);
    },
    set: function set(value) {
      if (this.isEnabled === value) return;
      _superPropSet(Disclosure, "isEnabled", value, this, 1, 1);
      if (value) this.ascend(DisclosureEmission.ADDED);else this.ascend(DisclosureEmission.REMOVED);
    }
  }, {
    key: "isActive",
    get: function get() {
      return this._isActive;
    },
    set: function set(value) {
      if (this._isActive === value) return;
      this._isActive = value;
      if (value) this.ascend(DisclosureEmission.ADDED);else {
        this.ascend(DisclosureEmission.REMOVED);
        if (this.isDisclosed) this.conceal();
      }
    }
  }, {
    key: "isPristine",
    get: function get() {
      return this._isPristine;
    }
  }, {
    key: "proxy",
    get: function get() {
      var scope = this;
      var proxy = Object.assign(_superPropGet(Disclosure, "proxy", this, 1), {
        disclose: scope.disclose.bind(scope),
        focus: scope.focus.bind(scope)
      });
      if (this.type.canConceal) proxy.conceal = scope.conceal.bind(scope);
      var proxyAccessors = {
        get buttons() {
          return scope.buttons.map(function (button) {
            return button.proxy;
          });
        },
        get group() {
          var group = scope.group;
          return group ? group.proxy : null;
        },
        get isDisclosed() {
          return scope.isDisclosed;
        },
        get isEnabled() {
          return scope.isEnabled;
        },
        get isActive() {
          return scope.isActive;
        }
      };
      return completeAssign(proxy, proxyAccessors);
    }
  }, {
    key: "buttons",
    get: function get() {
      return this.getRegisteredInstances(this.DisclosureButtonInstanceClass.instanceClassName);
    }
  }, {
    key: "update",
    value: function update() {
      this.getGroup();
      this.retrievePrimaries();
    }
  }, {
    key: "getGroup",
    value: function getGroup() {
      if (!this.disclosuresGroupInstanceClassName) {
        this._group = null;
        return;
      }
      var group = this.element.getAscendantInstance(this.disclosuresGroupInstanceClassName, this.constructor.instanceClassName);
      if (!group || !group.validate(this)) {
        this._group = null;
        return;
      }
      this._group = group;
    }
  }, {
    key: "group",
    get: function get() {
      return this._group;
    }
  }, {
    key: "disclose",
    value: function disclose(withhold) {
      if (this.isDisclosed === true || !this.isEnabled || !this._isActive) return false;
      this.retainFocus();
      this._isPristine = false;
      this.isDisclosed = true;
      if (!withhold && this.group) this.group.current = this;
      return true;
    }
  }, {
    key: "conceal",
    value: function conceal(withhold) {
      var preventFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (this.isDisclosed === false) return false;
      if (!this.type.canConceal && this.group && this.group.current === this) return false;
      this.isDisclosed = false;
      if (!withhold && this.group && this.group.current === this) this.group.current = null;
      if (!preventFocus) this.focus();
      if (!this._isPristine) this.descend(DisclosureEmission.RESET);
      return true;
    }
  }, {
    key: "isDisclosed",
    get: function get() {
      return this._isDisclosed;
    },
    set: function set(value) {
      if (this._isDisclosed === value || !this.isEnabled && value === true) return;
      if (!this._isPristine) this.dispatch(value ? DisclosureEvent.DISCLOSE : DisclosureEvent.CONCEAL, this);
      this._isDisclosed = value;
      if (value) this.addClass(this.modifier);else this.removeClass(this.modifier);
      for (var i = 0; i < this.buttons.length; i++) this.buttons[i].apply(value);
    }
  }, {
    key: "isInitiallyDisclosed",
    get: function get() {
      return this.primaryButtons.some(function (button) {
        return button.isInitiallyDisclosed;
      });
    }
  }, {
    key: "hasRetrieved",
    value: function hasRetrieved() {
      return this._hasRetrieved;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "toggle",
    value: function toggle(canDisclose) {
      if (!this.type.canConceal) this.disclose();else {
        switch (true) {
          case !canDisclose:
          case this.isDisclosed:
            this.conceal(false, false);
            break;
          default:
            this.disclose();
        }
      }
    }
  }, {
    key: "buttonHasFocus",
    get: function get() {
      return this.buttons.some(function (button) {
        return button.hasFocus;
      });
    }
  }, {
    key: "hasFocus",
    get: function get() {
      if (_superPropGet(Disclosure, "hasFocus", this, 1)) return true;
      if (this.buttonHasFocus) return true;
      return this.querySelectorAll(':focus').length > 0;
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this._primaryButtons.length > 0) this._primaryButtons[0].focus();else this.focusBack();
    }
  }, {
    key: "primaryButtons",
    get: function get() {
      return this._primaryButtons;
    }
  }, {
    key: "retrievePrimaries",
    value: function retrievePrimaries() {
      if (this._isRetrievingPrimaries) return;
      this._isRetrievingPrimaries = true;
      this.request(this._retrievePrimaries.bind(this));
    }
  }, {
    key: "_retrievePrimaries",
    value: function _retrievePrimaries() {
      this._isRetrievingPrimaries = false;
      this._primaryButtons = this._electPrimaries(this.buttons);
      if (this._hasRetrieved || this._primaryButtons.length === 0 && this.type.requirePrimary) return;
      this.retrieved();
      this._hasRetrieved = true;
      this.applyAbility(true);
      if (this.group) {
        this.group.retrieve();
        return;
      }
      if (this._isPristine && this.isEnabled && this.isActive && !this.group) {
        switch (true) {
          case this.hash === this.id:
            this._spotlight();
            break;
          case this.isInitiallyDisclosed:
            this.disclose();
            break;
        }
      }
    }
  }, {
    key: "retrieved",
    value: function retrieved() {}
  }, {
    key: "_spotlight",
    value: function _spotlight() {
      var _this18 = this;
      this.disclose();
      this.request(function () {
        _this18.ascend(DisclosureEmission.SPOTLIGHT);
      });
    }
  }, {
    key: "_electPrimaries",
    value: function _electPrimaries(candidates) {
      var _this19 = this;
      return candidates.filter(function (button) {
        return button.canDisclose && !_this19.node.contains(button.node);
      });
    }
  }, {
    key: "applyAbility",
    value: function applyAbility() {
      var withhold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var isEnabled = !this.type.requirePrimary || this._primaryButtons.some(function (button) {
        return !button.isDisabled;
      });
      if (this.isEnabled === isEnabled) return;
      this.isEnabled = isEnabled;
      if (withhold) return;
      if (!this.isEnabled && this.isDisclosed) {
        if (this.group) this.ascend(DisclosureEmission.REMOVED);else if (this.type.canConceal) this.conceal();
      }
      if (this.isEnabled) {
        if (this.group) this.ascend(DisclosureEmission.ADDED);
        if (this.hash === this.id) {
          this._spotlight();
        }
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._group = null;
      this._primaryButtons = null;
      _superPropGet(Disclosure, "dispose", this, 3)([]);
      this.ascend(DisclosureEmission.REMOVED);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Disclosure';
    }
  }]);
}(Instance);
var DisclosureButton = /*#__PURE__*/function (_Instance2) {
  function DisclosureButton(type) {
    var _this20;
    _classCallCheck(this, DisclosureButton);
    _this20 = _callSuper(this, DisclosureButton);
    _this20.type = type;
    _this20.attributeName = type.ariaState ? 'aria-' + type.id : ns.attr(type.id);
    _this20._canDisclose = false;
    return _this20;
  }
  _inherits(DisclosureButton, _Instance2);
  return _createClass(DisclosureButton, [{
    key: "isPrimary",
    get: function get() {
      return this.registration.creator.primaryButtons.includes(this);
    }
  }, {
    key: "canDisclose",
    get: function get() {
      return this._canDisclose;
    }
  }, {
    key: "isDisabled",
    get: function get() {
      return this.type.canDisable && this.hasAttribute('disabled');
    }
  }, {
    key: "init",
    value: function init() {
      this._canDisclose = this.hasAttribute(this.attributeName);
      this._isInitiallyDisclosed = this.isDisclosed;
      this._isContained = this.registration.creator.node.contains(this.node);
      this.controlsId = this.getAttribute('aria-controls');
      this.registration.creator.retrievePrimaries();
      this.listenClick();
    }
  }, {
    key: "proxy",
    get: function get() {
      var scope = this;
      return Object.assign(_superPropGet(DisclosureButton, "proxy", this, 1), {
        focus: scope.focus.bind(scope)
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      if (this.registration.creator) this.registration.creator.toggle(this.canDisclose);
    }
  }, {
    key: "mutate",
    value: function mutate(attributeNames) {
      this._canDisclose = this.hasAttribute(this.attributeName);
      this.registration.creator.applyAbility();
      if (!this._isApplying && this.isPrimary && attributeNames.indexOf(this.attributeName) > -1 && this.registration.creator) {
        if (this.isDisclosed) this.registration.creator.disclose();else if (this.type.canConceal) this.registration.creator.conceal();
      }
    }
  }, {
    key: "apply",
    value: function apply(value) {
      var _this21 = this;
      if (!this.canDisclose) return;
      this._isApplying = true;
      this.setAttribute(this.attributeName, value);
      this.request(function () {
        _this21._isApplying = false;
      });
    }
  }, {
    key: "isDisclosed",
    get: function get() {
      return this.getAttribute(this.attributeName) === 'true';
    }
  }, {
    key: "isInitiallyDisclosed",
    get: function get() {
      return this._isInitiallyDisclosed;
    }
  }, {
    key: "focus",
    value: function focus() {
      _superPropGet(DisclosureButton, "focus", this, 3)([]);
      this.scrollIntoView();
    }
  }, {
    key: "measure",
    value: function measure(rect) {
      var buttonRect = this.rect;
      this._dx = rect.x - buttonRect.x;
      this._dy = rect.y - buttonRect.y;
    }
  }, {
    key: "dx",
    get: function get() {
      return this._dx;
    }
  }, {
    key: "dy",
    get: function get() {
      return this._dy;
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'DisclosureButton';
    }
  }]);
}(Instance);
var DisclosureSelector = {
  PREVENT_CONCEAL: ns.attr.selector('prevent-conceal'),
  GROUP: ns.attr('group')
};
var DisclosuresGroup = /*#__PURE__*/function (_Instance3) {
  function DisclosuresGroup(disclosureInstanceClassName, jsAttribute) {
    var _this22;
    _classCallCheck(this, DisclosuresGroup);
    _this22 = _callSuper(this, DisclosuresGroup, [jsAttribute]);
    _this22.disclosureInstanceClassName = disclosureInstanceClassName;
    _this22._members = [];
    _this22._index = -1;
    _this22._isRetrieving = false;
    _this22._hasRetrieved = false;
    _this22._isGrouped = true;
    return _this22;
  }
  _inherits(DisclosuresGroup, _Instance3);
  return _createClass(DisclosuresGroup, [{
    key: "init",
    value: function init() {
      this.addAscent(DisclosureEmission.ADDED, this.update.bind(this));
      this.addAscent(DisclosureEmission.RETRIEVE, this.retrieve.bind(this));
      this.addAscent(DisclosureEmission.REMOVED, this.update.bind(this));
      this.descend(DisclosureEmission.GROUP);
      this._isGrouped = this.getAttribute(DisclosureSelector.GROUP) !== 'false';
      this.update();
    }
  }, {
    key: "proxy",
    get: function get() {
      var scope = this;
      var proxyAccessors = {
        set index(value) {
          scope.index = value;
        },
        get index() {
          return scope.index;
        },
        get length() {
          return scope.length;
        },
        get current() {
          var current = scope.current;
          return current ? current.proxy : null;
        },
        get members() {
          return scope.members.map(function (member) {
            return member.proxy;
          });
        },
        get hasFocus() {
          return scope.hasFocus;
        },
        set isGrouped(value) {
          scope.isGrouped = value;
        },
        get isGrouped() {
          return scope.isGrouped;
        }
      };
      return completeAssign(_superPropGet(DisclosuresGroup, "proxy", this, 1), proxyAccessors);
    }
  }, {
    key: "validate",
    value: function validate(member) {
      return true;
    }
  }, {
    key: "getMembers",
    value: function getMembers() {
      var _this23 = this;
      var members = this.element.getDescendantInstances(this.disclosureInstanceClassName, this.constructor.instanceClassName, true);
      this._members = members.filter(this.validate.bind(this)).filter(function (member) {
        return member.isEnabled && member.isActive;
      });
      var invalids = members.filter(function (member) {
        return !_this23._members.includes(member);
      });
      invalids.forEach(function (invalid) {
        return invalid.conceal();
      });
    }
  }, {
    key: "retrieve",
    value: function retrieve() {
      var bypassPrevention = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this._isRetrieving || this._hasRetrieved && !bypassPrevention) return;
      this._isRetrieving = true;
      this.request(this._retrieve.bind(this));
    }
  }, {
    key: "_retrieve",
    value: function _retrieve() {
      var _this24 = this;
      this.getMembers();
      this._isRetrieving = false;
      this._hasRetrieved = true;
      if (!this.isGrouped) {
        for (var i = 0; i < this.length; i++) {
          var member = this.members[i];
          if (member.isInitiallyDisclosed) {
            member.disclose(true);
          }
        }
        return;
      }
      if (this.hash) {
        for (var _i4 = 0; _i4 < this.length; _i4++) {
          var _member = this.members[_i4];
          if (this.hash === _member.id) {
            this.index = _i4;
            this.request(function () {
              _this24.ascend(DisclosureEmission.SPOTLIGHT);
            });
            return _i4;
          }
        }
      }
      for (var _i5 = 0; _i5 < this.length; _i5++) {
        var _member2 = this.members[_i5];
        if (_member2.isInitiallyDisclosed) {
          this.index = _i5;
          return _i5;
        }
      }
      return this.getIndex();
    }
  }, {
    key: "update",
    value: function update() {
      this.getMembers();
      if (this._hasRetrieved) {
        if (this.isGrouped) this.getIndex();
      }
    }
  }, {
    key: "members",
    get: function get() {
      return this._members;
    }
  }, {
    key: "length",
    get: function get() {
      return this.members ? this.members.length : 0;
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      var defaultIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      this._index = undefined;
      var index = defaultIndex;
      for (var i = 0; i < this.length; i++) {
        if (this.members[i].isDisclosed) {
          index = i;
          break;
        }
      }
      this.index = index;
      return index;
    }
  }, {
    key: "index",
    get: function get() {
      return this._index;
    },
    set: function set(value) {
      if (value < -1 || value >= this.length || value === this._index) return;
      this._index = value;
      for (var i = 0; i < this.length; i++) {
        var member = this.members[i];
        if (value === i) {
          if (!member.isDisclosed) member.disclose(true);
        } else {
          if ((this.isGrouped || !this.canUngroup) && member.isDisclosed !== false) member.conceal(true);
        }
      }
      this.apply();
      this.dispatch(DisclosureEvent.CURRENT, this.current);
    }
  }, {
    key: "current",
    get: function get() {
      if (this._index === -1 || isNaN(this._index)) return null;
      return this._members[this._index] || null;
    },
    set: function set(member) {
      this.index = this.members.indexOf(member);
    }
  }, {
    key: "hasFocus",
    get: function get() {
      var current = this.current;
      if (current) return current.hasFocus;
      return false;
    }
  }, {
    key: "isGrouped",
    get: function get() {
      return this._isGrouped;
    },
    set: function set(value) {
      var isGrouped = !!value;
      if (this._isGrouped === isGrouped) return;
      this._isGrouped = isGrouped;
      this.setAttribute(DisclosureSelector.GROUP, !!value);
      this.update();
    }
  }, {
    key: "canUngroup",
    get: function get() {
      return false;
    }
  }, {
    key: "mutate",
    value: function mutate(attributesNames) {
      if (attributesNames.includes(DisclosureSelector.GROUP)) {
        this.isGrouped = this.getAttribute(DisclosureSelector.GROUP) !== 'false';
      }
    }
  }, {
    key: "apply",
    value: function apply() {}
  }, {
    key: "dispose",
    value: function dispose() {
      _superPropGet(DisclosuresGroup, "dispose", this, 3)([]);
      this.descend(DisclosureEmission.UNGROUP);
      this._members = null;
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'DisclosuresGroup';
    }
  }]);
}(Instance);
var DisclosureType = {
  EXPAND: {
    id: 'expanded',
    ariaState: true,
    ariaControls: true,
    canConceal: true,
    canDisable: true,
    requirePrimary: true
  },
  SELECT: {
    id: 'selected',
    ariaState: true,
    ariaControls: true,
    canConceal: false,
    canDisable: true,
    requirePrimary: true
  },
  OPENED: {
    id: 'opened',
    ariaState: false,
    ariaControls: true,
    canConceal: true,
    canDisable: false,
    requirePrimary: false
  }
};
var CollapseButton = /*#__PURE__*/function (_DisclosureButton) {
  function CollapseButton() {
    _classCallCheck(this, CollapseButton);
    return _callSuper(this, CollapseButton, [DisclosureType.EXPAND]);
  }
  _inherits(CollapseButton, _DisclosureButton);
  return _createClass(CollapseButton, null, [{
    key: "instanceClassName",
    get: function get() {
      return 'CollapseButton';
    }
  }]);
}(DisclosureButton);
var CollapseSelector = {
  COLLAPSE: ns.selector('collapse'),
  COLLAPSING: ns.selector('collapsing')
};

/**
 * Tab coorespond au panel d'un élement Tabs (tab panel)
 * Tab étend disclosure qui ajoute/enleve le modifier --selected,
 * et ajoute/eleve l'attribut hidden, sur le panel
 */
var Collapse = /*#__PURE__*/function (_Disclosure) {
  function Collapse() {
    _classCallCheck(this, Collapse);
    return _callSuper(this, Collapse, [DisclosureType.EXPAND, CollapseSelector.COLLAPSE, CollapseButton, 'CollapsesGroup']);
  }
  _inherits(Collapse, _Disclosure);
  return _createClass(Collapse, [{
    key: "init",
    value: function init() {
      _superPropGet(Collapse, "init", this, 3)([]);
      this.listen('transitionend', this.endCollapsing.bind(this));
    }
  }, {
    key: "endCollapsing",
    value: function endCollapsing(e) {
      if (!this._isCollpasing) return;
      if (this._timeout) clearTimeout(this._timeout);
      this._timeout = null;
      this._isCollpasing = false;
      this.removeClass(CollapseSelector.COLLAPSING);
      if (!this.isDisclosed) {
        if (this.isLegacy) this.style.maxHeight = '';
      }
    }
  }, {
    key: "unbound",
    value: function unbound() {
      if (this.isLegacy) this.style.maxHeight = 'none';
    }
  }, {
    key: "disclose",
    value: function disclose(withhold) {
      var _this25 = this;
      if (this.isDisclosed === true || !this.isEnabled) return false;
      this.unbound();
      this.collapsing(function () {
        return _superPropGet(Collapse, "disclose", _this25, 3)([withhold]);
      });
    }
  }, {
    key: "conceal",
    value: function conceal(withhold, preventFocus) {
      var _this26 = this;
      if (this.isDisclosed === false) return false;
      this.collapsing(function () {
        return _superPropGet(Collapse, "conceal", _this26, 3)([withhold, preventFocus]);
      });
    }
  }, {
    key: "collapsing",
    value: function collapsing(request) {
      var _this27 = this;
      this._isCollpasing = true;
      if (this._timeout) clearTimeout(this._timeout);
      this.addClass(CollapseSelector.COLLAPSING);
      this.adjust();
      this.request(function () {
        request();
        _this27._timeout = setTimeout(_this27.endCollapsing.bind(_this27), 500);
      });
    }
  }, {
    key: "adjust",
    value: function adjust() {
      this.setProperty('--collapser', 'none');
      var height = this.node.offsetHeight;
      this.setProperty('--collapse', -height + 'px');
      this.setProperty('--collapser', '');
    }
  }, {
    key: "reset",
    value: function reset() {
      if (!this.isPristine) this.isDisclosed = false;
    }
  }, {
    key: "_electPrimaries",
    value: function _electPrimaries(candidates) {
      var primary = this.element.parent.instances.map(function (instance) {
        return instance.collapsePrimary;
      }).filter(function (button) {
        return button !== undefined && candidates.indexOf(button) > -1;
      });
      if (primary.length === 1) return primary;
      candidates = _superPropGet(Collapse, "_electPrimaries", this, 3)([candidates]);
      if (candidates.length === 1) return candidates;
      var before = candidates.filter(function (candidate) {
        return candidate.dy >= 0;
      });
      if (before.length > 0) candidates = before;
      if (candidates.length === 1) return candidates;
      var min = Math.min.apply(Math, _toConsumableArray(candidates.map(function (candidate) {
        return candidate.dy;
      })));
      var mins = candidates.filter(function (candidate) {
        return candidate.dy === min;
      });
      if (mins.length > 0) candidates = mins;
      if (candidates.length === 1) return candidates;
      candidates.sort(function (a, b) {
        return Math.abs(b.dx) - Math.abs(a.dx);
      });
      return candidates;
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Collapse';
    }
  }]);
}(Disclosure);
var CollapsesGroup = /*#__PURE__*/function (_DisclosuresGroup) {
  function CollapsesGroup() {
    _classCallCheck(this, CollapsesGroup);
    return _callSuper(this, CollapsesGroup, ['Collapse']);
  }
  _inherits(CollapsesGroup, _DisclosuresGroup);
  return _createClass(CollapsesGroup, [{
    key: "canUngroup",
    get: function get() {
      return true;
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'CollapsesGroup';
    }
  }]);
}(DisclosuresGroup);
var EquisizedEmission = {
  CHANGE: ns('equisized')
};
var Equisized = /*#__PURE__*/function (_Instance4) {
  function Equisized() {
    _classCallCheck(this, Equisized);
    return _callSuper(this, Equisized, arguments);
  }
  _inherits(Equisized, _Instance4);
  return _createClass(Equisized, [{
    key: "init",
    value: function init() {
      this.ascend(EquisizedEmission.CHANGE);
    }
  }, {
    key: "measure",
    value: function measure() {
      if (this.isLegacy) this.style.width = 'auto';
      return this.getRect().width;
    }
  }, {
    key: "adjust",
    value: function adjust(width) {
      if (this.isLegacy) this.style.width = "".concat(width, "px");
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.ascend(EquisizedEmission.CHANGE);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Equisized';
    }
  }]);
}(Instance);
var EquisizedsGroup = /*#__PURE__*/function (_Instance5) {
  function EquisizedsGroup() {
    _classCallCheck(this, EquisizedsGroup);
    return _callSuper(this, EquisizedsGroup, arguments);
  }
  _inherits(EquisizedsGroup, _Instance5);
  return _createClass(EquisizedsGroup, [{
    key: "init",
    value: function init() {
      this.isResizing = true;
      this.isLoading = true;
      this.addAscent(EquisizedEmission.CHANGE, this.resize.bind(this));
    }
  }, {
    key: "load",
    value: function load() {
      this.resize();
    }
  }, {
    key: "resize",
    value: function resize() {
      var equisizeds = this.element.getDescendantInstances('Equisized');
      if (!this.isLegacy) this.style.setProperty('--equisized-width', 'auto');
      var width = Math.max.apply(Math, _toConsumableArray(equisizeds.map(function (equisized) {
        return equisized.measure();
      })));
      if (this.isLegacy) equisizeds.forEach(function (equisized) {
        return equisized.adjust(width);
      });else this.style.setProperty('--equisized-width', "".concat(width, "px"));
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'EquisizedsGroup';
    }
  }]);
}(Instance);
var Toggle = /*#__PURE__*/function (_Instance6) {
  function Toggle() {
    _classCallCheck(this, Toggle);
    return _callSuper(this, Toggle, arguments);
  }
  _inherits(Toggle, _Instance6);
  return _createClass(Toggle, [{
    key: "init",
    value: function init() {
      this.pressed = this.pressed === 'true';
      this.listenClick();
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.toggle();
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.pressed = this.pressed !== 'true';
    }
  }, {
    key: "pressed",
    get: function get() {
      return this.getAttribute('aria-pressed');
    },
    set: function set(value) {
      this.setAttribute('aria-pressed', value ? 'true' : 'false');
    }
  }, {
    key: "proxy",
    get: function get() {
      var scope = this;
      var proxy = Object.assign(_superPropGet(Toggle, "proxy", this, 1), {
        toggle: scope.toggle.bind(scope)
      });
      var proxyAccessors = {
        get pressed() {
          return scope.pressed;
        },
        set pressed(value) {
          scope.pressed = value;
        }
      };
      return completeAssign(proxy, proxyAccessors);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Toggle';
    }
  }]);
}(Instance);
var RootSelector = {
  ROOT: ':root'
};
var setAttributes = function setAttributes(el, attrs) {
  Object.keys(attrs).forEach(function (key) {
    return el.setAttribute(key, attrs[key]);
  });
};
var InjectSvg = /*#__PURE__*/function (_Instance7) {
  function InjectSvg() {
    _classCallCheck(this, InjectSvg);
    return _callSuper(this, InjectSvg, arguments);
  }
  _inherits(InjectSvg, _Instance7);
  return _createClass(InjectSvg, [{
    key: "init",
    value: function init() {
      if (this.node) {
        this.img = this.node.querySelector('img');
      }
      if (!this.isLegacy) {
        this.replace();
      }
    }
  }, {
    key: "proxy",
    get: function get() {
      var scope = this;
      return Object.assign(_superPropGet(InjectSvg, "proxy", this, 1), {
        replace: scope.replace.bind(scope),
        restore: scope.restore.bind(scope)
      });
    }
  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch() {
        return _fetch.apply(this, arguments);
      }
      fetch.toString = function () {
        return _fetch.toString();
      };
      return fetch;
    }(function () {
      var _this28 = this;
      if (this.img) {
        this.imgID = this.img.getAttribute('id');
        this.imgClass = this.img.getAttribute('class');
        this.imgURL = this.img.getAttribute('src');
        fetch(this.imgURL).then(function (data) {
          return data.text();
        }).then(function (response) {
          var parser = new DOMParser();
          var xmlDoc = parser.parseFromString(response, 'text/html');
          _this28.svg = xmlDoc.querySelector('svg');
          if (_this28.svg) {
            _this28.replace();
          }
        });
      }
    })
  }, {
    key: "replace",
    value: function replace() {
      if (!this.svg) {
        this.fetch();
        return;
      }
      if (this.imgID && typeof this.imgID !== 'undefined') {
        this.svg.setAttribute('id', this.imgID);
      }

      // gestion de la dépréciation
      var name = this.imgURL.match(/[ \w-]+\./)[0];
      if (name) {
        name = name.slice(0, -1);
        if (['dark', 'light', 'system'].includes(name)) {
          this.svg.innerHTML = this.svg.innerHTML.replaceAll('id="artwork-', "id=\"".concat(name, "-artwork-"));
          this.svg.innerHTML = this.svg.innerHTML.replaceAll('"#artwork-', "\"#".concat(name, "-artwork-"));
        }
      }
      if (this.imgClass && typeof this.imgClass !== 'undefined') {
        this.svg.setAttribute('class', this.imgClass);
      }
      if (this.svg.hasAttribute('xmlns:a')) {
        this.svg.removeAttribute('xmlns:a');
      }
      this.node.setAttribute('data-fr-inject-svg', true);
      var svgAttributes = {
        'aria-hidden': true,
        focusable: false
      };
      setAttributes(this.svg, svgAttributes);
      this.node.replaceChild(this.svg, this.img);
    }
  }, {
    key: "restore",
    value: function restore() {
      if (this.img && this.svg) {
        this.node.setAttribute('data-fr-inject-svg', false);
        this.node.replaceChild(this.img, this.svg);
      }
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'InjectSvg';
    }
  }]);
}(Instance);
var InjectSvgSelector = {
  INJECT_SVG: "[".concat(ns.attr('inject-svg'), "]")
};
var Artwork = /*#__PURE__*/function (_Instance8) {
  function Artwork() {
    _classCallCheck(this, Artwork);
    return _callSuper(this, Artwork, arguments);
  }
  _inherits(Artwork, _Instance8);
  return _createClass(Artwork, [{
    key: "init",
    value: function init() {
      if (this.isLegacy) {
        this.replace();
      }
    }
  }, {
    key: "proxy",
    get: function get() {
      var scope = this;
      return Object.assign(_superPropGet(Artwork, "proxy", this, 1), {
        replace: scope.replace.bind(scope)
      });
    }
  }, {
    key: "fetch",
    value: function fetch() {
      var _this29 = this;
      this.xlink = this.node.getAttribute('href');
      var splitUrl = this.xlink.split('#');
      this.svgUrl = splitUrl[0];
      this.svgName = splitUrl[1];
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString(xhr.responseText, 'text/html');
        _this29.realSvgContent = xmlDoc.getElementById(_this29.svgName);
        if (_this29.realSvgContent) {
          if (_this29.realSvgContent.tagName === 'symbol') {
            _this29.use = xmlDoc.querySelector('use[href="#' + _this29.svgName + '"]');
            if (_this29.use) _this29.node.parentNode.insertBefore(_this29.use, _this29.node);
          } else {
            // deprecated svg structure
            _this29.realSvgContent.classList.add(_this29.node.classList);
          }
          _this29.replace();
        }
      };
      xhr.open('GET', this.svgUrl);
      xhr.send();
    }
  }, {
    key: "replace",
    value: function replace() {
      if (!this.realSvgContent) {
        this.fetch();
        return;
      }
      this.node.parentNode.replaceChild(this.realSvgContent, this.node);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Artwork';
    }
  }]);
}(Instance);
var ArtworkSelector = {
  ARTWORK_USE: "".concat(ns.selector('artwork'), " use")
};
var AssessSelector = {
  ASSESS_FILE: "".concat(ns.attr.selector('assess-file')),
  DETAIL: "".concat(ns.attr.selector('assess-file'), " [class$=\"__detail\"], ").concat(ns.attr.selector('assess-file'), " [class*=\"__detail \"]")
};
var AssessEmission = {
  UPDATE: ns.emission('assess', 'update'),
  ADDED: ns.emission('assess', 'added')
};
var AssessFile = /*#__PURE__*/function (_Instance9) {
  function AssessFile() {
    _classCallCheck(this, AssessFile);
    return _callSuper(this, AssessFile, arguments);
  }
  _inherits(AssessFile, _Instance9);
  return _createClass(AssessFile, [{
    key: "init",
    value: function init() {
      this.lang = this.getLang(this.node);
      this.href = this.getAttribute('href');
      this.hreflang = this.getAttribute('hreflang');
      this.file = {};
      this.gather();
      this.addAscent(AssessEmission.ADDED, this.update.bind(this));
      this.addDescent(AssessEmission.ADDED, this.update.bind(this));
    }
  }, {
    key: "getFileLength",
    value: function getFileLength() {
      var _this30 = this;
      if (this.href === undefined) {
        this.length = -1;
        return;
      }
      fetch(this.href, {
        method: 'HEAD',
        mode: 'cors'
      }).then(function (response) {
        if (response.ok) {
          _this30.length = response.headers.get('content-length') || -1;
          if (_this30.length && _this30.length === -1) {
            throw new Error('File size unknown' + '\n Unable to get HTTP header: "content-length"');
          }
          _this30.gather();
        } else {
          throw new Error('Unable to access the resource : Status ' + response.status);
        }
      })["catch"](function (error) {
        _this30.length = -1;
        _this30.gather();
        inspector.warn('Fetch error on assess file : ' + _this30.href + '\n ' + error);
      });
    }
  }, {
    key: "mutate",
    value: function mutate(attributeNames) {
      if (attributeNames.indexOf('href') !== -1) {
        this.href = this.getAttribute('href');
        this.getFileLength();
      }
      if (attributeNames.indexOf('hreflang') !== -1) {
        this.hreflang = this.getAttribute('hreflang');
        this.gather();
      }
    }
  }, {
    key: "gather",
    value: function gather() {
      // TODO V2: implémenter async
      if (this.isLegacy) this.length = -1;
      if (!this.length) {
        this.getFileLength();
      }
      this.details = [];
      if (this.href) {
        var extension = this.parseExtension(this.href);
        if (extension) this.details.push(extension.toUpperCase());
      }
      if (this.length && this.length !== -1) {
        this.details.push(this.bytesToSize(this.length));
      }
      if (this.hreflang) {
        this.details.push(this.getLangDisplayName(this.hreflang));
      }
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      if (!this.details) return;
      this.descend(AssessEmission.UPDATE, this.details);
      this.ascend(AssessEmission.UPDATE, this.details);
    }
  }, {
    key: "getLang",
    value: function getLang(elem) {
      // todo: ajouter un listener global de changement de langue
      if (elem.lang) return elem.lang;
      if (document.documentElement === elem) return window.navigator.language;
      return this.getLang(elem.parentElement);
    }
  }, {
    key: "parseExtension",
    value: function parseExtension(url) {
      var regexExtension = /\.(\w{1,9})(?:$|[?#])/;
      return url.match(regexExtension)[0].replace('.', '');
    }
  }, {
    key: "getLangDisplayName",
    value: function getLangDisplayName(locale) {
      if (this.isLegacy) return locale;
      var displayNames = new Intl.DisplayNames([this.lang], {
        type: 'language'
      });
      var name = displayNames.of(locale);
      return name.charAt(0).toUpperCase() + name.slice(1);
    }
  }, {
    key: "bytesToSize",
    value: function bytesToSize(bytes) {
      if (bytes === -1) return null;
      var sizeUnits = ['octets', 'ko', 'Mo', 'Go', 'To'];
      if (this.getAttribute(ns.attr('assess-file')) === 'bytes') {
        sizeUnits = ['bytes', 'KB', 'MB', 'GB', 'TB'];
      }
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)), 10);
      if (i === 0) return "".concat(bytes, " ").concat(sizeUnits[i]);
      var size = bytes / Math.pow(1000, i);
      var roundedSize = Math.round((size + Number.EPSILON) * 100) / 100; // arrondi a 2 décimal
      var stringSize = String(roundedSize).replace('.', ',');
      return "".concat(stringSize, " ").concat(sizeUnits[i]);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'AssessFile';
    }
  }]);
}(Instance);
var AssessDetail = /*#__PURE__*/function (_Instance0) {
  function AssessDetail() {
    _classCallCheck(this, AssessDetail);
    return _callSuper(this, AssessDetail, arguments);
  }
  _inherits(AssessDetail, _Instance0);
  return _createClass(AssessDetail, [{
    key: "init",
    value: function init() {
      this.addDescent(AssessEmission.UPDATE, this.update.bind(this));
      this.ascend(AssessEmission.ADDED);
    }
  }, {
    key: "update",
    value: function update(details) {
      this.node.innerHTML = details.join(' - ');
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'AssessDetail';
    }
  }]);
}(Instance);
var ratiosImg = ['32x9', '16x9', '3x2', '4x3', '1x1', '3x4', '2x3'];
var ratiosVid = ['16x9', '4x3', '1x1'];
var ratioSelector = function ratioSelector(name, modifiers) {
  return modifiers.map(function (modifier) {
    return ns.selector("".concat(name, "--").concat(modifier));
  }).join(',');
};
var deprecatedRatioSelector = "".concat(ns.selector('responsive-img'), ", ").concat(ratioSelector('responsive-img', ratiosImg), ", ").concat(ns.selector('responsive-vid'), ", ").concat(ratioSelector('responsive-vid', ratiosVid));
var RatioSelector = {
  RATIO: "".concat(ns.selector('ratio'), ", ").concat(ratioSelector('ratio', ratiosImg), ", ").concat(deprecatedRatioSelector)
};
var api = window[config.namespace];
var Ratio = /*#__PURE__*/function (_Instance1) {
  function Ratio() {
    _classCallCheck(this, Ratio);
    return _callSuper(this, Ratio, arguments);
  }
  _inherits(Ratio, _Instance1);
  return _createClass(Ratio, [{
    key: "init",
    value: function init() {
      if (!api.internals.support.supportAspectRatio()) {
        this.ratio = 16 / 9;
        for (var className in this.classNames) {
          if (this.registration.selector.indexOf(this.classNames[className]) > 0) {
            var ratio = this.classNames[className].split('ratio-');
            if (ratio[1]) {
              this.ratio = ratio[1].split('x')[0] / ratio[1].split('x')[1];
            }
          }
        }
        this.isRendering = true;
        this.update();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var width = this.getRect().width;
      if (width !== this.currentWidth) this.update();
    }
  }, {
    key: "update",
    value: function update() {
      this.currentWidth = this.getRect().width;
      this.style.height = this.currentWidth / this.ratio + 'px';
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Ratio';
    }
  }]);
}(Instance);
var PlaceSelector = {
  TOP: ns.selector('placement--top'),
  RIGHT: ns.selector('placement--right'),
  BOTTOM: ns.selector('placement--bottom'),
  LEFT: ns.selector('placement--left')
};
var AlignSelector = {
  START: ns.selector('placement--start'),
  CENTER: ns.selector('placement--center'),
  END: ns.selector('placement--end')
};
var PlacementPosition = {
  TOP: 'place_top',
  RIGHT: 'place_right',
  BOTTOM: 'place_bottom',
  LEFT: 'place_left'
};
var PlacementAlign = {
  START: 'align_start',
  CENTER: 'align_center',
  END: 'align_end'
};
var PlacementMode = {
  AUTO: 'placement_auto',
  MANUAL: 'placement_manual'
};
var Placement = /*#__PURE__*/function (_Instance10) {
  function Placement() {
    var _this31;
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PlacementMode.AUTO;
    var places = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [PlacementPosition.BOTTOM, PlacementPosition.TOP, PlacementPosition.LEFT, PlacementPosition.RIGHT];
    var aligns = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [PlacementAlign.CENTER, PlacementAlign.START, PlacementAlign.END];
    var safeAreaMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 16;
    _classCallCheck(this, Placement);
    _this31 = _callSuper(this, Placement);
    _this31._mode = mode;
    _this31._places = places;
    _this31._aligns = aligns;
    _this31._safeAreaMargin = safeAreaMargin;
    _this31._isShown = false;
    _this31._x = _this31._y = 0;
    return _this31;
  }
  _inherits(Placement, _Instance10);
  return _createClass(Placement, [{
    key: "init",
    value: function init() {
      this.isResizing = true;
    }
  }, {
    key: "proxy",
    get: function get() {
      var scope = this;
      var proxy = Object.assign(_superPropGet(Placement, "proxy", this, 1), {
        show: scope.show.bind(scope),
        hide: scope.hide.bind(scope)
      });
      var proxyAccessors = {
        get mode() {
          return scope.mode;
        },
        set mode(value) {
          scope.mode = value;
        },
        get place() {
          return scope.place;
        },
        set place(value) {
          scope.place = value;
        },
        get align() {
          return scope.align;
        },
        set align(value) {
          scope.align = value;
        },
        get isShown() {
          return scope.isShown;
        },
        set isShown(value) {
          scope.isShown = value;
        }
      };
      return completeAssign(proxy, proxyAccessors);
    }
  }, {
    key: "mode",
    get: function get() {
      return this._mode;
    },
    set: function set(value) {
      this._mode = value;
    }
  }, {
    key: "place",
    get: function get() {
      return this._place;
    },
    set: function set(value) {
      if (this._place === value) return;
      switch (this._place) {
        case PlacementPosition.TOP:
          this.removeClass(PlaceSelector.TOP);
          break;
        case PlacementPosition.RIGHT:
          this.removeClass(PlaceSelector.RIGHT);
          break;
        case PlacementPosition.BOTTOM:
          this.removeClass(PlaceSelector.BOTTOM);
          break;
        case PlacementPosition.LEFT:
          this.removeClass(PlaceSelector.LEFT);
          break;
      }
      this._place = value;
      switch (this._place) {
        case PlacementPosition.TOP:
          this.addClass(PlaceSelector.TOP);
          break;
        case PlacementPosition.RIGHT:
          this.addClass(PlaceSelector.RIGHT);
          break;
        case PlacementPosition.BOTTOM:
          this.addClass(PlaceSelector.BOTTOM);
          break;
        case PlacementPosition.LEFT:
          this.addClass(PlaceSelector.LEFT);
          break;
      }
    }
  }, {
    key: "align",
    get: function get() {
      return this._align;
    },
    set: function set(value) {
      if (this._align === value) return;
      switch (this._align) {
        case PlacementAlign.START:
          this.removeClass(AlignSelector.START);
          break;
        case PlacementAlign.CENTER:
          this.removeClass(AlignSelector.CENTER);
          break;
        case PlacementAlign.END:
          this.removeClass(AlignSelector.END);
          break;
      }
      this._align = value;
      switch (this._align) {
        case PlacementAlign.START:
          this.addClass(AlignSelector.START);
          break;
        case PlacementAlign.CENTER:
          this.addClass(AlignSelector.CENTER);
          break;
        case PlacementAlign.END:
          this.addClass(AlignSelector.END);
          break;
      }
    }
  }, {
    key: "show",
    value: function show() {
      this.isShown = true;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.isShown = false;
    }
  }, {
    key: "isShown",
    get: function get() {
      return this._isShown;
    },
    set: function set(value) {
      if (this._isShown === value || !this.isEnabled) return;
      this.isRendering = value;
      this._isShown = value;
    }
  }, {
    key: "setReferent",
    value: function setReferent(referent) {
      this._referent = referent;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this._referent) return;
      this.referentRect = this._referent.getRect();
      this.rect = this.getRect();
      this.safeArea = this.getSafeArea();
      if (this.mode === PlacementMode.AUTO) {
        this.place = this.getPlace();
        switch (this.place) {
          case PlacementPosition.TOP:
          case PlacementPosition.BOTTOM:
            this.align = this.getHorizontalAlign();
            break;
          case PlacementPosition.LEFT:
          case PlacementPosition.RIGHT:
            this.align = this.getVerticalAlign();
        }
      }
      var x, y;
      switch (this.place) {
        case PlacementPosition.TOP:
          y = this.referentRect.top - this.rect.top - this.rect.height;
          break;
        case PlacementPosition.RIGHT:
          x = this.referentRect.left - this.rect.left + this.referentRect.width;
          break;
        case PlacementPosition.BOTTOM:
          y = this.referentRect.top - this.rect.top + this.referentRect.height;
          break;
        case PlacementPosition.LEFT:
          x = this.referentRect.left - this.rect.left - this.rect.width;
          break;
      }
      switch (this.place) {
        case PlacementPosition.TOP:
        case PlacementPosition.BOTTOM:
          switch (this.align) {
            case PlacementAlign.CENTER:
              x = this.referentRect.left - this.rect.left + this.referentRect.width * 0.5 - this.rect.width * 0.5;
              break;
            case PlacementAlign.START:
              x = this.referentRect.left - this.rect.left;
              break;
            case PlacementAlign.END:
              x = this.referentRect.left - this.rect.left + this.referentRect.width - this.rect.width;
              break;
          }
          break;
        case PlacementPosition.RIGHT:
        case PlacementPosition.LEFT:
          switch (this.align) {
            case PlacementAlign.CENTER:
              y = this.referentRect.top - this.rect.top + this.referentRect.height * 0.5 - this.rect.height * 0.5;
              break;
            case PlacementAlign.START:
              y = this.referentRect.top - this.rect.top;
              break;
            case PlacementAlign.END:
              y = this.referentRect.top - this.rect.top - this.rect.height;
              break;
          }
          break;
      }
      this._x += x + 0.5 | 0;
      this._y += y + 0.5 | 0;
      this.node.style.transform = "translate(".concat(this._x, "px,").concat(this._y, "px)");
    }
  }, {
    key: "getPlace",
    value: function getPlace() {
      var _iterator26 = _createForOfIteratorHelper(this._places),
        _step26;
      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var place = _step26.value;
          switch (place) {
            case PlacementPosition.TOP:
              if (this.referentRect.top - this.rect.height > this.safeArea.top) return PlacementPosition.TOP;
              break;
            case PlacementPosition.RIGHT:
              if (this.referentRect.right + this.rect.width < this.safeArea.right) return PlacementPosition.RIGHT;
              break;
            case PlacementPosition.BOTTOM:
              if (this.referentRect.bottom + this.rect.height < this.safeArea.bottom) return PlacementPosition.BOTTOM;
              break;
            case PlacementPosition.LEFT:
              if (this.referentRect.left - this.rect.width > this.safeArea.left) return PlacementPosition.LEFT;
              break;
          }
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
      return this._places[0];
    }
  }, {
    key: "getHorizontalAlign",
    value: function getHorizontalAlign() {
      var _iterator27 = _createForOfIteratorHelper(this._aligns),
        _step27;
      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var align = _step27.value;
          switch (align) {
            case PlacementAlign.CENTER:
              if (this.referentRect.center - this.rect.width * 0.5 > this.safeArea.left && this.referentRect.center + this.rect.width * 0.5 < this.safeArea.right) return PlacementAlign.CENTER;
              break;
            case PlacementAlign.START:
              if (this.referentRect.left + this.rect.width < this.safeArea.right) return PlacementAlign.START;
              break;
            case PlacementAlign.END:
              if (this.referentRect.right - this.rect.width > this.safeArea.left) return PlacementAlign.END;
              break;
          }
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
      return this._aligns[0];
    }
  }, {
    key: "getVerticalAlign",
    value: function getVerticalAlign() {
      var _iterator28 = _createForOfIteratorHelper(this._aligns),
        _step28;
      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var align = _step28.value;
          switch (align) {
            case PlacementAlign.CENTER:
              if (this.referentRect.middle - this.rect.height * 0.5 > this.safeArea.top && this.referentRect.middle + this.rect.height * 0.5 < this.safeArea.bottom) return PlacementAlign.CENTER;
              break;
            case PlacementAlign.START:
              if (this.referentRect.top + this.rect.height < this.safeArea.bottom) return PlacementAlign.START;
              break;
            case PlacementAlign.END:
              if (this.referentRect.bottom - this.rect.height > this.safeArea.top) return PlacementAlign.END;
              break;
          }
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }
      return this._aligns[0];
    }
  }, {
    key: "getSafeArea",
    value: function getSafeArea() {
      var element = this.node;
      var isX, isY;
      var top = this._safeAreaMargin;
      var right = window.innerWidth - this._safeAreaMargin;
      var bottom = window.innerHeight - this._safeAreaMargin;
      var left = this._safeAreaMargin;
      while (element) {
        if (element === document.body) break;
        element = element.parentElement;
        var style = window.getComputedStyle(element);
        var overflow = /(visible|(\w+))(\s(visible|(\w+)))?/.exec(style.overflow);
        isX = overflow[2] !== undefined;
        isY = overflow[3] !== undefined ? overflow[5] !== undefined : overflow[2] !== undefined;
        if (!isX && !isY) continue;
        var rect = element.getBoundingClientRect();
        if (isX) {
          if (rect.left > left) left = rect.left;
          if (rect.right < right) right = rect.right;
        }
        if (isY) {
          if (rect.top > top) top = rect.top;
          if (rect.bottom < bottom) bottom = rect.bottom;
        }
      }
      return {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        center: left + (right - left) * 0.5,
        middle: top + (bottom - top) * 0.5
      };
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._referent = null;
      _superPropGet(Placement, "dispose", this, 3)([]);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Placement';
    }
  }]);
}(Instance);
var PlacementReferent = /*#__PURE__*/function (_Instance11) {
  function PlacementReferent() {
    var _this32;
    _classCallCheck(this, PlacementReferent);
    _this32 = _callSuper(this, PlacementReferent);
    _this32._isShown = false;
    return _this32;
  }
  _inherits(PlacementReferent, _Instance11);
  return _createClass(PlacementReferent, [{
    key: "init",
    value: function init() {
      this.registration.creator.setReferent(this);
      this._placement = this.registration.creator;
    }
  }, {
    key: "placement",
    get: function get() {
      return this._placement;
    }
  }, {
    key: "isShown",
    get: function get() {
      return this._isShown;
    },
    set: function set(value) {
      if (this._isShown === value || !this.isEnabled) return;
      this._isShown = value;
      if (value) this.registration.creator.show();else this.registration.creator.hide();
    }
  }, {
    key: "show",
    value: function show() {
      this.isShown = true;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.isShown = false;
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'PlacementReferent';
    }
  }]);
}(Instance);
api$1.core = {
  Instance: Instance,
  Breakpoints: Breakpoints,
  KeyCodes: KeyCodes,
  Disclosure: Disclosure,
  DisclosureButton: DisclosureButton,
  DisclosuresGroup: DisclosuresGroup,
  DisclosureType: DisclosureType,
  DisclosureEvent: DisclosureEvent,
  DisclosureSelector: DisclosureSelector,
  DisclosureEmission: DisclosureEmission,
  Collapse: Collapse,
  CollapseButton: CollapseButton,
  CollapsesGroup: CollapsesGroup,
  CollapseSelector: CollapseSelector,
  RootSelector: RootSelector,
  RootEmission: RootEmission,
  Equisized: Equisized,
  EquisizedEmission: EquisizedEmission,
  Toggle: Toggle,
  EquisizedsGroup: EquisizedsGroup,
  InjectSvg: InjectSvg,
  InjectSvgSelector: InjectSvgSelector,
  Artwork: Artwork,
  ArtworkSelector: ArtworkSelector,
  AssessFile: AssessFile,
  AssessDetail: AssessDetail,
  AssessEmission: AssessEmission,
  AssessSelector: AssessSelector,
  Ratio: Ratio,
  RatioSelector: RatioSelector,
  Placement: Placement,
  PlacementReferent: PlacementReferent,
  PlacementAlign: PlacementAlign,
  PlacementPosition: PlacementPosition,
  PlacementMode: PlacementMode
};
api$1.internals.register(api$1.core.CollapseSelector.COLLAPSE, api$1.core.Collapse);
api$1.internals.register(api$1.core.InjectSvgSelector.INJECT_SVG, api$1.core.InjectSvg);
api$1.internals.register(api$1.core.RatioSelector.RATIO, api$1.core.Ratio);
api$1.internals.register(api$1.core.AssessSelector.ASSESS_FILE, api$1.core.AssessFile);
api$1.internals.register(api$1.core.AssessSelector.DETAIL, api$1.core.AssessDetail);
var SchemeValue = {
  SYSTEM: 'system',
  LIGHT: 'light',
  DARK: 'dark'
};
var SchemeAttribute = {
  THEME: api.internals.ns.attr('theme'),
  SCHEME: api.internals.ns.attr('scheme'),
  TRANSITION: api.internals.ns.attr('transition')
};
var SchemeTheme = {
  LIGHT: 'light',
  DARK: 'dark'
};
var SchemeEmission = {
  SCHEME: api.internals.ns.emission('scheme', 'scheme'),
  THEME: api.internals.ns.emission('scheme', 'theme'),
  ASK: api.internals.ns.emission('scheme', 'ask')
};
var SchemeEvent = {
  SCHEME: api.internals.ns.event('scheme'),
  THEME: api.internals.ns.event('theme')
};
var Scheme = /*#__PURE__*/function (_api$core$Instance) {
  function Scheme() {
    _classCallCheck(this, Scheme);
    return _callSuper(this, Scheme, [false]);
  }
  _inherits(Scheme, _api$core$Instance);
  return _createClass(Scheme, [{
    key: "init",
    value: function init() {
      this.changing = this.change.bind(this);
      if (this.hasAttribute(SchemeAttribute.TRANSITION)) {
        this.removeAttribute(SchemeAttribute.TRANSITION);
        this.request(this.restoreTransition.bind(this));
      }
      var scheme = api.internals.support.supportLocalStorage() ? localStorage.getItem('scheme') : '';
      var schemeAttr = this.getAttribute(SchemeAttribute.SCHEME);
      switch (scheme) {
        case SchemeValue.DARK:
        case SchemeValue.LIGHT:
        case SchemeValue.SYSTEM:
          this.scheme = scheme;
          break;
        default:
          switch (schemeAttr) {
            case SchemeValue.DARK:
              this.scheme = SchemeValue.DARK;
              break;
            case SchemeValue.LIGHT:
              this.scheme = SchemeValue.LIGHT;
              break;
            default:
              this.scheme = SchemeValue.SYSTEM;
          }
      }
      this.addAscent(SchemeEmission.ASK, this.ask.bind(this));
      this.addAscent(SchemeEmission.SCHEME, this.apply.bind(this));
    }
  }, {
    key: "proxy",
    get: function get() {
      var scope = this;
      var proxyAccessors = {
        get scheme() {
          return scope.scheme;
        },
        set scheme(value) {
          scope.scheme = value;
        }
      };
      return api.internals.property.completeAssign(_superPropGet(Scheme, "proxy", this, 1), proxyAccessors);
    }
  }, {
    key: "restoreTransition",
    value: function restoreTransition() {
      this.setAttribute(SchemeAttribute.TRANSITION, '');
    }
  }, {
    key: "ask",
    value: function ask() {
      this.descend(SchemeEmission.SCHEME, this.scheme);
    }
  }, {
    key: "apply",
    value: function apply(value) {
      this.scheme = value;
    }
  }, {
    key: "scheme",
    get: function get() {
      return this._scheme;
    },
    set: function set(value) {
      if (this._scheme === value) return;
      this._scheme = value;
      switch (value) {
        case SchemeValue.SYSTEM:
          this.listenPreferences();
          break;
        case SchemeValue.DARK:
          this.unlistenPreferences();
          this.theme = SchemeTheme.DARK;
          break;
        case SchemeValue.LIGHT:
          this.unlistenPreferences();
          this.theme = SchemeTheme.LIGHT;
          break;
        default:
          this.scheme = SchemeValue.SYSTEM;
          return;
      }
      this.descend(SchemeEmission.SCHEME, value);
      if (api.internals.support.supportLocalStorage()) {
        localStorage.setItem('scheme', value);
      }
      this.setAttribute(SchemeAttribute.SCHEME, value);
      this.dispatch(SchemeEvent.SCHEME, {
        scheme: this._scheme
      }, false);
    }
  }, {
    key: "theme",
    get: function get() {
      return this._theme;
    },
    set: function set(value) {
      if (this._theme === value) return;
      switch (value) {
        case SchemeTheme.LIGHT:
        case SchemeTheme.DARK:
          this._theme = value;
          this.setAttribute(SchemeAttribute.THEME, value);
          this.descend(SchemeEmission.THEME, value);
          this.dispatch(SchemeEvent.THEME, {
            theme: this._theme
          }, false);
          document.documentElement.style.colorScheme = value === SchemeTheme.DARK ? 'dark' : '';
          break;
      }
    }
  }, {
    key: "listenPreferences",
    value: function listenPreferences() {
      if (this.isListening) return;
      this.isListening = true;
      this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      if (this.mediaQuery.addEventListener) this.mediaQuery.addEventListener('change', this.changing);
      this.change();
    }
  }, {
    key: "unlistenPreferences",
    value: function unlistenPreferences() {
      if (!this.isListening) return;
      this.isListening = false;
      this.mediaQuery.removeEventListener('change', this.changing);
      this.mediaQuery = null;
    }
  }, {
    key: "change",
    value: function change() {
      if (!this.isListening) return;
      this.theme = this.mediaQuery.matches ? SchemeTheme.DARK : SchemeTheme.LIGHT;
    }
  }, {
    key: "mutate",
    value: function mutate(attributeNames) {
      if (attributeNames.indexOf(SchemeAttribute.SCHEME) > -1) this.scheme = this.getAttribute(SchemeAttribute.SCHEME);
      if (attributeNames.indexOf(SchemeAttribute.THEME) > -1) this.theme = this.getAttribute(SchemeAttribute.THEME);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.unlistenPreferences();
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Scheme';
    }
  }]);
}(api.core.Instance);
var SchemeSelector = {
  SCHEME: ":root".concat(api.internals.ns.attr.selector('theme'), ", :root").concat(api.internals.ns.attr.selector('scheme')),
  SWITCH_THEME: api.internals.ns.selector('switch-theme'),
  RADIO_BUTTONS: "input[name=\"".concat(api.internals.ns('radios-theme'), "\"]")
};
api.scheme = {
  Scheme: Scheme,
  SchemeValue: SchemeValue,
  SchemeSelector: SchemeSelector,
  SchemeEmission: SchemeEmission,
  SchemeTheme: SchemeTheme,
  SchemeEvent: SchemeEvent
};
api.internals.register(api.scheme.SchemeSelector.SCHEME, api.scheme.Scheme);
var ACCORDION = api.internals.ns.selector('accordion');
var COLLAPSE$2 = api.internals.ns.selector('collapse');
var AccordionSelector = {
  GROUP: api.internals.ns.selector('accordions-group'),
  ACCORDION: ACCORDION,
  COLLAPSE: "".concat(ACCORDION, " > ").concat(COLLAPSE$2, ", ").concat(ACCORDION, " > *:not(").concat(ACCORDION, "):not(").concat(COLLAPSE$2, ") > ").concat(COLLAPSE$2, ", ").concat(ACCORDION, " > *:not(").concat(ACCORDION, "):not(").concat(COLLAPSE$2, ") > *:not(").concat(ACCORDION, "):not(").concat(COLLAPSE$2, ") > ").concat(COLLAPSE$2),
  COLLAPSE_LEGACY: "".concat(ACCORDION, " ").concat(COLLAPSE$2),
  BUTTON: "".concat(ACCORDION, "__btn")
};
var Accordion = /*#__PURE__*/function (_api$core$Instance2) {
  function Accordion() {
    _classCallCheck(this, Accordion);
    return _callSuper(this, Accordion, arguments);
  }
  _inherits(Accordion, _api$core$Instance2);
  return _createClass(Accordion, [{
    key: "collapsePrimary",
    get: function get() {
      var buttons = this.element.children.map(function (child) {
        return child.getInstance('CollapseButton');
      }).filter(function (button) {
        return button !== null && button.hasClass(AccordionSelector.BUTTON);
      });
      return buttons[0];
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Accordion';
    }
  }]);
}(api.core.Instance);
var AccordionsGroup = /*#__PURE__*/function (_api$core$CollapsesGr) {
  function AccordionsGroup() {
    _classCallCheck(this, AccordionsGroup);
    return _callSuper(this, AccordionsGroup, arguments);
  }
  _inherits(AccordionsGroup, _api$core$CollapsesGr);
  return _createClass(AccordionsGroup, [{
    key: "validate",
    value: function validate(member) {
      var match = member.node.matches(api.internals.legacy.isLegacy ? AccordionSelector.COLLAPSE_LEGACY : AccordionSelector.COLLAPSE);
      return _superPropGet(AccordionsGroup, "validate", this, 3)([member]) && match;
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'AccordionsGroup';
    }
  }]);
}(api.core.CollapsesGroup);
api.accordion = {
  Accordion: Accordion,
  AccordionSelector: AccordionSelector,
  AccordionsGroup: AccordionsGroup
};
api.internals.register(api.accordion.AccordionSelector.GROUP, api.accordion.AccordionsGroup);
api.internals.register(api.accordion.AccordionSelector.ACCORDION, api.accordion.Accordion);
var ButtonSelector = {
  EQUISIZED_BUTTON: "".concat(api.internals.ns.selector('btns-group--equisized'), " ").concat(api.internals.ns.selector('btn')),
  EQUISIZED_GROUP: api.internals.ns.selector('btns-group--equisized')
};
api.button = {
  ButtonSelector: ButtonSelector
};
api.internals.register(api.button.ButtonSelector.EQUISIZED_BUTTON, api.core.Equisized);
api.internals.register(api.button.ButtonSelector.EQUISIZED_GROUP, api.core.EquisizedsGroup);
var CardDownload = /*#__PURE__*/function (_api$core$Instance3) {
  function CardDownload() {
    _classCallCheck(this, CardDownload);
    return _callSuper(this, CardDownload, arguments);
  }
  _inherits(CardDownload, _api$core$Instance3);
  return _createClass(CardDownload, [{
    key: "init",
    value: function init() {
      var _this33 = this;
      this.addAscent(api.core.AssessEmission.UPDATE, function (details) {
        _this33.descend(api.core.AssessEmission.UPDATE, details);
      });
      this.addAscent(api.core.AssessEmission.ADDED, function () {
        _this33.descend(api.core.AssessEmission.ADDED);
      });
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'CardDownload';
    }
  }]);
}(api.core.Instance);
var CardSelector = {
  DOWNLOAD: api.internals.ns.selector('card--download'),
  DOWNLOAD_DETAIL: "".concat(api.internals.ns.selector('card--download'), " ").concat(api.internals.ns.selector('card__end'), " ").concat(api.internals.ns.selector('card__detail'))
};
api.card = {
  CardSelector: CardSelector,
  CardDownload: CardDownload
};
api.internals.register(api.card.CardSelector.DOWNLOAD, api.card.CardDownload);
api.internals.register(api.card.CardSelector.DOWNLOAD_DETAIL, api.core.AssessDetail);
var CheckboxSelector = {
  INPUT: "".concat(api.internals.ns.selector('checkbox-group'), " input[type=\"checkbox\"]")
};
var CheckboxEmission = {
  CHANGE: api.internals.ns.emission('checkbox', 'change'),
  RETRIEVE: api.internals.ns.emission('checkbox', 'retrieve')
};
var CheckboxInput = /*#__PURE__*/function (_api$core$Instance4) {
  function CheckboxInput() {
    var _this34;
    _classCallCheck(this, CheckboxInput);
    _this34 = _callSuper(this, CheckboxInput);
    _this34._handlingChange = _this34.handleChange.bind(_this34);
    return _this34;
  }
  _inherits(CheckboxInput, _api$core$Instance4);
  return _createClass(CheckboxInput, [{
    key: "init",
    value: function init() {
      this.node.addEventListener('change', this._handlingChange);
      this.addDescent(CheckboxEmission.RETRIEVE, this._handlingChange);
      this.handleChange();
    }
  }, {
    key: "isChecked",
    get: function get() {
      return this.node.checked;
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      this.ascend(CheckboxEmission.CHANGE, this.node);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'CheckboxInput';
    }
  }]);
}(api.core.Instance);
api.checkbox = {
  CheckboxSelector: CheckboxSelector,
  CheckboxEmission: CheckboxEmission,
  CheckboxInput: CheckboxInput
};
api.internals.register(api.checkbox.CheckboxSelector.INPUT, api.checkbox.CheckboxInput);
var SegmentedSelector = {
  SEGMENTED: api.internals.ns.selector('segmented'),
  SEGMENTED_ELEMENTS: api.internals.ns.selector('segmented__elements'),
  SEGMENTED_ELEMENT: api.internals.ns.selector('segmented__element input'),
  SEGMENTED_LEGEND: api.internals.ns.selector('segmented__legend')
};
var SegmentedEmission = {
  ADDED: api.internals.ns.emission('segmented', 'added'),
  REMOVED: api.internals.ns.emission('segmented', 'removed')
};
var Segmented = /*#__PURE__*/function (_api$core$Instance5) {
  function Segmented() {
    _classCallCheck(this, Segmented);
    return _callSuper(this, Segmented, arguments);
  }
  _inherits(Segmented, _api$core$Instance5);
  return _createClass(Segmented, [{
    key: "init",
    value: function init() {
      this.elements = this.node.querySelector(SegmentedSelector.SEGMENTED_ELEMENTS);
      this.legend = this.node.querySelector(SegmentedSelector.SEGMENTED_LEGEND);
      this.addAscent(SegmentedEmission.ADDED, this.resize.bind(this));
      this.addAscent(SegmentedEmission.REMOVED, this.resize.bind(this));
      this._isLegendInline = this.legend && this.legend.classList.contains("".concat(api.prefix, "-segmented__legend--inline"));
      this.isResizing = true;
    }
  }, {
    key: "resize",
    value: function resize() {
      var SEGMENTED_VERTICAL = "".concat(api.prefix, "-segmented--vertical");
      var LEGEND_INLINE = "".concat(api.prefix, "-segmented__legend--inline");
      var gapOffset = 16;
      this.removeClass(SEGMENTED_VERTICAL);
      if (this._isLegendInline) {
        this.legend.classList.add(LEGEND_INLINE);
        if (this.node.offsetWidth > this.node.parentNode.offsetWidth || this.elements.scrollWidth + this.legend.offsetWidth + gapOffset > this.node.parentNode.offsetWidth) {
          this.legend.classList.remove(LEGEND_INLINE);
        }
      }
      if (this.elements.offsetWidth > this.node.parentNode.offsetWidth || this.elements.scrollWidth > this.node.parentNode.offsetWidth) {
        this.addClass(SEGMENTED_VERTICAL);
      } else {
        this.removeClass(SEGMENTED_VERTICAL);
      }
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Segmented';
    }
  }]);
}(api.core.Instance);
var SegmentedElement = /*#__PURE__*/function (_api$core$Instance6) {
  function SegmentedElement() {
    _classCallCheck(this, SegmentedElement);
    return _callSuper(this, SegmentedElement, arguments);
  }
  _inherits(SegmentedElement, _api$core$Instance6);
  return _createClass(SegmentedElement, [{
    key: "init",
    value: function init() {
      this.ascend(SegmentedEmission.ADDED);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.ascend(SegmentedEmission.REMOVED);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'SegmentedElement';
    }
  }]);
}(api.core.Instance);
api.segmented = {
  SegmentedSelector: SegmentedSelector,
  SegmentedEmission: SegmentedEmission,
  SegmentedElement: SegmentedElement,
  Segmented: Segmented
};
api.internals.register(api.segmented.SegmentedSelector.SEGMENTED, api.segmented.Segmented);
api.internals.register(api.segmented.SegmentedSelector.SEGMENTED_ELEMENT, api.segmented.SegmentedElement);
var BreadcrumbSelector = {
  BREADCRUMB: api.internals.ns.selector('breadcrumb'),
  BUTTON: api.internals.ns.selector('breadcrumb__button')
};
var Breadcrumb = /*#__PURE__*/function (_api$core$Instance7) {
  function Breadcrumb() {
    var _this35;
    _classCallCheck(this, Breadcrumb);
    _this35 = _callSuper(this, Breadcrumb);
    _this35.count = 0;
    _this35.focusing = _this35.focus.bind(_this35);
    return _this35;
  }
  _inherits(Breadcrumb, _api$core$Instance7);
  return _createClass(Breadcrumb, [{
    key: "init",
    value: function init() {
      this.getCollapse();
      this.isResizing = true;
    }
  }, {
    key: "proxy",
    get: function get() {
      var scope = this;
      return Object.assign(_superPropGet(Breadcrumb, "proxy", this, 1), {
        focus: scope.focus.bind(scope),
        disclose: scope.collapse.disclose.bind(scope.collapse)
      });
    }
  }, {
    key: "getCollapse",
    value: function getCollapse() {
      var collapse = this.collapse;
      if (collapse) {
        collapse.listen(api.core.DisclosureEvent.DISCLOSE, this.focusing);
      } else {
        this.addAscent(api.core.DisclosureEmission.ADDED, this.getCollapse.bind(this));
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      var collapse = this.collapse;
      var links = this.links;
      if (!collapse || !links.length) return;
      if (this.isBreakpoint(api.core.Breakpoints.MD)) {
        if (collapse.buttonHasFocus) links[0].focus();
      } else {
        if (links.indexOf(document.activeElement) > -1) collapse.focus();
      }
    }
  }, {
    key: "links",
    get: function get() {
      return _toConsumableArray(this.querySelectorAll('a[href]'));
    }
  }, {
    key: "collapse",
    get: function get() {
      return this.element.getDescendantInstances(api.core.Collapse.instanceClassName, null, true)[0];
    }
  }, {
    key: "focus",
    value: function focus() {
      this.count = 0;
      this._focus();
    }
  }, {
    key: "_focus",
    value: function _focus() {
      var link = this.links[0];
      if (!link) return;
      link.focus();
      this.request(this.verify.bind(this));
    }
  }, {
    key: "verify",
    value: function verify() {
      this.count++;
      if (this.count > 100) return;
      var link = this.links[0];
      if (!link) return;
      if (document.activeElement !== link) this._focus();
    }
  }, {
    key: "collapsePrimary",
    get: function get() {
      var buttons = this.element.children.map(function (child) {
        return child.getInstance('CollapseButton');
      }).filter(function (button) {
        return button !== null && button.hasClass(BreadcrumbSelector.BUTTON);
      });
      return buttons[0];
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Breadcrumb';
    }
  }]);
}(api.core.Instance);
api.breadcrumb = {
  BreadcrumbSelector: BreadcrumbSelector,
  Breadcrumb: Breadcrumb
};
api.internals.register(api.breadcrumb.BreadcrumbSelector.BREADCRUMB, api.breadcrumb.Breadcrumb);
var TooltipSelector = {
  TOOLTIP: api.internals.ns.selector('tooltip'),
  SHOWN: api.internals.ns.selector('tooltip--shown'),
  HIDDING: api.internals.ns.selector('tooltip--hidding'),
  BUTTON: api.internals.ns.selector('btn--tooltip')
};
var TooltipReferentState = {
  FOCUS: 1 << 0,
  HOVER: 1 << 1
};
var TooltipReferent = /*#__PURE__*/function (_api$core$PlacementRe) {
  function TooltipReferent() {
    var _this36;
    _classCallCheck(this, TooltipReferent);
    _this36 = _callSuper(this, TooltipReferent);
    _this36._state = 0;
    return _this36;
  }
  _inherits(TooltipReferent, _api$core$PlacementRe);
  return _createClass(TooltipReferent, [{
    key: "init",
    value: function init() {
      _superPropGet(TooltipReferent, "init", this, 3)([]);
      this.listen('focusin', this.focusIn.bind(this));
      this.listen('focusout', this.focusOut.bind(this));
      if (!this.matches(TooltipSelector.BUTTON)) {
        var mouseover = this.mouseover.bind(this);
        this.listen('mouseover', mouseover);
        this.placement.listen('mouseover', mouseover);
        var mouseout = this.mouseout.bind(this);
        this.listen('mouseout', mouseout);
        this.placement.listen('mouseout', mouseout);
      }
      this.addEmission(api.core.RootEmission.KEYDOWN, this._keydown.bind(this));
      this.listen('click', this._click.bind(this));
      this.addEmission(api.core.RootEmission.CLICK, this._clickOut.bind(this));
    }
  }, {
    key: "_click",
    value: function _click() {
      this.focusIn();
    }
  }, {
    key: "_clickOut",
    value: function _clickOut(target) {
      if (!this.node.contains(target)) this.blur();
    }
  }, {
    key: "_keydown",
    value: function _keydown(keyCode) {
      switch (keyCode) {
        case api.core.KeyCodes.ESCAPE:
          this.close();
          break;
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.state = 0;
    }
  }, {
    key: "state",
    get: function get() {
      return this._state;
    },
    set: function set(value) {
      if (this._state === value) return;
      this.isShown = value > 0;
      this._state = value;
    }
  }, {
    key: "focusIn",
    value: function focusIn() {
      this.state |= TooltipReferentState.FOCUS;
    }
  }, {
    key: "focusOut",
    value: function focusOut() {
      this.state &= ~TooltipReferentState.FOCUS;
    }
  }, {
    key: "mouseover",
    value: function mouseover() {
      this.state |= TooltipReferentState.HOVER;
    }
  }, {
    key: "mouseout",
    value: function mouseout() {
      this.state &= ~TooltipReferentState.HOVER;
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'TooltipReferent';
    }
  }]);
}(api.core.PlacementReferent);
var TooltipEvent = {
  SHOW: ns.event('show'),
  HIDE: ns.event('hide')
};
var TooltipState = {
  HIDDEN: 'hidden',
  SHOWN: 'shown',
  HIDING: 'hiding'
};
var Tooltip = /*#__PURE__*/function (_api$core$Placement) {
  function Tooltip() {
    var _this37;
    _classCallCheck(this, Tooltip);
    _this37 = _callSuper(this, Tooltip, [api.core.PlacementMode.AUTO, [api.core.PlacementPosition.TOP, api.core.PlacementPosition.BOTTOM], [api.core.PlacementAlign.CENTER, api.core.PlacementAlign.START, api.core.PlacementAlign.END]]);
    _this37.modifier = '';
    _this37._state = TooltipState.HIDDEN;
    return _this37;
  }
  _inherits(Tooltip, _api$core$Placement);
  return _createClass(Tooltip, [{
    key: "init",
    value: function init() {
      _superPropGet(Tooltip, "init", this, 3)([]);
      this.register("[aria-describedby=\"".concat(this.id, "\"]"), TooltipReferent);
      this.listen('transitionend', this.transitionEnd.bind(this));
    }
  }, {
    key: "transitionEnd",
    value: function transitionEnd() {
      if (this._state === TooltipState.HIDING) {
        this.removeClass(TooltipSelector.SHOWN);
        this.removeClass(TooltipSelector.HIDDING);
        this._state = TooltipState.HIDDEN;
        this.isShown = false;
      }
    }
  }, {
    key: "isShown",
    get: function get() {
      return _superPropGet(Tooltip, "isShown", this, 1);
    },
    set: function set(value) {
      if (!this.isEnabled) return;
      switch (true) {
        case value:
          this._state = TooltipState.SHOWN;
          this.addClass(TooltipSelector.SHOWN);
          this.removeClass(TooltipSelector.HIDDING);
          this.dispatch(TooltipEvent.SHOW);
          _superPropSet(Tooltip, "isShown", true, this, 1, 1);
          break;
        case this.isShown && !value && this._state === TooltipState.SHOWN:
          this._state = TooltipState.HIDING;
          this.addClass(TooltipSelector.HIDDING);
          break;
        case this.isShown && !value && this._state === TooltipState.HIDDEN:
          this.dispatch(TooltipEvent.HIDE);
          this.removeClass(TooltipSelector.HIDDING);
          _superPropSet(Tooltip, "isShown", false, this, 1, 1);
          break;
      }
    }
  }, {
    key: "render",
    value: function render() {
      _superPropGet(Tooltip, "render", this, 3)([]);
      this.rect = this.getRect();
      var x = this.referentRect.center - this.rect.center;
      var limit = this.rect.width * 0.5 - 8;
      if (x < -limit) x = -limit;
      if (x > limit) x = limit;
      this.setProperty('--arrow-x', "".concat(x.toFixed(2), "px"));
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Tooltip';
    }
  }]);
}(api.core.Placement);
api.tooltip = {
  Tooltip: Tooltip,
  TooltipSelector: TooltipSelector,
  TooltipEvent: TooltipEvent
};
api.internals.register(api.tooltip.TooltipSelector.TOOLTIP, api.tooltip.Tooltip);
var ToggleInput = /*#__PURE__*/function (_api$core$Instance8) {
  function ToggleInput() {
    _classCallCheck(this, ToggleInput);
    return _callSuper(this, ToggleInput, arguments);
  }
  _inherits(ToggleInput, _api$core$Instance8);
  return _createClass(ToggleInput, [{
    key: "isChecked",
    get: function get() {
      return this.node.checked;
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'ToggleInput';
    }
  }]);
}(api.core.Instance);
var ToggleStatusLabel = /*#__PURE__*/function (_api$core$Instance9) {
  function ToggleStatusLabel() {
    _classCallCheck(this, ToggleStatusLabel);
    return _callSuper(this, ToggleStatusLabel, arguments);
  }
  _inherits(ToggleStatusLabel, _api$core$Instance9);
  return _createClass(ToggleStatusLabel, [{
    key: "init",
    value: function init() {
      this.register("input[id=\"".concat(this.getAttribute('for'), "\"]"), ToggleInput);
      this.update();
      this.isSwappingFont = true;
    }
  }, {
    key: "proxy",
    get: function get() {
      var scope = this;
      return Object.assign(_superPropGet(ToggleStatusLabel, "proxy", this, 1), {
        update: scope.update.bind(scope)
      });
    }
  }, {
    key: "input",
    get: function get() {
      return this.getRegisteredInstances('ToggleInput')[0];
    }
  }, {
    key: "update",
    value: function update() {
      this.node.style.removeProperty('--toggle-status-width');
      var checked = this.input.isChecked;
      var style = getComputedStyle(this.node, ':before');
      var maxWidth = parseFloat(style.width);
      this.input.node.checked = !checked;
      var style2 = getComputedStyle(this.node, ':before');
      var width = parseFloat(style2.width);
      if (width > maxWidth) maxWidth = width;
      this.input.node.checked = checked;
      this.node.style.setProperty('--toggle-status-width', maxWidth / 16 + 'rem');
    }
  }, {
    key: "swapFont",
    value: function swapFont(families) {
      this.update();
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'ToggleStatusLabel';
    }
  }]);
}(api.core.Instance);
var ToggleSelector = {
  STATUS_LABEL: "".concat(api.internals.ns.selector('toggle__label')).concat(api.internals.ns.attr.selector('checked-label')).concat(api.internals.ns.attr.selector('unchecked-label'))
};

// import { ToggleInput } from './script/toggle/toggle-input.js';

api.toggle = {
  ToggleStatusLabel: ToggleStatusLabel,
  ToggleSelector: ToggleSelector
};
api.internals.register(api.toggle.ToggleSelector.STATUS_LABEL, api.toggle.ToggleStatusLabel);
var ITEM$1 = api.internals.ns.selector('sidemenu__item');
var COLLAPSE$1 = api.internals.ns.selector('collapse');
var SidemenuSelector = {
  LIST: api.internals.ns.selector('sidemenu__list'),
  COLLAPSE: "".concat(ITEM$1, " > ").concat(COLLAPSE$1, ", ").concat(ITEM$1, " > *:not(").concat(ITEM$1, "):not(").concat(COLLAPSE$1, ") > ").concat(COLLAPSE$1, ", ").concat(ITEM$1, " > *:not(").concat(ITEM$1, "):not(").concat(COLLAPSE$1, ") > *:not(").concat(ITEM$1, "):not(").concat(COLLAPSE$1, ") > ").concat(COLLAPSE$1),
  COLLAPSE_LEGACY: "".concat(ITEM$1, " ").concat(COLLAPSE$1),
  ITEM: api.internals.ns.selector('sidemenu__item'),
  BUTTON: api.internals.ns.selector('sidemenu__btn')
};
var SidemenuList = /*#__PURE__*/function (_api$core$CollapsesGr2) {
  function SidemenuList() {
    _classCallCheck(this, SidemenuList);
    return _callSuper(this, SidemenuList, arguments);
  }
  _inherits(SidemenuList, _api$core$CollapsesGr2);
  return _createClass(SidemenuList, [{
    key: "validate",
    value: function validate(member) {
      return _superPropGet(SidemenuList, "validate", this, 3)([member]) && member.node.matches(api.internals.legacy.isLegacy ? SidemenuSelector.COLLAPSE_LEGACY : SidemenuSelector.COLLAPSE);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'SidemenuList';
    }
  }]);
}(api.core.CollapsesGroup);
var SidemenuItem = /*#__PURE__*/function (_api$core$Instance0) {
  function SidemenuItem() {
    _classCallCheck(this, SidemenuItem);
    return _callSuper(this, SidemenuItem, arguments);
  }
  _inherits(SidemenuItem, _api$core$Instance0);
  return _createClass(SidemenuItem, [{
    key: "collapsePrimary",
    get: function get() {
      var buttons = this.element.children.map(function (child) {
        return child.getInstance('CollapseButton');
      }).filter(function (button) {
        return button !== null && button.hasClass(SidemenuSelector.BUTTON);
      });
      return buttons[0];
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'SidemenuItem';
    }
  }]);
}(api.core.Instance);
api.sidemenu = {
  SidemenuList: SidemenuList,
  SidemenuItem: SidemenuItem,
  SidemenuSelector: SidemenuSelector
};
api.internals.register(api.sidemenu.SidemenuSelector.LIST, api.sidemenu.SidemenuList);
api.internals.register(api.sidemenu.SidemenuSelector.ITEM, api.sidemenu.SidemenuItem);
var ModalSelector = {
  MODAL: api.internals.ns.selector('modal'),
  SCROLL_DIVIDER: api.internals.ns.selector('scroll-divider'),
  BODY: api.internals.ns.selector('modal__body'),
  TITLE: api.internals.ns.selector('modal__title')
};
var ModalButton = /*#__PURE__*/function (_api$core$DisclosureB) {
  function ModalButton() {
    _classCallCheck(this, ModalButton);
    return _callSuper(this, ModalButton, [api.core.DisclosureType.OPENED]);
  }
  _inherits(ModalButton, _api$core$DisclosureB);
  return _createClass(ModalButton, null, [{
    key: "instanceClassName",
    get: function get() {
      return 'ModalButton';
    }
  }]);
}(api.core.DisclosureButton);
var ModalAttribute = {
  CONCEALING_BACKDROP: api.internals.ns.attr('concealing-backdrop')
};
var Modal = /*#__PURE__*/function (_api$core$Disclosure) {
  function Modal() {
    var _this38;
    _classCallCheck(this, Modal);
    _this38 = _callSuper(this, Modal, [api.core.DisclosureType.OPENED, ModalSelector.MODAL, ModalButton, 'ModalsGroup']);
    _this38._isDecorated = false;
    _this38.scrolling = _this38.resize.bind(_this38, false);
    _this38.resizing = _this38.resize.bind(_this38, true);
    return _this38;
  }
  _inherits(Modal, _api$core$Disclosure);
  return _createClass(Modal, [{
    key: "init",
    value: function init() {
      _superPropGet(Modal, "init", this, 3)([]);
      this._isDialog = this.node.tagName === 'DIALOG';
      this.listenClick();
      this.addEmission(api.core.RootEmission.KEYDOWN, this._keydown.bind(this));
    }
  }, {
    key: "_keydown",
    value: function _keydown(keyCode) {
      switch (keyCode) {
        case api.core.KeyCodes.ESCAPE:
          this._escape();
          break;
      }
    }

    // TODO v2 : passer les tagName d'action en constante
  }, {
    key: "_escape",
    value: function _escape() {
      var tagName = document.activeElement ? document.activeElement.tagName : undefined;
      var isTooltipReferent = document.activeElement ? document.activeElement.hasAttribute('data-fr-js-tooltip-referent') : false;
      if (isTooltipReferent) return;
      switch (tagName) {
        case 'INPUT':
        case 'LABEL':
        case 'TEXTAREA':
        case 'SELECT':
        case 'AUDIO':
        case 'VIDEO':
          break;
        default:
          if (this.isDisclosed) {
            this.conceal();
            this.focus();
          }
      }
    }
  }, {
    key: "retrieved",
    value: function retrieved() {
      this._ensureAccessibleName();
    }
  }, {
    key: "body",
    get: function get() {
      return this.element.getDescendantInstances('ModalBody', 'Modal')[0];
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      if (e.target === this.node && this.getAttribute(ModalAttribute.CONCEALING_BACKDROP) !== 'false') this.conceal();
    }
  }, {
    key: "disclose",
    value: function disclose(withhold) {
      if (!_superPropGet(Modal, "disclose", this, 3)([withhold])) return false;
      if (this.body) {
        this.body.isResizing = true;
        this.body.resize();
      }
      this.isScrollLocked = true;
      this.setAttribute('aria-modal', 'true');
      this.setAttribute('open', 'true');
      if (!this._isDialog) {
        this.decorateDialog();
      }
      return true;
    }
  }, {
    key: "conceal",
    value: function conceal(withhold, preventFocus) {
      if (!_superPropGet(Modal, "conceal", this, 3)([withhold, preventFocus])) return false;
      this.isScrollLocked = false;
      this.removeAttribute('aria-modal');
      this.removeAttribute('open');
      if (this.body) this.body.isResizing = false;
      if (!this._isDialog) {
        this.stripDialog();
      }
      return true;
    }
  }, {
    key: "isDialog",
    get: function get() {
      return this._isDialog;
    },
    set: function set(value) {
      this._isDialog = value;
    }
  }, {
    key: "isActive",
    get: function get() {
      return _superPropGet(Modal, "isActive", this, 1);
    },
    set: function set(value) {
      _superPropSet(Modal, "isActive", value, this, 1, 1);
      if (value) this._ensureAccessibleName();
    }
  }, {
    key: "decorateDialog",
    value: function decorateDialog() {
      if (this._isDecorated) return;
      this._isDecorated = true;
      this._hasDialogRole = this.getAttribute('role') === 'dialog';
      if (!this._hasDialogRole) this.setAttribute('role', 'dialog');
    }
  }, {
    key: "stripDialog",
    value: function stripDialog() {
      if (!this._isDecorated) return;
      this._isDecorated = false;
      if (!this._hasDialogRole) this.removeAttribute('role');
    }
  }, {
    key: "_setAccessibleName",
    value: function _setAccessibleName(node, append) {
      var id = this.retrieveNodeId(node, append);
      this.warn("add reference to ".concat(append, " for accessible name (aria-labelledby)"));
      this.setAttribute('aria-labelledby', id);
    }
  }, {
    key: "_ensureAccessibleName",
    value: function _ensureAccessibleName() {
      if (!this.isActive || !this.isEnabled || this.isEnabled && (this.hasAttribute('aria-labelledby') || this.hasAttribute('aria-label'))) return;
      this.warn('missing accessible name');
      var title = this.node.querySelector(ModalSelector.TITLE);
      var primary = this.primaryButtons[0];
      switch (true) {
        case title !== null:
          this._setAccessibleName(title, 'title');
          break;
        case primary !== undefined:
          this.warn('missing required title, fallback to primary button');
          this._setAccessibleName(primary, 'primary');
          break;
      }
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Modal';
    }
  }]);
}(api.core.Disclosure);
var unordereds = ['[tabindex="0"]', 'a[href]', 'button:not([disabled])', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details', 'iframe'];
var UNORDEREDS = unordereds.join();
var ordereds = ['[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'];
var ORDEREDS = ordereds.join();
var isFocusable = function isFocusable(element, container) {
  if (!(element instanceof Element)) return false;
  var windowElement = window.frameElement ? window.frameElement.contentWindow : window;
  var style = windowElement.getComputedStyle(element);
  if (!style) return false;
  if (style.visibility === 'hidden') return false;
  if (container === undefined) container = element;
  while (container.contains(element)) {
    if (style.display === 'none') return false;
    element = element.parentElement;
  }
  return true;
};
var FocusTrap = /*#__PURE__*/function () {
  function FocusTrap(onTrap, onUntrap) {
    _classCallCheck(this, FocusTrap);
    this.element = null;
    this.activeElement = null;
    this.onTrap = onTrap;
    this.onUntrap = onUntrap;
    this.waiting = this.wait.bind(this);
    this.handling = this.handle.bind(this);
    this.focusing = this.maintainFocus.bind(this);
    this.current = null;
    this.window = window.frameElement ? window.frameElement.contentWindow : window;
  }
  return _createClass(FocusTrap, [{
    key: "trapped",
    get: function get() {
      return this.element !== null;
    }
  }, {
    key: "trap",
    value: function trap(element) {
      if (this.trapped) this.untrap();
      this.element = element;
      this.isTrapping = true;
      this.wait();
      if (this.onTrap) this.onTrap();
    }
  }, {
    key: "wait",
    value: function wait() {
      if (!isFocusable(this.element)) {
        this.window.requestAnimationFrame(this.waiting);
        return;
      }
      this.trapping();
    }
  }, {
    key: "trapping",
    value: function trapping() {
      if (!this.isTrapping) return;
      this.isTrapping = false;
      var focusables = this.focusables;
      if (focusables.length && focusables.indexOf(this.window.document.activeElement) === -1) focusables[0].focus();
      this.element.setAttribute('aria-modal', true);
      this.window.addEventListener('keydown', this.handling);
      this.window.document.body.addEventListener('focus', this.focusing, true);
    }
  }, {
    key: "stun",
    value: function stun(node) {
      var _iterator29 = _createForOfIteratorHelper(node.children),
        _step29;
      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var child = _step29.value;
          if (child === this.element) continue;
          if (child.contains(this.element)) {
            this.stun(child);
            continue;
          }
          this.stunneds.push(new Stunned(child));
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
    }
  }, {
    key: "maintainFocus",
    value: function maintainFocus(event) {
      if (!this.element.contains(event.target)) {
        var focusables = this.focusables;
        if (focusables.length === 0) return;
        var first = focusables[0];
        event.preventDefault();
        first.focus();
      }
    }
  }, {
    key: "handle",
    value: function handle(e) {
      if (e.keyCode !== 9) return;
      var focusables = this.focusables;
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var index = focusables.indexOf(this.window.document.activeElement);
      if (e.shiftKey) {
        if (!this.element.contains(this.window.document.activeElement) || index < 1) {
          e.preventDefault();
          last.focus();
        } else if (this.window.document.activeElement.tabIndex > 0 || focusables[index - 1].tabIndex > 0) {
          e.preventDefault();
          focusables[index - 1].focus();
        }
      } else {
        if (!this.element.contains(this.window.document.activeElement) || index === focusables.length - 1 || index === -1) {
          e.preventDefault();
          first.focus();
        } else if (this.window.document.activeElement.tabIndex > 0) {
          e.preventDefault();
          focusables[index + 1].focus();
        }
      }
    }
  }, {
    key: "focusables",
    get: function get() {
      var _this39 = this;
      var unordereds = api.internals.dom.querySelectorAllArray(this.element, UNORDEREDS);

      /**
       *  filtrage des radiobutttons de même name (la navigations d'un groupe de radio se fait à la flèche et non pas au tab
       **/
      var radios = api.internals.dom.querySelectorAllArray(this.window.document.documentElement, 'input[type="radio"]');
      if (radios.length) {
        var groups = {};
        var _iterator30 = _createForOfIteratorHelper(radios),
          _step30;
        try {
          for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
            var radio = _step30.value;
            var name = radio.getAttribute('name');
            if (groups[name] === undefined) groups[name] = new RadioButtonGroup(name);
            groups[name].push(radio);
          }
        } catch (err) {
          _iterator30.e(err);
        } finally {
          _iterator30.f();
        }
        unordereds = unordereds.filter(function (unordered) {
          if (unordered.tagName.toLowerCase() !== 'input' || unordered.getAttribute('type') && unordered.getAttribute('type').toLowerCase() !== 'radio') return true;
          var name = unordered.getAttribute('name');
          return groups[name].keep(unordered);
        });
      }
      var ordereds = api.internals.dom.querySelectorAllArray(this.element, ORDEREDS);
      ordereds.sort(function (a, b) {
        return a.tabIndex - b.tabIndex;
      });
      var noDuplicates = unordereds.filter(function (element) {
        return ordereds.indexOf(element) === -1;
      });
      var concateneds = ordereds.concat(noDuplicates);
      return concateneds.filter(function (element) {
        return element.tabIndex !== '-1' && isFocusable(element, _this39.element);
      });
    }
  }, {
    key: "untrap",
    value: function untrap() {
      if (!this.trapped) return;
      this.isTrapping = false;
      this.element.removeAttribute('aria-modal');
      this.window.removeEventListener('keydown', this.handling);
      this.window.document.body.removeEventListener('focus', this.focusing, true);
      this.element = null;
      if (this.onUntrap) this.onUntrap();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.untrap();
    }
  }]);
}();
var Stunned = /*#__PURE__*/function () {
  function Stunned(element) {
    _classCallCheck(this, Stunned);
    this.element = element;
    // this.hidden = element.getAttribute('aria-hidden');
    this.inert = element.getAttribute('inert');

    // this.element.setAttribute('aria-hidden', true);
    this.element.setAttribute('inert', '');
  }
  return _createClass(Stunned, [{
    key: "unstun",
    value: function unstun() {
      /*
      if (this.hidden === null) this.element.removeAttribute('aria-hidden');
      else this.element.setAttribute('aria-hidden', this.hidden);
       */

      if (this.inert === null) this.element.removeAttribute('inert');else this.element.setAttribute('inert', this.inert);
    }
  }]);
}();
var RadioButtonGroup = /*#__PURE__*/function () {
  function RadioButtonGroup(name) {
    _classCallCheck(this, RadioButtonGroup);
    this.name = name;
    this.buttons = [];
  }
  return _createClass(RadioButtonGroup, [{
    key: "push",
    value: function push(button) {
      this.buttons.push(button);
      var windowElement = window.frameElement ? window.frameElement.contentWindow : window;
      if (button === windowElement.document.activeElement || button.checked || this.selected === undefined) this.selected = button;
    }
  }, {
    key: "keep",
    value: function keep(button) {
      return this.selected === button;
    }
  }]);
}();
var ModalsGroup = /*#__PURE__*/function (_api$core$Disclosures) {
  function ModalsGroup() {
    var _this40;
    _classCallCheck(this, ModalsGroup);
    _this40 = _callSuper(this, ModalsGroup, ['Modal', false]);
    _this40.focusTrap = new FocusTrap();
    return _this40;
  }
  _inherits(ModalsGroup, _api$core$Disclosures);
  return _createClass(ModalsGroup, [{
    key: "apply",
    value: function apply(value, initial) {
      _superPropGet(ModalsGroup, "apply", this, 3)([value, initial]);
      if (this.current === null) this.focusTrap.untrap();else this.focusTrap.trap(this.current.node);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'ModalsGroup';
    }
  }]);
}(api.core.DisclosuresGroup);
var OFFSET = 32; // 32px => 8v => 2rem
var ModalBody = /*#__PURE__*/function (_api$core$Instance1) {
  function ModalBody() {
    _classCallCheck(this, ModalBody);
    return _callSuper(this, ModalBody, arguments);
  }
  _inherits(ModalBody, _api$core$Instance1);
  return _createClass(ModalBody, [{
    key: "init",
    value: function init() {
      this.listen('scroll', this.divide.bind(this));
    }
  }, {
    key: "divide",
    value: function divide() {
      if (this.node.scrollHeight > this.node.clientHeight) {
        if (this.node.offsetHeight + this.node.scrollTop >= this.node.scrollHeight) {
          this.removeClass(ModalSelector.SCROLL_DIVIDER);
        } else {
          this.addClass(ModalSelector.SCROLL_DIVIDER);
        }
      } else {
        this.removeClass(ModalSelector.SCROLL_DIVIDER);
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      this.adjust();
      this.request(this.adjust.bind(this));
    }
  }, {
    key: "adjust",
    value: function adjust() {
      var iframe = window.frameElement;
      var windowElement = iframe ? iframe.contentWindow : window;
      var offset = OFFSET * (this.isBreakpoint(api.core.Breakpoints.MD) ? 2 : 1);
      if (this.isLegacy) this.style.maxHeight = "".concat(windowElement.innerHeight - offset, "px");else this.style.setProperty('--modal-max-height', "".concat(windowElement.innerHeight - offset, "px"));
      this.divide();
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'ModalBody';
    }
  }]);
}(api.core.Instance);
api.modal = {
  Modal: Modal,
  ModalButton: ModalButton,
  ModalBody: ModalBody,
  ModalsGroup: ModalsGroup,
  ModalSelector: ModalSelector
};
api.internals.register(api.modal.ModalSelector.MODAL, api.modal.Modal);
api.internals.register(api.modal.ModalSelector.BODY, api.modal.ModalBody);
api.internals.register(api.core.RootSelector.ROOT, api.modal.ModalsGroup);
var PasswordEmission = {
  TOGGLE: api.internals.ns.emission('password', 'toggle'),
  ADJUST: api.internals.ns.emission('password', 'adjust')
};
var PasswordToggle = /*#__PURE__*/function (_api$core$Instance10) {
  function PasswordToggle() {
    _classCallCheck(this, PasswordToggle);
    return _callSuper(this, PasswordToggle, arguments);
  }
  _inherits(PasswordToggle, _api$core$Instance10);
  return _createClass(PasswordToggle, [{
    key: "init",
    value: function init() {
      this.listenClick();
      this.ascend(PasswordEmission.ADJUST, this.width);
      this.isSwappingFont = true;
      this._isChecked = this.isChecked;
    }
  }, {
    key: "width",
    get: function get() {
      var style = getComputedStyle(this.node.parentNode);
      return parseInt(style.width);
    }
  }, {
    key: "isChecked",
    get: function get() {
      return this.node.checked;
    },
    set: function set(value) {
      this._isChecked = value;
      this.ascend(PasswordEmission.TOGGLE, value);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.isChecked = !this._isChecked;
    }
  }, {
    key: "swapFont",
    value: function swapFont(families) {
      this.ascend(PasswordEmission.ADJUST, this.width);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'PasswordToggle';
    }
  }]);
}(api.core.Instance);
var Password = /*#__PURE__*/function (_api$core$Instance11) {
  function Password() {
    _classCallCheck(this, Password);
    return _callSuper(this, Password, arguments);
  }
  _inherits(Password, _api$core$Instance11);
  return _createClass(Password, [{
    key: "init",
    value: function init() {
      this.addAscent(PasswordEmission.TOGGLE, this.toggle.bind(this));
      this.addAscent(PasswordEmission.ADJUST, this.adjust.bind(this));
    }
  }, {
    key: "toggle",
    value: function toggle(value) {
      this.descend(PasswordEmission.TOGGLE, value);
    }
  }, {
    key: "adjust",
    value: function adjust(value) {
      this.descend(PasswordEmission.ADJUST, value);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Password';
    }
  }]);
}(api.core.Instance);
var PasswordSelector = {
  PASSWORD: api.internals.ns.selector('password'),
  INPUT: api.internals.ns.selector('password__input'),
  LABEL: api.internals.ns.selector('password__label'),
  TOOGLE: "".concat(api.internals.ns.selector('password__checkbox'), " input[type=\"checkbox\"]")
};
var PasswordInput = /*#__PURE__*/function (_api$core$Instance12) {
  function PasswordInput() {
    _classCallCheck(this, PasswordInput);
    return _callSuper(this, PasswordInput, arguments);
  }
  _inherits(PasswordInput, _api$core$Instance12);
  return _createClass(PasswordInput, [{
    key: "init",
    value: function init() {
      this.addDescent(PasswordEmission.TOGGLE, this.toggle.bind(this));
      this._isRevealed = this.hasAttribute('type') === 'password';
      this.listen('keydown', this.capslock.bind(this)); // for capslock enabled
      this.listen('keyup', this.capslock.bind(this)); // for capslock desabled
    }
  }, {
    key: "toggle",
    value: function toggle(value) {
      this.isRevealed = value;
      this.setAttribute('type', value ? 'text' : 'password');
    }
  }, {
    key: "isRevealed",
    get: function get() {
      return this._isRevealed;
    },
    set: function set(value) {
      this._isRevealed = value;
      this.setAttribute('type', value ? 'text' : 'password');
    }
  }, {
    key: "capslock",
    value: function capslock(event) {
      if (event && typeof event.getModifierState !== 'function') return;
      if (event.getModifierState('CapsLock')) {
        this.node.parentNode.setAttribute(api.internals.ns.attr('capslock'), '');
      } else {
        this.node.parentNode.removeAttribute(api.internals.ns.attr('capslock'));
      }
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'PasswordInput';
    }
  }]);
}(api.core.Instance);
var PasswordLabel = /*#__PURE__*/function (_api$core$Instance13) {
  function PasswordLabel() {
    _classCallCheck(this, PasswordLabel);
    return _callSuper(this, PasswordLabel, arguments);
  }
  _inherits(PasswordLabel, _api$core$Instance13);
  return _createClass(PasswordLabel, [{
    key: "init",
    value: function init() {
      this.addDescent(PasswordEmission.ADJUST, this.adjust.bind(this));
    }
  }, {
    key: "adjust",
    value: function adjust(value) {
      var valueREM = Math.ceil(value / 16);
      this.node.style.paddingRight = valueREM + 'rem';
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'PasswordLabel';
    }
  }]);
}(api.core.Instance);
api.password = {
  Password: Password,
  PasswordToggle: PasswordToggle,
  PasswordSelector: PasswordSelector,
  PasswordInput: PasswordInput,
  PasswordLabel: PasswordLabel
};
api.internals.register(api.password.PasswordSelector.INPUT, api.password.PasswordInput);
api.internals.register(api.password.PasswordSelector.PASSWORD, api.password.Password);
api.internals.register(api.password.PasswordSelector.TOOGLE, api.password.PasswordToggle);
api.internals.register(api.password.PasswordSelector.LABEL, api.password.PasswordLabel);
var ITEM = api.internals.ns.selector('nav__item');
var COLLAPSE = api.internals.ns.selector('collapse');
var NavigationSelector = {
  NAVIGATION: api.internals.ns.selector('nav'),
  COLLAPSE: "".concat(ITEM, " > ").concat(COLLAPSE, ", ").concat(ITEM, " > *:not(").concat(ITEM, "):not(").concat(COLLAPSE, ") > ").concat(COLLAPSE, ", ").concat(ITEM, " > *:not(").concat(ITEM, "):not(").concat(COLLAPSE, ") > *:not(").concat(ITEM, "):not(").concat(COLLAPSE, ") > ").concat(COLLAPSE),
  COLLAPSE_LEGACY: "".concat(ITEM, " ").concat(COLLAPSE),
  ITEM: ITEM,
  ITEM_RIGHT: "".concat(ITEM, "--align-right"),
  MENU: api.internals.ns.selector('menu'),
  BUTTON: api.internals.ns.selector('nav__btn'),
  TRANSLATE_BUTTON: api.internals.ns.selector('translate__btn')
};
var NavigationItem = /*#__PURE__*/function (_api$core$Instance14) {
  function NavigationItem() {
    var _this41;
    _classCallCheck(this, NavigationItem);
    _this41 = _callSuper(this, NavigationItem);
    _this41._isRightAligned = false;
    return _this41;
  }
  _inherits(NavigationItem, _api$core$Instance14);
  return _createClass(NavigationItem, [{
    key: "init",
    value: function init() {
      this.addAscent(api.core.DisclosureEmission.ADDED, this.calculate.bind(this));
      this.addAscent(api.core.DisclosureEmission.REMOVED, this.calculate.bind(this));
      this.isResizing = true;
      this.calculate();
    }
  }, {
    key: "resize",
    value: function resize() {
      this.calculate();
    }
  }, {
    key: "calculate",
    value: function calculate() {
      var collapse = this.element.getDescendantInstances(api.core.Collapse.instanceClassName, null, true)[0];
      if (collapse && this.isBreakpoint(api.core.Breakpoints.LG) && collapse.element.node.matches(NavigationSelector.MENU)) {
        var right = this.element.node.parentElement.getBoundingClientRect().right; // todo: ne fonctionne que si la nav fait 100% du container
        var width = collapse.element.node.getBoundingClientRect().width;
        var left = this.element.node.getBoundingClientRect().left;
        this.isRightAligned = left + width > right;
      } else this.isRightAligned = false;
    }
  }, {
    key: "isRightAligned",
    get: function get() {
      return this._isRightAligned;
    },
    set: function set(value) {
      if (this._isRightAligned === value) return;
      this._isRightAligned = value;
      if (value) api.internals.dom.addClass(this.element.node, NavigationSelector.ITEM_RIGHT);else api.internals.dom.removeClass(this.element.node, NavigationSelector.ITEM_RIGHT);
    }
  }, {
    key: "collapsePrimary",
    get: function get() {
      var buttons = this.element.children.map(function (child) {
        return child.getInstance('CollapseButton');
      }).filter(function (button) {
        return button !== null && (button.hasClass(NavigationSelector.BUTTON) || button.hasClass(NavigationSelector.TRANSLATE_BUTTON));
      });
      return buttons[0];
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'NavigationItem';
    }
  }]);
}(api.core.Instance);
var NavigationMousePosition = {
  NONE: -1,
  INSIDE: 0,
  OUTSIDE: 1
};
var Navigation = /*#__PURE__*/function (_api$core$CollapsesGr3) {
  function Navigation() {
    _classCallCheck(this, Navigation);
    return _callSuper(this, Navigation, arguments);
  }
  _inherits(Navigation, _api$core$CollapsesGr3);
  return _createClass(Navigation, [{
    key: "init",
    value: function init() {
      _superPropGet(Navigation, "init", this, 3)([]);
      this.clicked = false;
      this.out = false;
      this.addEmission(api.core.RootEmission.CLICK, this._handleRootClick.bind(this));
      this.listen('mousedown', this.handleMouseDown.bind(this));
      this.addEmission(api.core.RootEmission.KEYDOWN, this._keydown.bind(this));
      this.listenClick({
        capture: true
      });
      this.isResizing = true;
    }
  }, {
    key: "validate",
    value: function validate(member) {
      return _superPropGet(Navigation, "validate", this, 3)([member]) && member.element.node.matches(api.internals.legacy.isLegacy ? NavigationSelector.COLLAPSE_LEGACY : NavigationSelector.COLLAPSE);
    }
  }, {
    key: "hasOpenedMenu",
    get: function get() {
      return this.isBreakpoint(api.core.Breakpoints.LG) && this.index > -1;
    }
  }, {
    key: "_keydown",
    value: function _keydown(keyCode) {
      var _this42 = this;
      switch (keyCode) {
        case api.core.KeyCodes.ESCAPE:
          if (!this.hasOpenedMenu) return;
          this.index = -1;
          break;
        case api.core.KeyCodes.TAB:
          if (!this.hasOpenedMenu) return;
          this.request(function () {
            if (_this42.current.node.contains(document.activeElement)) return;
            _this42.index = -1;
          });
          break;
      }
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(e) {
      if (!this.hasOpenedMenu) return;
      this.position = this.current.node.contains(e.target) ? NavigationMousePosition.INSIDE : NavigationMousePosition.OUTSIDE;
      this.requestPosition();
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      if (e.target.matches('a, button') && !e.target.matches('[aria-controls]') && !e.target.matches(api.core.DisclosureSelector.PREVENT_CONCEAL)) {
        this.index = -1;
      }
    }
  }, {
    key: "_handleRootClick",
    value: function _handleRootClick(target) {
      if (!this.isBreakpoint(api.core.Breakpoints.LG)) return;
      if (!this.node.contains(target)) {
        this.out = true;
        this.requestPosition();
      }
    }
  }, {
    key: "requestPosition",
    value: function requestPosition() {
      if (this.isRequesting) return;
      this.isRequesting = true;
      this.request(this.getPosition.bind(this));
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      if (this.out) {
        switch (this.position) {
          case NavigationMousePosition.OUTSIDE:
            this.index = -1;
            break;
          case NavigationMousePosition.INSIDE:
            if (this.current && !this.current.node.contains(document.activeElement)) this.current.focus();
            break;
          default:
            if (this.index > -1 && !this.current.hasFocus) this.index = -1;
        }
      }
      this.request(this.requested.bind(this));
    }
  }, {
    key: "requested",
    value: function requested() {
      this.position = NavigationMousePosition.NONE;
      this.out = false;
      this.isRequesting = false;
    }
  }, {
    key: "index",
    get: function get() {
      return _superPropGet(Navigation, "index", this, 1);
    },
    set: function set(value) {
      if (value === -1 && this.current && this.current.hasFocus) this.current.focus();
      _superPropSet(Navigation, "index", value, this, 1, 1);
    }
  }, {
    key: "canUngroup",
    get: function get() {
      return !this.isBreakpoint(api.core.Breakpoints.LG);
    }
  }, {
    key: "resize",
    value: function resize() {
      this.update();
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Navigation';
    }
  }]);
}(api.core.CollapsesGroup);
api.navigation = {
  Navigation: Navigation,
  NavigationItem: NavigationItem,
  NavigationMousePosition: NavigationMousePosition,
  NavigationSelector: NavigationSelector
};
api.internals.register(api.navigation.NavigationSelector.NAVIGATION, api.navigation.Navigation);
api.internals.register(api.navigation.NavigationSelector.ITEM, api.navigation.NavigationItem);

/**
  * TabButton correspond au bouton cliquable qui change le panel
  * TabButton étend de DisclosureButton qui ajoute/enelve l'attribut aria-selected,
  * Et change l'attributte tabindex a 0 si le boutton est actif (value=true), -1 s'il n'est pas actif (value=false)
 */
var TabButton = /*#__PURE__*/function (_api$core$DisclosureB2) {
  function TabButton() {
    _classCallCheck(this, TabButton);
    return _callSuper(this, TabButton, [api.core.DisclosureType.SELECT]);
  }
  _inherits(TabButton, _api$core$DisclosureB2);
  return _createClass(TabButton, [{
    key: "handleClick",
    value: function handleClick(e) {
      _superPropGet(TabButton, "handleClick", this, 3)([e]);
      this.focus();
    }
  }, {
    key: "apply",
    value: function apply(value) {
      _superPropGet(TabButton, "apply", this, 3)([value]);
      if (this.isPrimary) {
        this.setAttribute('tabindex', value ? '0' : '-1');
        if (value) {
          if (this.list) this.list.focalize(this);
        }
      }
    }
  }, {
    key: "list",
    get: function get() {
      return this.element.getAscendantInstance('TabsList', 'TabsGroup');
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'TabButton';
    }
  }]);
}(api.core.DisclosureButton);
var TabSelector = {
  TAB: api.internals.ns.selector('tabs__tab'),
  GROUP: api.internals.ns.selector('tabs'),
  PANEL: api.internals.ns.selector('tabs__panel'),
  LIST: api.internals.ns.selector('tabs__list'),
  SHADOW: api.internals.ns.selector('tabs__shadow'),
  SHADOW_LEFT: api.internals.ns.selector('tabs__shadow--left'),
  SHADOW_RIGHT: api.internals.ns.selector('tabs__shadow--right'),
  PANEL_START: api.internals.ns.selector('tabs__panel--direction-start'),
  PANEL_END: api.internals.ns.selector('tabs__panel--direction-end')
};
var TabPanelDirection = {
  START: 'direction-start',
  END: 'direction-end',
  NONE: 'none'
};

/**
  * Tab coorespond au panel d'un élement Tabs (tab panel)
  * Tab étend disclosure qui ajoute/enleve le modifier --selected,
  * et ajoute/eleve l'attribut hidden, sur le panel
  */
var TabPanel = /*#__PURE__*/function (_api$core$Disclosure2) {
  function TabPanel() {
    var _this43;
    _classCallCheck(this, TabPanel);
    _this43 = _callSuper(this, TabPanel, [api.core.DisclosureType.SELECT, TabSelector.PANEL, TabButton, 'TabsGroup']);
    _this43._direction = TabPanelDirection.NONE;
    _this43._isPreventingTransition = false;
    return _this43;
  }
  _inherits(TabPanel, _api$core$Disclosure2);
  return _createClass(TabPanel, [{
    key: "direction",
    get: function get() {
      return this._direction;
    },
    set: function set(value) {
      if (value === this._direction) return;
      switch (this._direction) {
        case TabPanelDirection.START:
          this.removeClass(TabSelector.PANEL_START);
          break;
        case TabPanelDirection.END:
          this.removeClass(TabSelector.PANEL_END);
          break;
        case TabPanelDirection.NONE:
          break;
        default:
          return;
      }
      this._direction = value;
      switch (this._direction) {
        case TabPanelDirection.START:
          this.addClass(TabSelector.PANEL_START);
          break;
        case TabPanelDirection.END:
          this.addClass(TabSelector.PANEL_END);
          break;
      }
    }
  }, {
    key: "isPreventingTransition",
    get: function get() {
      return this._isPreventingTransition;
    },
    set: function set(value) {
      if (this._isPreventingTransition === value) return;
      if (value) this.addClass(api.internals.motion.TransitionSelector.NONE);else this.removeClass(api.internals.motion.TransitionSelector.NONE);
      this._isPreventingTransition = value === true;
    }
  }, {
    key: "translate",
    value: function translate(direction, initial) {
      this.isPreventingTransition = initial;
      this.direction = direction;
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.group) this.group.retrieve(true);
    }
  }, {
    key: "_electPrimaries",
    value: function _electPrimaries(candidates) {
      var _this44 = this;
      if (!this.group || !this.group.list) return [];
      return _superPropGet(TabPanel, "_electPrimaries", this, 3)([candidates]).filter(function (candidate) {
        return _this44.group.list.node.contains(candidate.node);
      });
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'TabPanel';
    }
  }]);
}(api.core.Disclosure);
var TabKeys = {
  LEFT: 'tab_keys_left',
  RIGHT: 'tab_keys_right',
  HOME: 'tab_keys_home',
  END: 'tab_keys_end'
};
var TabEmission = {
  PRESS_KEY: api.internals.ns.emission('tab', 'press_key'),
  LIST_HEIGHT: api.internals.ns.emission('tab', 'list_height')
};

/**
* TabGroup est la classe étendue de DiscosuresGroup
* Correspond à un objet Tabs avec plusieurs tab-button & Tab (panel)
*/
var TabsGroup = /*#__PURE__*/function (_api$core$Disclosures2) {
  function TabsGroup() {
    _classCallCheck(this, TabsGroup);
    return _callSuper(this, TabsGroup, ['TabPanel']);
  }
  _inherits(TabsGroup, _api$core$Disclosures2);
  return _createClass(TabsGroup, [{
    key: "init",
    value: function init() {
      _superPropGet(TabsGroup, "init", this, 3)([]);
      this.listen('transitionend', this.transitionend.bind(this));
      this.addAscent(TabEmission.PRESS_KEY, this.pressKey.bind(this));
      this.addAscent(TabEmission.LIST_HEIGHT, this.setListHeight.bind(this));
      this.isRendering = true;
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      var defaultIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      _superPropGet(TabsGroup, "getIndex", this, 3)([defaultIndex]);
    }
  }, {
    key: "list",
    get: function get() {
      return this.element.getDescendantInstances('TabsList', 'TabsGroup', true)[0];
    }
  }, {
    key: "setListHeight",
    value: function setListHeight(value) {
      this.listHeight = value;
    }
  }, {
    key: "transitionend",
    value: function transitionend(e) {
      this.isPreventingTransition = true;
    }
  }, {
    key: "buttonHasFocus",
    get: function get() {
      return this.members.some(function (member) {
        return member.buttonHasFocus;
      });
    }
  }, {
    key: "pressKey",
    value: function pressKey(key) {
      switch (key) {
        case TabKeys.LEFT:
          this.pressLeft();
          break;
        case TabKeys.RIGHT:
          this.pressRight();
          break;
        case TabKeys.HOME:
          this.pressHome();
          break;
        case TabKeys.END:
          this.pressEnd();
          break;
      }
    }

    /**
     * Selectionne l'element suivant de la liste si on est sur un bouton
     * Si on est à la fin on retourne au début
     */
  }, {
    key: "pressRight",
    value: function pressRight() {
      if (this.buttonHasFocus) {
        if (this.index < this.length - 1) {
          this.index++;
        } else {
          this.index = 0;
        }
        this.focus();
      }
    }
  }, {
    key: "pressLeft",
    value:
    /**
     * Selectionne l'element précédent de la liste si on est sur un bouton
     * Si on est au debut retourne a la fin
     */
    function pressLeft() {
      if (this.buttonHasFocus) {
        if (this.index > 0) {
          this.index--;
        } else {
          this.index = this.length - 1;
        }
        this.focus();
      }
    }
  }, {
    key: "pressHome",
    value:
    /**
     * Selectionne le permier element de la liste si on est sur un bouton
     */
    function pressHome() {
      if (this.buttonHasFocus) {
        this.index = 0;
        this.focus();
      }
    }
  }, {
    key: "pressEnd",
    value:
    /**
     * Selectionne le dernier element de la liste si on est sur un bouton
     */
    function pressEnd() {
      if (this.buttonHasFocus) {
        this.index = this.length - 1;
        this.focus();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.current) {
        this.current.focus();
      }
    }
  }, {
    key: "apply",
    value: function apply() {
      for (var i = 0; i < this._index; i++) this.members[i].translate(TabPanelDirection.START);
      if (this.current) this.current.translate(TabPanelDirection.NONE);
      for (var _i6 = this._index + 1; _i6 < this.length; _i6++) this.members[_i6].translate(TabPanelDirection.END);
      this.isPreventingTransition = false;
    }
  }, {
    key: "isPreventingTransition",
    get: function get() {
      return this._isPreventingTransition;
    },
    set: function set(value) {
      if (this._isPreventingTransition === value) return;
      if (value) this.addClass(api.internals.motion.TransitionSelector.NONE);else this.removeClass(api.internals.motion.TransitionSelector.NONE);
      this._isPreventingTransition = value === true;
    }
  }, {
    key: "render",
    value: function render() {
      if (this.current === null) return;
      this.node.scrollTop = 0;
      this.node.scrollLeft = 0;
      var paneHeight = Math.round(this.current.node.offsetHeight);
      if (this.panelHeight === paneHeight) return;
      this.panelHeight = paneHeight;
      this.style.setProperty('--tabs-height', this.panelHeight + this.listHeight + 'px');
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'TabsGroup';
    }
  }]);
}(api.core.DisclosuresGroup);
var FOCALIZE_OFFSET = 16;
var SCROLL_OFFSET$1 = 16; // valeur en px du scroll avant laquelle le shadow s'active ou se desactive
var TabsList = /*#__PURE__*/function (_api$core$Instance15) {
  function TabsList() {
    _classCallCheck(this, TabsList);
    return _callSuper(this, TabsList, arguments);
  }
  _inherits(TabsList, _api$core$Instance15);
  return _createClass(TabsList, [{
    key: "init",
    value: function init() {
      this.listen('scroll', this.scroll.bind(this));
      this.listenKey(api.core.KeyCodes.RIGHT, this.ascend.bind(this, TabEmission.PRESS_KEY, TabKeys.RIGHT), true, true);
      this.listenKey(api.core.KeyCodes.LEFT, this.ascend.bind(this, TabEmission.PRESS_KEY, TabKeys.LEFT), true, true);
      this.listenKey(api.core.KeyCodes.HOME, this.ascend.bind(this, TabEmission.PRESS_KEY, TabKeys.HOME), true, true);
      this.listenKey(api.core.KeyCodes.END, this.ascend.bind(this, TabEmission.PRESS_KEY, TabKeys.END), true, true);
      this.isResizing = true;
    }
  }, {
    key: "focalize",
    value: function focalize(btn) {
      var btnRect = btn.getRect();
      var listRect = this.getRect();
      var actualScroll = this.node.scrollLeft;
      if (btnRect.left < listRect.left) this.node.scrollTo(actualScroll - listRect.left + btnRect.left - FOCALIZE_OFFSET, 0);else if (btnRect.right > listRect.right) this.node.scrollTo(actualScroll - listRect.right + btnRect.right + FOCALIZE_OFFSET, 0);
    }
  }, {
    key: "isScrolling",
    get: function get() {
      return this._isScrolling;
    },
    set: function set(value) {
      if (this._isScrolling === value) return;
      this._isScrolling = value;
      this.apply();
    }
  }, {
    key: "apply",
    value: function apply() {
      if (this._isScrolling) {
        this.addClass(TabSelector.SHADOW);
        this.scroll();
      } else {
        this.removeClass(TabSelector.SHADOW_RIGHT);
        this.removeClass(TabSelector.SHADOW_LEFT);
        this.removeClass(TabSelector.SHADOW);
      }
    }

    /* ajoute la classe fr-table__shadow-left ou fr-table__shadow-right sur fr-table en fonction d'une valeur de scroll et du sens (right, left) */
  }, {
    key: "scroll",
    value: function scroll() {
      var scrollLeft = Math.abs(this.node.scrollLeft);
      var isMin = scrollLeft <= SCROLL_OFFSET$1;
      var max = this.node.scrollWidth - this.node.clientWidth - SCROLL_OFFSET$1;
      var isMax = Math.abs(scrollLeft) >= max;
      var isRtl = getComputedStyle(this.node).direction === 'rtl';
      var minSelector = isRtl ? TabSelector.SHADOW_RIGHT : TabSelector.SHADOW_LEFT;
      var maxSelector = isRtl ? TabSelector.SHADOW_LEFT : TabSelector.SHADOW_RIGHT;
      if (isMin) {
        this.removeClass(minSelector);
      } else {
        this.addClass(minSelector);
      }
      if (isMax) {
        this.removeClass(maxSelector);
      } else {
        this.addClass(maxSelector);
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      this.isScrolling = this.node.scrollWidth > this.node.clientWidth + SCROLL_OFFSET$1;
      var height = this.getRect().height;
      this.setProperty('--tabs-list-height', "".concat(height, "px"));
      this.ascend(TabEmission.LIST_HEIGHT, height);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.isScrolling = false;
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'TabsList';
    }
  }]);
}(api.core.Instance);
api.tab = {
  TabPanel: TabPanel,
  TabButton: TabButton,
  TabsGroup: TabsGroup,
  TabsList: TabsList,
  TabSelector: TabSelector,
  TabEmission: TabEmission
};
api.internals.register(api.tab.TabSelector.PANEL, api.tab.TabPanel);
api.internals.register(api.tab.TabSelector.GROUP, api.tab.TabsGroup);
api.internals.register(api.tab.TabSelector.LIST, api.tab.TabsList);
var TagEvent = {
  DISMISS: api.internals.ns.event('dismiss')
};
var TagDismissible = /*#__PURE__*/function (_api$core$Instance16) {
  function TagDismissible() {
    _classCallCheck(this, TagDismissible);
    return _callSuper(this, TagDismissible, arguments);
  }
  _inherits(TagDismissible, _api$core$Instance16);
  return _createClass(TagDismissible, [{
    key: "init",
    value: function init() {
      this.listenClick();
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.focusClosest();
      switch (api.mode) {
        case api.Modes.ANGULAR:
        case api.Modes.REACT:
        case api.Modes.VUE:
          this.request(this.verify.bind(this));
          break;
        default:
          this.remove();
      }
      this.dispatch(TagEvent.DISMISS);
    }
  }, {
    key: "verify",
    value: function verify() {
      if (document.body.contains(this.node)) this.warn("a TagDismissible has just been dismissed and should be removed from the dom. In ".concat(api.mode, " mode, the api doesn't handle dom modification. An event ").concat(TagEvent.DISMISS, " is dispatched by the element to trigger the removal"));
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'TagDismissible';
    }
  }]);
}(api.core.Instance);
var TagSelector = {
  PRESSABLE: "".concat(api.internals.ns.selector('tag'), "[aria-pressed]"),
  DISMISSIBLE: "".concat(api.internals.ns.selector('tag--dismiss'))
};
api.tag = {
  TagDismissible: TagDismissible,
  TagSelector: TagSelector,
  TagEvent: TagEvent
};
api.internals.register(api.tag.TagSelector.PRESSABLE, api.core.Toggle);
api.internals.register(api.tag.TagSelector.DISMISSIBLE, api.tag.TagDismissible);
var TRANSCRIPTION = api.internals.ns.selector('transcription');
var TranscriptionSelector = {
  TRANSCRIPTION: TRANSCRIPTION,
  BUTTON: "".concat(TRANSCRIPTION, "__btn")
};
var Transcription = /*#__PURE__*/function (_api$core$Instance17) {
  function Transcription() {
    _classCallCheck(this, Transcription);
    return _callSuper(this, Transcription, arguments);
  }
  _inherits(Transcription, _api$core$Instance17);
  return _createClass(Transcription, [{
    key: "collapsePrimary",
    get: function get() {
      var buttons = this.element.children.map(function (child) {
        return child.getInstance('CollapseButton');
      }).filter(function (button) {
        return button !== null && button.hasClass(TranscriptionSelector.BUTTON);
      });
      return buttons[0];
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Transcription';
    }
  }]);
}(api.core.Instance);
api.transcription = {
  Transcription: Transcription,
  TranscriptionSelector: TranscriptionSelector
};
api.internals.register(api.transcription.TranscriptionSelector.TRANSCRIPTION, api.transcription.Transcription);
var TileDownload = /*#__PURE__*/function (_api$core$Instance18) {
  function TileDownload() {
    _classCallCheck(this, TileDownload);
    return _callSuper(this, TileDownload, arguments);
  }
  _inherits(TileDownload, _api$core$Instance18);
  return _createClass(TileDownload, [{
    key: "init",
    value: function init() {
      var _this45 = this;
      this.addAscent(api.core.AssessEmission.UPDATE, function (details) {
        _this45.descend(api.core.AssessEmission.UPDATE, details);
      });
      this.addAscent(api.core.AssessEmission.ADDED, function () {
        _this45.descend(api.core.AssessEmission.ADDED);
      });
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'TileDownload';
    }
  }]);
}(api.core.Instance);
var TileSelector = {
  DOWNLOAD: api.internals.ns.selector('tile--download'),
  DOWNLOAD_DETAIL: "".concat(api.internals.ns.selector('tile--download'), " ").concat(api.internals.ns.selector('tile__detail'))
};
api.tile = {
  TileSelector: TileSelector,
  TileDownload: TileDownload
};
api.internals.register(api.tile.TileSelector.DOWNLOAD, api.tile.TileDownload);
api.internals.register(api.tile.TileSelector.DOWNLOAD_DETAIL, api.core.AssessDetail);
var RangeSelector = {
  RANGE: api.internals.ns.selector('range'),
  RANGE_SM: api.internals.ns.selector('range--sm'),
  RANGE_STEP: api.internals.ns.selector('range--step'),
  RANGE_DOUBLE: api.internals.ns.selector('range--double'),
  RANGE_DOUBLE_STEP: api.internals.ns.selector('range--double') + api.internals.ns.selector('range--step'),
  RANGE_INPUT: api.internals.ns.selector('range input[type=range]:nth-of-type(1)'),
  RANGE_INPUT2: "".concat(api.internals.ns.selector('range--double'), " input[type=range]:nth-of-type(2)"),
  RANGE_OUTPUT: api.internals.ns.selector('range__output'),
  RANGE_MIN: api.internals.ns.selector('range__min'),
  RANGE_MAX: api.internals.ns.selector('range__max'),
  RANGE_PREFIX: api.internals.ns.attr('prefix'),
  RANGE_SUFFIX: api.internals.ns.attr('suffix')
};
var RangeEmission = {
  VALUE: api.internals.ns.emission('range', 'value'),
  VALUE2: api.internals.ns.emission('range', 'value2'),
  OUTPUT: api.internals.ns.emission('range', 'output'),
  CONSTRAINTS: api.internals.ns.emission('range', 'constraints'),
  MIN: api.internals.ns.emission('range', 'min'),
  MAX: api.internals.ns.emission('range', 'max'),
  STEP: api.internals.ns.emission('range', 'step'),
  PREFIX: api.internals.ns.emission('range', 'prefix'),
  SUFFIX: api.internals.ns.emission('range', 'suffix'),
  DISABLED: api.internals.ns.emission('range', 'disabled'),
  ENABLE_POINTER: api.internals.ns.emission('range', 'enable_pointer')
};
var RangeModel = /*#__PURE__*/function () {
  function RangeModel() {
    _classCallCheck(this, RangeModel);
    this._width = 0;
    this._min = 0;
    this._max = 0;
    this._value = 0;
    this._thumbSize = 24;
    this._innerWidth = 0;
    this._prefix = '';
    this._suffix = '';
    this._background = {};
  }
  return _createClass(RangeModel, [{
    key: "configure",
    value: function configure(model) {
      if (!model) return;
      this._prefix = model._prefix;
      this._suffix = model._suffix;
      this._width = model.width;
      this.setConstraints(model._constraints);
      this.value = model.value;
      this.update();
    }
  }, {
    key: "setPrefix",
    value: function setPrefix(value) {
      this._prefix = value !== null ? value : '';
    }
  }, {
    key: "setSuffix",
    value: function setSuffix(value) {
      this._suffix = value !== null ? value : '';
    }
  }, {
    key: "_decorate",
    value: function _decorate(value) {
      return "".concat(this._prefix).concat(value).concat(this._suffix);
    }
  }, {
    key: "width",
    get: function get() {
      return this._width;
    },
    set: function set(value) {
      this._width = value;
    }
  }, {
    key: "isSm",
    get: function get() {
      return this._isSm;
    },
    set: function set(value) {
      if (this._isSm === value) return;
      this._isSm = value;
      this.setThumbSize(value ? 16 : 24);
      this.update();
    }
  }, {
    key: "setThumbSize",
    value: function setThumbSize(value) {
      var mult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      this._thumbSize = value;
      this._innerPadding = value * mult;
    }
  }, {
    key: "textValue",
    get: function get() {
      return this._decorate(this._value);
    }
  }, {
    key: "value",
    get: function get() {
      return this._value;
    },
    set: function set(value) {
      this._value = value;
    }
  }, {
    key: "outputX",
    get: function get() {
      return this._outputX;
    }
  }, {
    key: "setConstraints",
    value: function setConstraints(constraints) {
      this._constraints = constraints;
      this._min = constraints.min;
      this._max = constraints.max;
      this._step = constraints.step;
      this._rangeWidth = constraints.rangeWidth;
    }
  }, {
    key: "min",
    get: function get() {
      return this._min;
    }
  }, {
    key: "textMin",
    get: function get() {
      return this._decorate(this._min);
    }
  }, {
    key: "max",
    get: function get() {
      return this._max;
    }
  }, {
    key: "textMax",
    get: function get() {
      return this._decorate(this._max);
    }
  }, {
    key: "step",
    get: function get() {
      return this._step;
    }
  }, {
    key: "output",
    get: function get() {
      return {
        text: this.textValue,
        transform: "translateX(".concat(this._translateX, "px) translateX(-").concat(this._centerPercent, "%)")
      };
    }
  }, {
    key: "_getRatio",
    value: function _getRatio(value) {
      return (value - this._min) / this._rangeWidth;
    }
  }, {
    key: "progress",
    get: function get() {
      return this._progress;
    }
  }, {
    key: "update",
    value: function update() {
      this._update();
    }
  }, {
    key: "_update",
    value: function _update() {
      this._innerWidth = this._width - this._innerPadding;
      var ratio = this._getRatio(this._value);
      this._translateX = ratio * this._width;
      this._centerPercent = ratio * 100;
      this._progress = {
        right: "".concat((this._innerWidth * ratio + this._innerPadding * 0.5).toFixed(2), "px")
      };
    }
  }]);
}();
var RangeModelStep = /*#__PURE__*/function (_RangeModel) {
  function RangeModelStep() {
    _classCallCheck(this, RangeModelStep);
    return _callSuper(this, RangeModelStep, arguments);
  }
  _inherits(RangeModelStep, _RangeModel);
  return _createClass(RangeModelStep, [{
    key: "stepWidth",
    get: function get() {
      return "".concat(this._stepWidth.toFixed(3), "px");
    }
  }, {
    key: "_update",
    value: function _update() {
      _superPropGet(RangeModelStep, "_update", this, 3)([]);
      var steps = this._rangeWidth / this._step;
      this._stepWidth = this._innerWidth / steps;
      if (this._stepWidth < 1 || !isFinite(this._stepWidth)) this._stepWidth = 4;
      while (this._stepWidth < 4) this._stepWidth *= 2;
    }
  }]);
}(RangeModel);
var RangeModelDouble = /*#__PURE__*/function (_RangeModel2) {
  function RangeModelDouble() {
    _classCallCheck(this, RangeModelDouble);
    return _callSuper(this, RangeModelDouble, arguments);
  }
  _inherits(RangeModelDouble, _RangeModel2);
  return _createClass(RangeModelDouble, [{
    key: "value2",
    get: function get() {
      return this._value;
    },
    set: function set(value) {
      if (this._value2 === value) return;
      this._value2 = value;
      this.update();
    }
  }, {
    key: "textValue",
    get: function get() {
      return "".concat(this._decorate(this._value), " - ").concat(this._decorate(this._value2));
    }
  }, {
    key: "setThumbSize",
    value: function setThumbSize(value) {
      _superPropGet(RangeModelDouble, "setThumbSize", this, 3)([value, 2]);
    }
  }, {
    key: "_update",
    value: function _update() {
      _superPropGet(RangeModelDouble, "_update", this, 3)([]);
      var ratio = this._getRatio((this._value + this._value2) * 0.5);
      this._translateX = ratio * this._width;
      this._centerPercent = ratio * 100;
      var ratio1 = this._getRatio(this._value);
      var ratio2 = this._getRatio(this._value2);
      this._progress = {
        left: "".concat((this._innerWidth * ratio1 + this._innerPadding * 0.25).toFixed(2), "px"),
        right: "".concat((this._innerWidth * ratio2 + this._innerPadding * 0.75).toFixed(2), "px")
      };
    }
  }]);
}(RangeModel);
var RangeModelDoubleStep = /*#__PURE__*/function (_RangeModelDouble) {
  function RangeModelDoubleStep() {
    _classCallCheck(this, RangeModelDoubleStep);
    return _callSuper(this, RangeModelDoubleStep, arguments);
  }
  _inherits(RangeModelDoubleStep, _RangeModelDouble);
  return _createClass(RangeModelDoubleStep, [{
    key: "stepWidth",
    get: function get() {
      return "".concat(this._stepWidth.toFixed(3), "px");
    }
  }, {
    key: "_update",
    value: function _update() {
      _superPropGet(RangeModelDoubleStep, "_update", this, 3)([]);
      var steps = this._rangeWidth / this._step;
      this._stepWidth = this._innerWidth / steps;
      if (this._stepWidth < 4) this._stepWidth *= Math.ceil(4 / this._stepWidth);
    }
  }]);
}(RangeModelDouble);
var RangeTypes = {
  STEP: 'step',
  DOUBLE: 'double',
  DOUBLE_STEP: 'double-step',
  DEFAULT: 'default'
};
var Range = /*#__PURE__*/function (_api$core$Instance19) {
  function Range() {
    _classCallCheck(this, Range);
    return _callSuper(this, Range, arguments);
  }
  _inherits(Range, _api$core$Instance19);
  return _createClass(Range, [{
    key: "init",
    value: function init() {
      this._retrieveType();
      this._retrieveSize();
      if (this.isLegacy) {
        this.isResizing = true;
        this.isMouseMoving = true;
      } else {
        this._observer = new ResizeObserver(this.resize.bind(this));
        this._observer.observe(this.node);
      }
      this.addAscent(RangeEmission.CONSTRAINTS, this.setConstraints.bind(this));
      this.addAscent(RangeEmission.VALUE, this.setValue.bind(this));
      this.addAscent(RangeEmission.VALUE2, this.setValue2.bind(this));
      if (this.getAttribute(RangeSelector.RANGE_PREFIX)) this.setPrefix(this.getAttribute(RangeSelector.RANGE_PREFIX));
      if (this.getAttribute(RangeSelector.RANGE_SUFFIX)) this.setSuffix(this.getAttribute(RangeSelector.RANGE_SUFFIX));
      this.update();
    }
  }, {
    key: "_retrieveType",
    value: function _retrieveType() {
      switch (true) {
        case this.matches(RangeSelector.RANGE_DOUBLE_STEP):
          this.type = RangeTypes.DOUBLE;
          break;
        case this.matches(RangeSelector.RANGE_DOUBLE):
          this.type = RangeTypes.DOUBLE;
          break;
        case this.matches(RangeSelector.RANGE_STEP):
          this.type = RangeTypes.STEP;
          break;
        default:
          this.type = RangeTypes.DEFAULT;
      }
    }
  }, {
    key: "type",
    get: function get() {
      return this._type;
    },
    set: function set(value) {
      if (this._type === value) return;
      this._type = value;
      var oldModel = this._model;
      switch (this._type) {
        case RangeTypes.DOUBLE_STEP:
          this._model = new RangeModelDoubleStep();
          break;
        case RangeTypes.DOUBLE:
          this._model = new RangeModelDouble();
          break;
        case RangeTypes.STEP:
          this._model = new RangeModelStep();
          break;
        default:
          this._model = new RangeModel();
      }
      this._model.configure(oldModel);
    }
  }, {
    key: "_retrieveSize",
    value: function _retrieveSize() {
      this._model.isSm = this.matches(RangeSelector.RANGE_SM);
    }
  }, {
    key: "resize",
    value: function resize() {
      this._retrieveWidth();
      this.update();
    }
  }, {
    key: "_retrieveWidth",
    value: function _retrieveWidth() {
      this._model.width = this.getRect().width;
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      this._model.value = value;
      switch (this._type) {
        case RangeTypes.DOUBLE_STEP:
        case RangeTypes.DOUBLE:
          this.descend(RangeEmission.VALUE, value);
          break;
      }
      this.update();
    }
  }, {
    key: "setValue2",
    value: function setValue2(value) {
      this._model.value2 = value;
      this.descend(RangeEmission.VALUE2, value);
      this.update();
    }
  }, {
    key: "setConstraints",
    value: function setConstraints(constraints) {
      this._model.setConstraints(constraints);
      this.update();
      this.descend(RangeEmission.CONSTRAINTS, constraints);
    }
  }, {
    key: "setPrefix",
    value: function setPrefix(value) {
      this._model.setPrefix(value);
      this.update();
    }
  }, {
    key: "setSuffix",
    value: function setSuffix(value) {
      this._model.setSuffix(value);
      this.update();
    }
  }, {
    key: "mutate",
    value: function mutate(attributesNames) {
      switch (true) {
        case attributesNames.includes('class'):
          this._retrieveType();
          this._retrieveSize();
          break;
        case attributesNames.includes(RangeSelector.RANGE_PREFIX):
        case attributesNames.includes(RangeSelector.RANGE_SUFFIX):
          this._model.setPrefix(this.getAttribute(RangeSelector.RANGE_PREFIX));
          this._model.setSuffix(this.getAttribute(RangeSelector.RANGE_SUFFIX));
          this.update();
          break;
      }
    }
  }, {
    key: "update",
    value: function update() {
      this._model.update();
      this.descend(RangeEmission.OUTPUT, this._model.output);
      this.descend(RangeEmission.MIN, this._model.textMin);
      this.descend(RangeEmission.MAX, this._model.textMax);
      var progress = this._model.progress;
      if (progress.left) {
        this.style.setProperty('--progress-left', progress.left);
      } else {
        this.style.removeProperty('--progress-left');
      }
      if (progress.right) {
        this.style.setProperty('--progress-right', progress.right);
        if (this.isLegacy) {
          if (progress.left) {
            this.style.setProperty('background-position-x', progress.left);
            this.style.setProperty('background-size', "".concat(parseFloat(progress.right) - parseFloat(progress.left), "px ").concat(this._model.isSm ? '8px' : '12px'));
          }
        }
      } else {
        this.style.removeProperty('--progress-right');
        if (this.isLegacy) {
          this.style.removeProperty('background-size');
          this.style.removeProperty('background-position-x');
        }
      }
      if (this._model.stepWidth) this.style.setProperty('--step-width', this._model.stepWidth);else this.style.removeProperty('--step-width');
    }
  }, {
    key: "mouseMove",
    value: function mouseMove(point) {
      if (this._type !== RangeTypes.DOUBLE && this._type !== RangeTypes.DOUBLE_STEP) return;
      var x = point.x - this.getRect().left;
      this.descend(RangeEmission.ENABLE_POINTER, (parseFloat(this._model.progress.right) - parseFloat(this._model.progress.left)) / 2 + parseFloat(this._model.progress.left) < x ? 2 : 1);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._observer.disconnect();
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Range';
    }
  }]);
}(api.core.Instance);
var RangeConstraints = /*#__PURE__*/function () {
  function RangeConstraints(node) {
    _classCallCheck(this, RangeConstraints);
    this._min = isNaN(node.min) ? 0 : node.min;
    this._max = isNaN(node.max) ? 100 : node.max;
    this._step = isNaN(node.step) ? 1 : node.step;
    this._rangeWidth = this._max - this._min;
  }
  return _createClass(RangeConstraints, [{
    key: "min",
    get: function get() {
      return this._min;
    }
  }, {
    key: "max",
    get: function get() {
      return this._max;
    }
  }, {
    key: "step",
    get: function get() {
      return this._step;
    }
  }, {
    key: "rangeWidth",
    get: function get() {
      return this._rangeWidth;
    }
  }, {
    key: "test",
    value: function test(min, max, step) {
      return this._min === min && this._max === max && this._step === step;
    }
  }]);
}();
var RangeInput = /*#__PURE__*/function (_api$core$Instance20) {
  function RangeInput() {
    _classCallCheck(this, RangeInput);
    return _callSuper(this, RangeInput, arguments);
  }
  _inherits(RangeInput, _api$core$Instance20);
  return _createClass(RangeInput, [{
    key: "init",
    value: function init() {
      this._init();
      this._value = parseFloat(this.node.getAttribute('value'));
      if (this.isLegacy) this.addDescent(RangeEmission.ENABLE_POINTER, this._enablePointer.bind(this));
      this.isRendering = true;
      this.change();
    }
  }, {
    key: "_init",
    value: function _init() {
      var _this46 = this;
      this._pointerId = 1;
      this.request(function () {
        if (!_this46.hasAttribute('min')) _this46.setAttribute('min', 0);
        _this46.ascend(RangeEmission.CONSTRAINTS, new RangeConstraints(_this46.node));
        _this46.ascend(RangeEmission.DISABLED, _this46.node.disabled);
      });
      this.addDescent(RangeEmission.VALUE2, this.setValue.bind(this));
    }
  }, {
    key: "proxy",
    get: function get() {
      var scope = this;
      var proxyAccessors = {
        get value() {
          return scope.value;
        },
        set value(value) {
          scope.value = value;
        }
      };
      return api.internals.property.completeAssign(_superPropGet(RangeInput, "proxy", this, 1), proxyAccessors);
    }
  }, {
    key: "_enablePointer",
    value: function _enablePointer(pointerId) {
      var isEnabled = pointerId === this._pointerId;
      if (this._isPointerEnabled === isEnabled) return;
      this._isPointerEnabled = isEnabled;
      if (isEnabled) this.style.removeProperty('pointer-events');else this.style.setProperty('pointer-events', 'none');
    }
  }, {
    key: "value",
    get: function get() {
      return parseFloat(this.node.value);
    },
    set: function set(value) {
      var parsedValue = parseFloat(value);
      if (parsedValue === this._value) return;
      this._value = parsedValue;
      this.node.value = parsedValue;
      this.dispatch('change');
      this.change();
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      if (parseFloat(this.node.value) > value) {
        this.value = value;
      }
    }
  }, {
    key: "change",
    value: function change() {
      this.ascend(RangeEmission.VALUE, this._value);
    }
  }, {
    key: "render",
    value: function render() {
      var parsedValue = parseFloat(this.node.value);
      if (parsedValue !== this._value) this.value = parsedValue;
    }
  }, {
    key: "mutate",
    value: function mutate(attributesNames) {
      if (attributesNames.includes('disabled')) this.ascend(RangeEmission.DISABLED, this.node.disabled);
      if (attributesNames.includes('min') || attributesNames.includes('max') || attributesNames.includes('step')) {
        this.ascend(RangeEmission.CONSTRAINTS, new RangeConstraints(this.node));
        this.change();
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this._listenerType) this.unlisten(this._listenerType, this._changing);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'RangeInput';
    }
  }]);
}(api.core.Instance);
var RangeInput2 = /*#__PURE__*/function (_RangeInput) {
  function RangeInput2() {
    _classCallCheck(this, RangeInput2);
    return _callSuper(this, RangeInput2, arguments);
  }
  _inherits(RangeInput2, _RangeInput);
  return _createClass(RangeInput2, [{
    key: "_init",
    value: function _init() {
      this._pointerId = 2;
      this.addDescent(RangeEmission.CONSTRAINTS, this.setConstraints.bind(this));
      this.addDescent(RangeEmission.VALUE, this.setValue.bind(this));
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      if (parseFloat(this.node.value) < value) {
        this.value = value;
      }
    }
  }, {
    key: "change",
    value: function change() {
      this.ascend(RangeEmission.VALUE2, parseFloat(this.node.value));
    }
  }, {
    key: "setConstraints",
    value: function setConstraints(constraints) {
      this.node.min = constraints.min;
      this.node.max = constraints.max;
      this.node.step = constraints.step;
      this.change();
    }
  }, {
    key: "mutate",
    value: function mutate(attributesNames) {}
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'RangeInput2';
    }
  }]);
}(RangeInput);
var RangeOutput = /*#__PURE__*/function (_api$core$Instance21) {
  function RangeOutput() {
    _classCallCheck(this, RangeOutput);
    return _callSuper(this, RangeOutput, arguments);
  }
  _inherits(RangeOutput, _api$core$Instance21);
  return _createClass(RangeOutput, [{
    key: "init",
    value: function init() {
      this.addDescent(RangeEmission.OUTPUT, this.change.bind(this));
    }
  }, {
    key: "change",
    value: function change(data) {
      this.node.innerText = data.text;
      this.node.style.transform = data.transform;
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'RangeOutput';
    }
  }]);
}(api.core.Instance);
var RangeLimit = /*#__PURE__*/function (_api$core$Instance22) {
  function RangeLimit() {
    _classCallCheck(this, RangeLimit);
    return _callSuper(this, RangeLimit, arguments);
  }
  _inherits(RangeLimit, _api$core$Instance22);
  return _createClass(RangeLimit, [{
    key: "init",
    value: function init() {
      switch (true) {
        case this.matches(RangeSelector.RANGE_MIN):
          this.addDescent(RangeEmission.MIN, this.change.bind(this));
          break;
        case this.matches(RangeSelector.RANGE_MAX):
          this.addDescent(RangeEmission.MAX, this.change.bind(this));
          break;
      }
    }
  }, {
    key: "change",
    value: function change(text) {
      this.node.innerText = text;
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'RangeLimit';
    }
  }]);
}(api.core.Instance);
api.range = {
  Range: Range,
  RangeInput: RangeInput,
  RangeInput2: RangeInput2,
  RangeOutput: RangeOutput,
  RangeLimit: RangeLimit,
  RangeEmission: RangeEmission,
  RangeSelector: RangeSelector
};
api.internals.register(api.range.RangeSelector.RANGE, api.range.Range);
api.internals.register(api.range.RangeSelector.RANGE_INPUT, api.range.RangeInput);
api.internals.register(api.range.RangeSelector.RANGE_INPUT2, api.range.RangeInput2);
api.internals.register(api.range.RangeSelector.RANGE_OUTPUT, api.range.RangeOutput);
api.internals.register(api.range.RangeSelector.RANGE_MIN, api.range.RangeLimit);
api.internals.register(api.range.RangeSelector.RANGE_MAX, api.range.RangeLimit);
var HeaderSelector = {
  HEADER: api.internals.ns.selector('header'),
  BRAND_LINK: api.internals.ns.selector('header__brand a'),
  TOOLS_LINKS: api.internals.ns.selector('header__tools-links'),
  MENU_LINKS: api.internals.ns.selector('header__menu-links'),
  BUTTONS: "".concat(api.internals.ns.selector('header__tools-links'), " ").concat(api.internals.ns.selector('btns-group'), ", ").concat(api.internals.ns.selector('header__tools-links'), " ").concat(api.internals.ns.selector('links-group')),
  MODALS: "".concat(api.internals.ns.selector('header__search')).concat(api.internals.ns.selector('modal'), ", ").concat(api.internals.ns.selector('header__menu')).concat(api.internals.ns.selector('modal'))
};
var HeaderLinks = /*#__PURE__*/function (_api$core$Instance23) {
  function HeaderLinks() {
    _classCallCheck(this, HeaderLinks);
    return _callSuper(this, HeaderLinks, arguments);
  }
  _inherits(HeaderLinks, _api$core$Instance23);
  return _createClass(HeaderLinks, [{
    key: "init",
    value: function init() {
      var header = this.queryParentSelector(HeaderSelector.HEADER);
      this.toolsLinks = header.querySelector(HeaderSelector.TOOLS_LINKS);
      this.menuLinks = header.querySelector(HeaderSelector.MENU_LINKS);
      var copySuffix = '-mobile';
      var toolsHtml = this.toolsLinks.innerHTML.replace(/  +/g, ' ');
      var menuHtml = this.menuLinks.innerHTML.replace(/  +/g, ' ');
      // Pour éviter de dupliquer des id, on ajoute un suffixe aux id et aria-controls duppliqués.
      var toolsHtmlIdList = toolsHtml.match(/id="(.*?)"/gm) || [];

      // on a besoin d'échapper les backslash dans la chaine de caractère
      // eslint-disable-next-line no-useless-escape
      toolsHtmlIdList = toolsHtmlIdList.map(function (element) {
        return element.replace('id=\"', '').replace('\"', '');
      });
      var dupplicateAttributes = ['aria-controls', 'aria-describedby', 'aria-labelledby'];
      var toolsHtmlDuplicateId = toolsHtml.replace(/id="(.*?)"/gm, "id=\"$1".concat(copySuffix, "\""));
      for (var _i7 = 0, _dupplicateAttributes = dupplicateAttributes; _i7 < _dupplicateAttributes.length; _i7++) {
        var attribute = _dupplicateAttributes[_i7];
        var toolsHtmlAttributeList = toolsHtml.match(new RegExp("".concat(attribute, "=\"(.*?)\""), 'gm'));
        if (toolsHtmlAttributeList) {
          var _iterator31 = _createForOfIteratorHelper(toolsHtmlAttributeList),
            _step31;
          try {
            for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
              var element = _step31.value;
              var attributeValue = element.replace("".concat(attribute, "=\""), '').replace('"', '');
              if (toolsHtmlIdList.includes(attributeValue)) {
                toolsHtmlDuplicateId = toolsHtmlDuplicateId.replace("".concat(attribute, "=\"").concat(attributeValue, "\""), "".concat(attribute, "=\"").concat(attributeValue + copySuffix, "\""));
              }
            }
          } catch (err) {
            _iterator31.e(err);
          } finally {
            _iterator31.f();
          }
        }
      }
      if (toolsHtmlDuplicateId === menuHtml) return;
      switch (api.mode) {
        case api.Modes.ANGULAR:
        case api.Modes.REACT:
        case api.Modes.VUE:
          this.warn("header__tools-links content is different from header__menu-links content.\nAs you're using a dynamic framework, you should handle duplication of this content yourself, please refer to documentation:\n".concat(api.header.doc));
          break;
        default:
          this.menuLinks.innerHTML = toolsHtmlDuplicateId;
      }
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'HeaderLinks';
    }
  }]);
}(api.core.Instance);
var HeaderModal = /*#__PURE__*/function (_api$core$Instance24) {
  function HeaderModal() {
    _classCallCheck(this, HeaderModal);
    return _callSuper(this, HeaderModal, arguments);
  }
  _inherits(HeaderModal, _api$core$Instance24);
  return _createClass(HeaderModal, [{
    key: "init",
    value: function init() {
      this.storeAria();
      this.isResizing = true;
    }
  }, {
    key: "resize",
    value: function resize() {
      if (this.isBreakpoint(api.core.Breakpoints.LG)) this.deactivateModal();else this.activateModal();
    }
  }, {
    key: "activateModal",
    value: function activateModal() {
      var modal = this.element.getInstance('Modal');
      if (!modal) {
        this.request(this.activateModal.bind(this));
        return;
      }
      this.restoreAria();
      modal.isActive = true;
      this.listenClick({
        capture: true
      });
    }
  }, {
    key: "deactivateModal",
    value: function deactivateModal() {
      var modal = this.element.getInstance('Modal');
      if (!modal) {
        this.request(this.deactivateModal.bind(this));
        return;
      }
      modal.conceal();
      modal.isActive = false;
      this.storeAria();
      this.unlistenClick({
        capture: true
      });
    }
  }, {
    key: "storeAria",
    value: function storeAria() {
      if (this.hasAttribute('aria-labelledby')) this._ariaLabelledby = this.getAttribute('aria-labelledby');
      if (this.hasAttribute('aria-label')) this._ariaLabel = this.getAttribute('aria-label');
      this.removeAttribute('aria-labelledby');
      this.removeAttribute('aria-label');
    }
  }, {
    key: "restoreAria",
    value: function restoreAria() {
      if (this._ariaLabelledby) this.setAttribute('aria-labelledby', this._ariaLabelledby);
      if (this._ariaLabel) this.setAttribute('aria-label', this._ariaLabel);
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      if (e.target.matches('a, button') && !e.target.matches('[aria-controls]') && !e.target.matches(api.core.DisclosureSelector.PREVENT_CONCEAL)) {
        var modal = this.element.getInstance('Modal');
        modal.conceal();
      }
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'HeaderModal';
    }
  }]);
}(api.core.Instance);
api.header = {
  HeaderLinks: HeaderLinks,
  HeaderModal: HeaderModal,
  HeaderSelector: HeaderSelector,
  doc: 'https://www.systeme-de-design.gouv.fr/version-courante/fr/composants/en-tete'
};
api.internals.register(api.header.HeaderSelector.TOOLS_LINKS, api.header.HeaderLinks);
api.internals.register(api.header.HeaderSelector.MODALS, api.header.HeaderModal);
var DisplaySelector = {
  DISPLAY: api.internals.ns.selector('display'),
  RADIO_BUTTONS: "input[name=\"".concat(api.internals.ns('radios-theme'), "\"]"),
  FIELDSET: api.internals.ns.selector('fieldset')
};
var Display = /*#__PURE__*/function (_api$core$Instance25) {
  function Display() {
    _classCallCheck(this, Display);
    return _callSuper(this, Display, arguments);
  }
  _inherits(Display, _api$core$Instance25);
  return _createClass(Display, [{
    key: "init",
    value: function init() {
      this.radios = this.querySelectorAll(DisplaySelector.RADIO_BUTTONS);
      if (api.scheme) {
        this.changing = this.change.bind(this);
        var _iterator32 = _createForOfIteratorHelper(this.radios),
          _step32;
        try {
          for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
            var radio = _step32.value;
            radio.addEventListener('change', this.changing);
          }
        } catch (err) {
          _iterator32.e(err);
        } finally {
          _iterator32.f();
        }
        this.addDescent(api.scheme.SchemeEmission.SCHEME, this.apply.bind(this));
        this.ascend(api.scheme.SchemeEmission.ASK);
      } else {
        this.querySelector(DisplaySelector.FIELDSET).setAttribute('disabled', '');
      }
    }
  }, {
    key: "scheme",
    get: function get() {
      return this._scheme;
    },
    set: function set(value) {
      if (this._scheme === value || !api.scheme) return;
      switch (value) {
        case api.scheme.SchemeValue.SYSTEM:
        case api.scheme.SchemeValue.LIGHT:
        case api.scheme.SchemeValue.DARK:
          this._scheme = value;
          var _iterator33 = _createForOfIteratorHelper(this.radios),
            _step33;
          try {
            for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
              var radio = _step33.value;
              radio.checked = radio.value === value;
            }
          } catch (err) {
            _iterator33.e(err);
          } finally {
            _iterator33.f();
          }
          this.ascend(api.scheme.SchemeEmission.SCHEME, value);
          break;
      }
    }
  }, {
    key: "change",
    value: function change() {
      var _iterator34 = _createForOfIteratorHelper(this.radios),
        _step34;
      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var radio = _step34.value;
          if (radio.checked) {
            this.scheme = radio.value;
            return;
          }
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
    }
  }, {
    key: "apply",
    value: function apply(value) {
      this.scheme = value;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var _iterator35 = _createForOfIteratorHelper(this.radios),
        _step35;
      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var radio = _step35.value;
          radio.removeEventListener('change', this.changing);
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Display';
    }
  }]);
}(api.core.Instance);
api.display = {
  Display: Display,
  DisplaySelector: DisplaySelector
};
api.internals.register(api.display.DisplaySelector.DISPLAY, api.display.Display);
var TableEmission = {
  SCROLLABLE: api.internals.ns.emission('table', 'scrollable'),
  CHANGE: api.internals.ns.emission('table', 'change'),
  CAPTION_HEIGHT: api.internals.ns.emission('table', 'captionheight'),
  CAPTION_WIDTH: api.internals.ns.emission('table', 'captionwidth')
};
var Table = /*#__PURE__*/function (_api$core$Instance26) {
  function Table() {
    _classCallCheck(this, Table);
    return _callSuper(this, Table, arguments);
  }
  _inherits(Table, _api$core$Instance26);
  return _createClass(Table, [{
    key: "init",
    value: function init() {
      this.addAscent(TableEmission.CAPTION_HEIGHT, this.setCaptionHeight.bind(this));
    }
  }, {
    key: "setCaptionHeight",
    value: function setCaptionHeight(value) {
      this.setProperty('--table-offset', value);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'Table';
    }
  }]);
}(api.core.Instance);
var TableWrapper = /*#__PURE__*/function (_api$core$Instance27) {
  function TableWrapper() {
    _classCallCheck(this, TableWrapper);
    return _callSuper(this, TableWrapper, arguments);
  }
  _inherits(TableWrapper, _api$core$Instance27);
  return _createClass(TableWrapper, [{
    key: "init",
    value: function init() {
      this.addAscent(TableEmission.CAPTION_HEIGHT, this.setCaptionHeight.bind(this));
    }
  }, {
    key: "setCaptionHeight",
    value: function setCaptionHeight(value) {
      var _this47 = this;
      requestAnimationFrame(function () {
        return _this47.ascend(TableEmission.CAPTION_HEIGHT, 0);
      });
      this.setProperty('--table-offset', value);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'TableWrapper';
    }
  }]);
}(api.core.Instance);
var TableSelector = {
  TABLE: api.internals.ns.selector('table'),
  TABLE_WRAPPER: ["".concat(api.internals.ns.selector('table'), " ").concat(api.internals.ns.selector('table__wrapper'))],
  SHADOW: api.internals.ns.selector('table__shadow'),
  SHADOW_LEFT: api.internals.ns.selector('table__shadow--left'),
  SHADOW_RIGHT: api.internals.ns.selector('table__shadow--right'),
  ELEMENT: ["".concat(api.internals.ns.selector('table'), ":not(").concat(api.internals.ns.selector('table--no-scroll'), ") table")],
  CAPTION: "".concat(api.internals.ns.selector('table'), " table caption"),
  ROW: "".concat(api.internals.ns.selector('table'), " tbody tr"),
  COL: "".concat(api.internals.ns.selector('table'), " thead th")
};
var SCROLL_OFFSET = 0; // valeur en px du scroll avant laquelle le shadow s'active ou se desactive
var TableElement = /*#__PURE__*/function (_api$core$Instance28) {
  function TableElement() {
    _classCallCheck(this, TableElement);
    return _callSuper(this, TableElement, arguments);
  }
  _inherits(TableElement, _api$core$Instance28);
  return _createClass(TableElement, [{
    key: "init",
    value: function init() {
      this.listen('scroll', this.scroll.bind(this));
      this.content = this.querySelector('tbody');
      this.tableOffsetHeight = 0;
      this.isResizing = true;
    }
  }, {
    key: "isScrolling",
    get: function get() {
      return this._isScrolling;
    },
    set: function set(value) {
      if (this._isScrolling === value) return;
      this._isScrolling = value;
      if (value) {
        this.addClass(TableSelector.SHADOW);
        this.scroll();
      } else {
        this.removeClass(TableSelector.SHADOW);
        this.removeClass(TableSelector.SHADOW_LEFT);
        this.removeClass(TableSelector.SHADOW_RIGHT);
      }
    }

    /* ajoute la classe fr-table__shadow-left ou fr-table__shadow-right sur fr-table en fonction d'une valeur de scroll et du sens (right, left) */
  }, {
    key: "scroll",
    value: function scroll() {
      var isMin = this.node.scrollLeft <= SCROLL_OFFSET;
      var max = this.content.offsetWidth - this.node.offsetWidth - SCROLL_OFFSET;
      var isMax = Math.abs(this.node.scrollLeft) >= max;
      var isRtl = document.documentElement.getAttribute('dir') === 'rtl';
      var minSelector = isRtl ? TableSelector.SHADOW_RIGHT : TableSelector.SHADOW_LEFT;
      var maxSelector = isRtl ? TableSelector.SHADOW_LEFT : TableSelector.SHADOW_RIGHT;
      if (isMin) {
        this.removeClass(minSelector);
      } else {
        this.addClass(minSelector);
      }
      if (isMax) {
        this.removeClass(maxSelector);
      } else {
        this.addClass(maxSelector);
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      this.isScrolling = this.content.offsetWidth > this.node.offsetWidth;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.isScrolling = false;
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'TableElement';
    }
  }]);
}(api.core.Instance);
var PADDING = '1rem'; // padding de 4v sur le caption
var TableCaption = /*#__PURE__*/function (_api$core$Instance29) {
  function TableCaption() {
    _classCallCheck(this, TableCaption);
    return _callSuper(this, TableCaption, arguments);
  }
  _inherits(TableCaption, _api$core$Instance29);
  return _createClass(TableCaption, [{
    key: "init",
    value: function init() {
      this.height = 0;
      this.isResizing = true;
    }
  }, {
    key: "resize",
    value: function resize() {
      var height = this.getRect().height;
      if (this.height === height) return;
      this.height = height;
      this.ascend(TableEmission.CAPTION_HEIGHT, "calc(".concat(height, "px + ").concat(PADDING, ")"));
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'TableCaption';
    }
  }]);
}(api.core.Instance);
var TableRow = /*#__PURE__*/function (_api$core$Instance30) {
  function TableRow() {
    _classCallCheck(this, TableRow);
    return _callSuper(this, TableRow, arguments);
  }
  _inherits(TableRow, _api$core$Instance30);
  return _createClass(TableRow, [{
    key: "init",
    value: function init() {
      if (api.checkbox) {
        this.addAscent(CheckboxEmission.CHANGE, this._handleCheckboxChange.bind(this));
        this.descend(CheckboxEmission.RETRIEVE);
      }
    }
  }, {
    key: "_handleCheckboxChange",
    value: function _handleCheckboxChange(node) {
      if (node.name === 'row-select' || node.getAttribute(api.internals.ns.attr('row-select')) === 'true') {
        this.isSelected = node.checked === true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var height = this.getRect().height + 2;
      if (this._height === height) return;
      this._height = height;
      this.setProperty('--row-height', "".concat(this._height, "px"));
    }
  }, {
    key: "isSelected",
    get: function get() {
      return this._isSelected;
    },
    set: function set(value) {
      if (this._isSelected === value) return;
      this.isRendering = value;
      this._isSelected = value;
      this.setAttribute('aria-selected', value);
    }
  }], [{
    key: "instanceClassName",
    get: function get() {
      return 'TableRow';
    }
  }]);
}(api.core.Instance);
api.table = {
  Table: Table,
  TableWrapper: TableWrapper,
  TableElement: TableElement,
  TableCaption: TableCaption,
  TableSelector: TableSelector,
  TableRow: TableRow
};
api.internals.register(api.table.TableSelector.TABLE, api.table.Table);
api.internals.register(api.table.TableSelector.TABLE_WRAPPER, api.table.TableWrapper);
api.internals.register(api.table.TableSelector.ELEMENT, api.table.TableElement);
api.internals.register(api.table.TableSelector.CAPTION, api.table.TableCaption);
api.internals.register(api.table.TableSelector.ROW, api.table.TableRow);